import Papa from 'papaparse';
import PropTypes from 'prop-types';
import ReactTable from 'react-table-6';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Switch from '@mui/material/Switch';
import Apexcharts from 'react-apexcharts';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@mui/material/TextField';
import { useHistory } from 'react-router-dom';
import { Link, useParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import { useDispatch, useSelector } from 'react-redux';
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import CircleCheckedFilled from '@material-ui/icons/CheckCircle';
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import { Menu, MenuItem, Checkbox, ListItemIcon, ListItemText } from "@mui/material";
import { Modal, ModalBody, ModalHeader, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, } from 'reactstrap';


import { toast } from "react-toastify";
import WorkspaceHeader from '../../components/workspaceHeader';
import { getSingleTask, getAllEmailCampaign } from '../../store/Campaign';


const initialCreate = {
  name: '',
  phoneNumber: [],
  assistantId: '',
  intervalTime: '',
  callsInterval: '',
  createdBy: localStorage.getItem('userId') || '',
};

// Dropdown options
const optionsAccountEmails = [
  { value: "abdul@softtik.online", label: "abdul@softtik.online", },
  { value: "ammara@softtik.click", label: "ammara@softtik.click", },
  { value: "ammara@softtik.ink", label: "ammara@softtik.ink", },
  { value: "ammara@softtik.online", label: "ammara@softtik.online", },
  { value: "ayesha@softtik.click", label: "ayesha@softtik.click", },
  { value: "ayesha@softtik.ink", label: "ayesha@softtik.ink", },
  { value: "ammara@softtik.click", label: "ammara@softtik.click", },
];

const optionsOwners = [
  { value: "MuhammadMousa", label: "Muhammad Mousa", },
  { value: "MuhammadMousa", label: "Muhammad Mousa", },
  { value: "WaqarUDDin", label: "Waqar UD Din", },
];

const optionsTags = [
  { value: "SalesAICampaign", label: "Sales AI Campaign", },
  { value: "SalesAICampaign", label: "Sales AI Campaign", },
  { value: "SalesAICampaign", label: "Sales AI Campaign", },
  { value: "SalesAICampaign", label: "Sales AI Campaign", },
];

const optionsTime = [
  { value: "01", label: "1", },
  { value: "02", label: "2", },
  { value: "03", label: "3", },
  { value: "04", label: "4", },
  { value: "05", label: "5", },
  { value: "06", label: "6", },
  { value: "07", label: "7", },
  { value: "08", label: "8", },
  { value: "08", label: "8", },
  { value: "09", label: "9", },
  { value: "10", label: "10", },
];

const optionsRate = [
  { value: "ReplyRate", label: "Reply Rate", },
  { value: "ClickRate", label: "Click Rate", },
  { value: "OpenRate", label: "Open Rate", },
];

// Dropdown options
const optionsFromTime = [
  { value: "00:30AM", label: "0:30 AM", },
  { value: "1:00AM", label: "1:00 AM", },
  { value: "1:30AM", label: "1:30 AM", },
  { value: "2:00AM", label: "2:00 AM", },
  { value: "2:30AM", label: "2:30 AM", },
  { value: "3:00AM", label: "3:00 AM", },
  { value: "4:00AM", label: "4:00 AM", },
  { value: "4:30AM", label: "4:30 AM", },
  { value: "5:00AM", label: "5:00 AM", },
  { value: "5:30AM", label: "5:30 AM", },
  { value: "6:00AM", label: "6:00 AM", },
  { value: "6:30AM", label: "6:30 AM", },
  { value: "7:00AM", label: "7:00 AM", },
  { value: "7:30AM", label: "7:00 AM", },
  { value: "8:00AM", label: "8:30 AM", },
  { value: "8:30AM", label: "8:00 AM", },
  { value: "9:00AM", label: "9:30 AM", },
  { value: "9:30AM", label: "9:00 AM", },
  { value: "10:00AM", label: "10:30 AM", },
  { value: "11:30AM", label: "10:00 AM", },
  { value: "0:00PM", label: "1:00 AM", },
  { value: "0:30PM", label: "0:30 PM", },
  { value: "1:00PM", label: "1:00 PM", },
  { value: "1:30PM", label: "1:30 PM", },
  { value: "2:00PM", label: "2:00 PM", },
  { value: "2:30PM", label: "2:30 PM", },
  { value: "3:00PM", label: "3:00 PM", },
  { value: "4:00PM", label: "1:00 PM", },
  { value: "4:30PM", label: "1:30 PM", },
  { value: "5:00PM", label: "2:00 PM", },
  { value: "5:30PM", label: "2:30 PM", },
  { value: "6:00PM", label: "3:00 PM", },
  { value: "6:30PM", label: "2:30 PM", },
  { value: "7:00PM", label: "3:00 PM", },
  { value: "7:30PM", label: "1:00 PM", },
  { value: "8:00PM", label: "1:30 PM", },
  { value: "8:30PM", label: "2:00 PM", },
  { value: "9:00PM", label: "2:30 PM", },
  { value: "9:30PM", label: "3:00 PM", },
  { value: "10:00PM", label: "2:30 PM", },
  { value: "11:30PM", label: "3:00 PM", },
  { value: "12:00PM", label: "1:00 PM", },
];

// Dropdown options
const optionsToTime = [
  { value: "00:30AM", label: "0:30 AM", },
  { value: "1:00AM", label: "1:00 AM", },
  { value: "1:30AM", label: "1:30 AM", },
  { value: "2:00AM", label: "2:00 AM", },
  { value: "2:30AM", label: "2:30 AM", },
  { value: "3:00AM", label: "3:00 AM", },
  { value: "4:00AM", label: "4:00 AM", },
  { value: "4:30AM", label: "4:30 AM", },
  { value: "5:00AM", label: "5:00 AM", },
  { value: "5:30AM", label: "5:30 AM", },
  { value: "6:00AM", label: "6:00 AM", },
  { value: "6:30AM", label: "6:30 AM", },
  { value: "7:00AM", label: "7:00 AM", },
  { value: "7:30AM", label: "7:00 AM", },
  { value: "8:00AM", label: "8:30 AM", },
  { value: "8:30AM", label: "8:00 AM", },
  { value: "9:00AM", label: "9:30 AM", },
  { value: "9:30AM", label: "9:00 AM", },
  { value: "10:00AM", label: "10:30 AM", },
  { value: "11:30AM", label: "10:00 AM", },
  { value: "0:00PM", label: "1:00 AM", },
  { value: "0:30PM", label: "0:30 PM", },
  { value: "1:00PM", label: "1:00 PM", },
  { value: "1:30PM", label: "1:30 PM", },
  { value: "2:00PM", label: "2:00 PM", },
  { value: "2:30PM", label: "2:30 PM", },
  { value: "3:00PM", label: "3:00 PM", },
  { value: "4:00PM", label: "1:00 PM", },
  { value: "4:30PM", label: "1:30 PM", },
  { value: "5:00PM", label: "2:00 PM", },
  { value: "5:30PM", label: "2:30 PM", },
  { value: "6:00PM", label: "3:00 PM", },
  { value: "6:30PM", label: "2:30 PM", },
  { value: "7:00PM", label: "3:00 PM", },
  { value: "7:30PM", label: "1:00 PM", },
  { value: "8:00PM", label: "1:30 PM", },
  { value: "8:30PM", label: "2:00 PM", },
  { value: "9:00PM", label: "2:30 PM", },
  { value: "9:30PM", label: "3:00 PM", },
  { value: "10:00PM", label: "2:30 PM", },
  { value: "11:30PM", label: "3:00 PM", },
  { value: "12:00PM", label: "1:00 PM", },
];

// Dropdown options
const optionsTimezone = [
  { value: "EasternTime", label: "Eastern Time (US & Canada)", },
  { value: "Indian", label: "Indian (East) (UTC-05:00)", },
  { value: "Caracas", label: "Caracas (UTC-04:30)", },
  { value: "AtlanticTime", label: "Atlantic Time (Canada) (UTC-04:00)", },
  { value: "Cuiaba (UTC-04:00)", label: "Cuiaba (UTC-04:00)", },
];
// Dropdown options
const optionsCampaign = [
  { value: "realestate", label: "Real Estate | US | Jan 24, 2025" },
  { value: "ecom", label: "eCom | US | Jan 23, 2025" },
  { value: "realestate", label: "Real Estate | US | Jan 24, 2025" },
  { value: "ecom", label: "eCom | US | Jan 23, 2025" },
  { value: "realestate", label: "Real Estate | US | Jan 24, 2025" },
  { value: "ecom", label: "eCom | US | Jan 23, 2025" },
];

// Dropdown options
const optionscontacts = [
  { value: "Allstatues", label: "All statues", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "Replyreceived", label: "Reply received", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6.75H12M6 9.75H10.5M8.2425 14.4045L6 15.75V13.5H4.5C3.90326 13.5 3.33097 13.2629 2.90901 12.841C2.48705 12.419 2.25 11.8467 2.25 11.25V5.25C2.25 4.65326 2.48705 4.08097 2.90901 3.65901C3.33097 3.23705 3.90326 3 4.5 3H13.5C14.0967 3 14.669 3.23705 15.091 3.65901C15.5129 4.08097 15.75 4.65326 15.75 5.25V9.75M11.25 14.25L12.75 15.75L15.75 12.75" stroke="#2ECA8B" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "Linkclicked", label: "Link clicked", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 9.74997C7.82209 10.1806 8.23302 10.5369 8.70491 10.7947C9.17681 11.0525 9.69863 11.2058 10.235 11.2442C10.7713 11.2826 11.3097 11.2052 11.8135 11.0173C12.3173 10.8294 12.7748 10.5353 13.155 10.155L15.405 7.90497C16.0881 7.19772 16.4661 6.25046 16.4575 5.26722C16.449 4.28398 16.0546 3.34343 15.3593 2.64815C14.664 1.95287 13.7235 1.55849 12.7403 1.54995C11.757 1.5414 10.8098 1.91938 10.1025 2.60247L8.8125 3.88497" stroke="var(--sa-dark-accent-light)" stroke-linecap="round" stroke-linejoin="round" /><path d="M10.5001 8.24992C10.1781 7.81933 9.76713 7.46304 9.29524 7.20522C8.82334 6.9474 8.30152 6.79409 7.76516 6.75567C7.2288 6.71726 6.69046 6.79465 6.18664 6.98259C5.68282 7.17053 5.22531 7.46462 4.84515 7.84492L2.59515 10.0949C1.91206 10.8022 1.53408 11.7494 1.54262 12.7327C1.55117 13.7159 1.94555 14.6565 2.64083 15.3517C3.33611 16.047 4.27666 16.4414 5.2599 16.45C6.24313 16.4585 7.19039 16.0805 7.89765 15.3974L9.18015 14.1149" stroke="var(--sa-dark-accent-light)" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "CompletedNoreply", label: "Completed, No reply", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6.75H12M6 9.75H10.5M8.2425 14.4045L6 15.75V13.5H4.5C3.90326 13.5 3.33097 13.2629 2.90901 12.841C2.48705 12.419 2.25 11.8467 2.25 11.25V5.25C2.25 4.65326 2.48705 4.08097 2.90901 3.65901C3.33097 3.23705 3.90326 3 4.5 3H13.5C14.0967 3 14.669 3.23705 15.091 3.65901C15.5129 4.08097 15.75 4.65326 15.75 5.25V9.75M11.25 14.25L12.75 15.75L15.75 12.75" stroke="#FF9F00" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "EmailopenedNoreply", label: "Email opened, No reply", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9 6.3C16.275 6.585 16.5 7.0275 16.5 7.5V15C16.5 15.3978 16.342 15.7794 16.0607 16.0607C15.7794 16.342 15.3978 16.5 15 16.5H3C2.60218 16.5 2.22064 16.342 1.93934 16.0607C1.65804 15.7794 1.5 15.3978 1.5 15V7.5C1.5 7.26713 1.55422 7.03746 1.65836 6.82918C1.7625 6.6209 1.91371 6.43972 2.1 6.3L8.1 1.8C8.35964 1.60527 8.67544 1.5 9 1.5C9.32456 1.5 9.64036 1.60527 9.9 1.8L15.9 6.3Z" stroke="#FF9F00" stroke-linecap="round" stroke-linejoin="round" /><path d="M16.5 7.5L9.7725 11.775C9.54095 11.9201 9.27324 11.997 9 11.997C8.72676 11.997 8.45905 11.9201 8.2275 11.775L1.5 7.5" stroke="#FF9F00" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "Noemailsopened", label: "No emails opened", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 3H15C15.825 3 16.5 3.675 16.5 4.5V13.5C16.5 14.325 15.825 15 15 15H3C2.175 15 1.5 14.325 1.5 13.5V4.5C1.5 3.675 2.175 3 3 3Z" stroke="#FF9F00" stroke-linecap="round" stroke-linejoin="round" /><path d="M16.5 4.5L9 9.75L1.5 4.5" stroke="#FF9F00" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "Unsubscribed", label: "Unsubscribed", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.96568 3.88921C7.18535 3.13993 6.13933 2.73133 5.05774 2.75328C3.97614 2.77524 2.94757 3.22595 2.19829 4.00628C1.44902 4.78661 1.04041 5.83263 1.06236 6.91422C1.08432 7.99581 1.53504 9.02439 2.31536 9.77366L8.59919 16.1482C8.65153 16.2013 8.71392 16.2436 8.78273 16.2724C8.85153 16.3012 8.92538 16.316 8.99997 16.316C9.07457 16.316 9.14841 16.3012 9.21722 16.2724C9.28603 16.2436 9.34841 16.2013 9.40075 16.1482L15.6797 9.77366C16.4452 9.00909 16.8756 7.97175 16.8762 6.88982C16.8769 5.8079 16.4477 4.77003 15.6832 4.00452C14.9186 3.23902 13.8813 2.8086 12.7993 2.80794C11.7174 2.80728 10.6795 3.23644 9.91404 4.00101L8.19841 5.6182L10.0547 7.47585C10.107 7.52809 10.1484 7.59013 10.1768 7.65842C10.2051 7.7267 10.2196 7.7999 10.2196 7.87382C10.2196 7.94774 10.2051 8.02094 10.1768 8.08922C10.1484 8.15751 10.107 8.21955 10.0547 8.27179L8.5999 9.72655C8.54759 9.77877 8.48551 9.82017 8.4172 9.8484C8.34889 9.87662 8.27569 9.89111 8.20178 9.89105C8.12787 9.89098 8.0547 9.87636 7.98644 9.84801C7.91818 9.81967 7.85617 9.77816 7.80396 9.72585C7.75174 9.67354 7.71034 9.61146 7.68212 9.54315C7.65389 9.47485 7.6394 9.40165 7.63947 9.32774C7.63953 9.25383 7.65415 9.18065 7.6825 9.1124C7.71084 9.04414 7.75235 8.98213 7.80466 8.92991L8.85935 7.87523L6.99607 6.00632C6.94251 5.9528 6.9003 5.88903 6.87198 5.81881C6.84366 5.74859 6.82981 5.67338 6.83125 5.59768C6.8327 5.52198 6.84941 5.44735 6.88039 5.37826C6.91137 5.30917 6.95597 5.24705 7.01154 5.19562L7.96427 4.29702C7.99193 4.27075 8.01395 4.23912 8.029 4.20407C8.04405 4.16901 8.05181 4.13127 8.05181 4.09312C8.05181 4.05497 8.04405 4.01722 8.029 3.98217C8.01395 3.94711 7.99193 3.91549 7.96427 3.88921H7.96568Z" fill="#FF0000" /></svg></> },
  { value: "Bounced", label: "Bounced", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6.75C5.80109 6.75 5.61032 6.82902 5.46967 6.96967C5.32902 7.11032 5.25 7.30109 5.25 7.5C5.25 7.69891 5.32902 7.88968 5.46967 8.03033C5.61032 8.17098 5.80109 8.25 6 8.25H6.75C6.94891 8.25 7.13968 8.17098 7.28033 8.03033C7.42098 7.88968 7.5 7.69891 7.5 7.5C7.5 7.30109 7.42098 7.11032 7.28033 6.96967C7.13968 6.82902 6.94891 6.75 6.75 6.75H6ZM11.25 6.75C11.0511 6.75 10.8603 6.82902 10.7197 6.96967C10.579 7.11032 10.5 7.30109 10.5 7.5C10.5 7.69891 10.579 7.88968 10.7197 8.03033C10.8603 8.17098 11.0511 8.25 11.25 8.25H12C12.1989 8.25 12.3897 8.17098 12.5303 8.03033C12.671 7.88968 12.75 7.69891 12.75 7.5C12.75 7.30109 12.671 7.11032 12.5303 6.96967C12.3897 6.82902 12.1989 6.75 12 6.75H11.25ZM6.75 11.25C6.55109 11.25 6.36032 11.329 6.21967 11.4697C6.07902 11.6103 6 11.8011 6 12C6 12.1989 6.07902 12.3897 6.21967 12.5303C6.36032 12.671 6.55109 12.75 6.75 12.75H11.25C11.4489 12.75 11.6397 12.671 11.7803 12.5303C11.921 12.3897 12 12.1989 12 12C12 11.8011 11.921 11.6103 11.7803 11.4697C11.6397 11.329 11.4489 11.25 11.25 11.25H6.75Z" fill="#E43F52" /><path fill-rule="evenodd" clip-rule="evenodd" d="M9 16.5C13.1423 16.5 16.5 13.1423 16.5 9C16.5 4.85775 13.1423 1.5 9 1.5C4.85775 1.5 1.5 4.85775 1.5 9C1.5 13.1423 4.85775 16.5 9 16.5ZM9 15C10.5913 15 12.1174 14.3679 13.2426 13.2426C14.3679 12.1174 15 10.5913 15 9C15 7.4087 14.3679 5.88258 13.2426 4.75736C12.1174 3.63214 10.5913 3 9 3C7.4087 3 5.88258 3.63214 4.75736 4.75736C3.63214 5.88258 3 7.4087 3 9C3 10.5913 3.63214 12.1174 4.75736 13.2426C5.88258 14.3679 7.4087 15 9 15Z" fill="#E43F52" /></svg></> },
  { value: "Skipped", label: "Skipped", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_389_13649)"><path d="M9 16.875C6.91142 16.875 4.90838 16.0453 3.43153 14.5685C1.95468 13.0916 1.125 11.0886 1.125 9C1.125 6.91142 1.95468 4.90838 3.43153 3.43153C4.90838 1.95468 6.91142 1.125 9 1.125C11.0886 1.125 13.0916 1.95468 14.5685 3.43153C16.0453 4.90838 16.875 6.91142 16.875 9C16.875 11.0886 16.0453 13.0916 14.5685 14.5685C13.0916 16.0453 11.0886 16.875 9 16.875ZM9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18Z" fill="#F76815" /><path d="M7.05488 5.68692C7.14688 5.63954 7.25018 5.61847 7.35339 5.62601C7.4566 5.63355 7.55573 5.66942 7.63988 5.72967L10.6875 7.90655V6.18755C10.6875 6.03836 10.7468 5.89529 10.8523 5.7898C10.9577 5.68431 11.1008 5.62505 11.25 5.62505C11.3992 5.62505 11.5423 5.68431 11.6477 5.7898C11.7532 5.89529 11.8125 6.03836 11.8125 6.18755V11.8125C11.8125 11.9617 11.7532 12.1048 11.6477 12.2103C11.5423 12.3158 11.3992 12.375 11.25 12.375C11.1008 12.375 10.9577 12.3158 10.8523 12.2103C10.7468 12.1048 10.6875 11.9617 10.6875 11.8125V10.0935L7.63875 12.2704C7.55464 12.3303 7.45567 12.3659 7.35269 12.3733C7.2497 12.3806 7.14667 12.3595 7.05488 12.3122C6.9631 12.265 6.8861 12.1933 6.83232 12.1052C6.77854 12.017 6.75006 11.9158 6.75 11.8125V6.18755C6.74989 6.08414 6.77829 5.9827 6.83208 5.89438C6.88586 5.80606 6.96295 5.73428 7.05488 5.68692Z" fill="#F76815" /></g><defs><clipPath id="clip0_389_13649"><rect width="18" height="18" fill="white" /></clipPath></defs></svg></> },
  { value: "Contacted", label: "Contacted", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.25005 4.50007H10.5L12.9675 2.02507C13.0373 1.95478 13.1202 1.89898 13.2116 1.8609C13.303 1.82283 13.401 1.80322 13.5 1.80322C13.5991 1.80322 13.6971 1.82283 13.7885 1.8609C13.8799 1.89898 13.9628 1.95478 14.0325 2.02507L15.9675 3.96757C16.1072 4.10809 16.1856 4.29818 16.1856 4.49632C16.1856 4.69446 16.1072 4.88455 15.9675 5.02507L14.25 6.75007H8.25005V8.25007C8.25005 8.44898 8.17103 8.63975 8.03038 8.7804C7.88973 8.92105 7.69896 9.00007 7.50005 9.00007C7.30114 9.00007 7.11037 8.92105 6.96972 8.7804C6.82907 8.63975 6.75005 8.44898 6.75005 8.25007V6.00007C6.75005 5.60225 6.90808 5.22072 7.18939 4.93941C7.47069 4.65811 7.85222 4.50007 8.25005 4.50007ZM3.75005 8.25007V11.2501L2.03255 12.9676C1.89286 13.1081 1.81445 13.2982 1.81445 13.4963C1.81445 13.6945 1.89286 13.8846 2.03255 14.0251L3.96755 15.9676C4.03727 16.0379 4.12022 16.0937 4.21162 16.1317C4.30301 16.1698 4.40104 16.1894 4.50005 16.1894C4.59906 16.1894 4.69709 16.1698 4.78848 16.1317C4.87987 16.0937 4.96283 16.0379 5.03255 15.9676L8.25005 12.7501H11.25C11.449 12.7501 11.6397 12.6711 11.7804 12.5304C11.921 12.3897 12 12.199 12 12.0001V11.2501H12.75C12.949 11.2501 13.1397 11.1711 13.2804 11.0304C13.421 10.8897 13.5 10.699 13.5 10.5001V9.75007H14.25C14.449 9.75007 14.6397 9.67105 14.7804 9.5304C14.921 9.38975 15 9.19898 15 9.00007V8.25007H9.75005V9.00007C9.75005 9.3979 9.59201 9.77943 9.31071 10.0607C9.0294 10.342 8.64787 10.5001 8.25005 10.5001H6.75005C6.35222 10.5001 5.97069 10.342 5.68939 10.0607C5.40808 9.77943 5.25005 9.3979 5.25005 9.00007V6.75007L3.75005 8.25007Z" fill="var(--sa-dark-accent-light)" /></svg></> },
  { value: "NotYetcontacted", label: "Not Yet contacted", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5ZM9 4.5C8.80109 4.5 8.61032 4.57902 8.46967 4.71967C8.32902 4.86032 8.25 5.05109 8.25 5.25V9C8.25004 9.1989 8.32909 9.38963 8.46975 9.53025L10.7198 11.7802C10.8612 11.9169 11.0507 11.9925 11.2473 11.9908C11.4439 11.989 11.6321 11.9102 11.7711 11.7711C11.9102 11.6321 11.989 11.4439 11.9908 11.2473C11.9925 11.0507 11.9169 10.8612 11.7802 10.7198L9.75 8.6895V5.25C9.75 5.05109 9.67098 4.86032 9.53033 4.71967C9.38968 4.57902 9.19891 4.5 9 4.5Z" fill="black" /></svg></> },
  { value: "Risky", label: "Risky", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_389_13737)"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 16.3125C10.9394 16.3125 12.7994 15.5421 14.1707 14.1707C15.5421 12.7994 16.3125 10.9394 16.3125 9C16.3125 7.0606 15.5421 5.20064 14.1707 3.82928C12.7994 2.45792 10.9394 1.6875 9 1.6875C7.0606 1.6875 5.20064 2.45792 3.82928 3.82928C2.45792 5.20064 1.6875 7.0606 1.6875 9C1.6875 10.9394 2.45792 12.7994 3.82928 14.1707C5.20064 15.5421 7.0606 16.3125 9 16.3125ZM9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18ZM10.125 12.375C10.125 12.6734 10.0065 12.9595 9.7955 13.1705C9.58452 13.3815 9.29837 13.5 9 13.5C8.70163 13.5 8.41548 13.3815 8.2045 13.1705C7.99353 12.9595 7.875 12.6734 7.875 12.375C7.875 12.0766 7.99353 11.7905 8.2045 11.5795C8.41548 11.3685 8.70163 11.25 9 11.25C9.29837 11.25 9.58452 11.3685 9.7955 11.5795C10.0065 11.7905 10.125 12.0766 10.125 12.375ZM9.84375 5.34375C9.84375 5.11997 9.75486 4.90536 9.59662 4.74713C9.43839 4.58889 9.22378 4.5 9 4.5C8.77622 4.5 8.56161 4.58889 8.40338 4.74713C8.24514 4.90536 8.15625 5.11997 8.15625 5.34375V9.28125C8.15625 9.50503 8.24514 9.71964 8.40338 9.87787C8.56161 10.0361 8.77622 10.125 9 10.125C9.22378 10.125 9.43839 10.0361 9.59662 9.87787C9.75486 9.71964 9.84375 9.50503 9.84375 9.28125V5.34375Z" fill="#FF9F00" /></g><defs><clipPath id="clip0_389_13737"><rect width="18" height="18" fill="white" /></clipPath></defs></svg></> },
  { value: "Invalid", label: "Invalid", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.4373 12.3376L13.3123 11.1751C13.8123 11.0376 14.2186 10.7718 14.5311 10.3778C14.8436 9.98385 14.9998 9.5246 14.9998 9.0001C14.9998 8.3751 14.7811 7.84385 14.3436 7.40635C13.9061 6.96885 13.3748 6.7501 12.7498 6.7501H9.74981V5.2501H12.7498C13.7873 5.2501 14.6718 5.61585 15.4033 6.34735C16.1348 7.07885 16.5003 7.9631 16.4998 9.0001C16.4998 9.7126 16.3156 10.3688 15.9471 10.9688C15.5786 11.5688 15.0753 12.0251 14.4373 12.3376ZM11.8873 9.7501L10.3873 8.2501H11.9998V9.7501H11.8873ZM14.8498 16.9501L1.0498 3.1501L2.0998 2.1001L15.8998 15.9001L14.8498 16.9501ZM8.2498 12.7501H5.2498C4.2123 12.7501 3.32805 12.3843 2.59705 11.6528C1.86605 10.9213 1.5003 10.0371 1.4998 9.0001C1.4998 8.1376 1.7623 7.36885 2.2873 6.69385C2.8123 6.01885 3.4873 5.5751 4.3123 5.3626L5.6998 6.7501H5.2498C4.6248 6.7501 4.09355 6.96885 3.65605 7.40635C3.21855 7.84385 2.9998 8.3751 2.9998 9.0001C2.9998 9.6251 3.21855 10.1563 3.65605 10.5938C4.09355 11.0313 4.6248 11.2501 5.2498 11.2501H8.2498V12.7501ZM5.9998 9.7501V8.2501H7.21855L8.69981 9.7501H5.9998Z" fill="#4b5563" /></svg></> },
  { value: "Valid", label: "Valid", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.75 12.75H5.25C4.25544 12.75 3.30161 12.3549 2.59835 11.6517C1.89509 10.9484 1.5 9.99456 1.5 9C1.5 8.00544 1.89509 7.05161 2.59835 6.34835C3.30161 5.64509 4.25544 5.25 5.25 5.25H6.75M11.25 5.25H12.75C13.7446 5.25 14.6984 5.64509 15.4017 6.34835C16.1049 7.05161 16.5 8.00544 16.5 9C16.5 9.99456 16.1049 10.9484 15.4017 11.6517C14.6984 12.3549 13.7446 12.75 12.75 12.75H11.25M6 9H12" stroke="#2ECA8B" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "Completed", label: "Completed", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.875 12.0454L5.0625 9.23231L5.85731 8.4375L7.875 10.4546L12.1416 6.1875L12.9375 6.98344L7.875 12.0454Z" fill="#2ECA8B" /><path d="M9 1.125C7.44248 1.125 5.91992 1.58686 4.62489 2.45218C3.32985 3.31749 2.32049 4.5474 1.72445 5.98637C1.12841 7.42534 0.972461 9.00874 1.27632 10.5363C1.58018 12.0639 2.3302 13.4671 3.43154 14.5685C4.53288 15.6698 5.93607 16.4198 7.46367 16.7237C8.99127 17.0275 10.5747 16.8716 12.0136 16.2756C13.4526 15.6795 14.6825 14.6702 15.5478 13.3751C16.4131 12.0801 16.875 10.5575 16.875 9C16.875 6.91142 16.0453 4.90838 14.5685 3.43153C13.0916 1.95469 11.0886 1.125 9 1.125ZM9 15.75C7.66498 15.75 6.35994 15.3541 5.2499 14.6124C4.13987 13.8707 3.27471 12.8165 2.76382 11.5831C2.25293 10.3497 2.11925 8.99251 2.3797 7.68314C2.64015 6.37377 3.28303 5.17103 4.22703 4.22703C5.17104 3.28302 6.37377 2.64015 7.68314 2.3797C8.99252 2.11925 10.3497 2.25292 11.5831 2.76381C12.8165 3.2747 13.8707 4.13987 14.6124 5.2499C15.3541 6.35993 15.75 7.66498 15.75 9C15.75 10.7902 15.0388 12.5071 13.773 13.773C12.5071 15.0388 10.7902 15.75 9 15.75Z" fill="#2ECA8B" /></svg></> },
  { value: "interested", label: "Interested", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#97E0B6" /></svg></> },
  { value: "Meetingbooked", label: "Meeting booked", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#BE83E4" /></svg></> },
  { value: "Meetingcompleted", label: "Meetingcompleted", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#F1A842" /></svg></> },
  { value: "Won", label: "Won", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#CAE32B" /></svg></> },
  { value: "Outofoffice", label: "Out of office", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#93BCED" /></svg></> },
  { value: "Wrongperson", label: "Wrong person", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#A5AAB6" /></svg></> },
  { value: "NotInterested", label: "Not Interested", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#EA7D84" /></svg></> },
  { value: "Lost", label: "Lost", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#FF0000" /></svg></> },
  { value: "Autoreply", label: "Auto reply", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#CAE32B" /></svg></> },
  { value: "Checkbackinfuture", label: "Check back in future", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#838383" /></svg></> },
];


// Dropdown options
const optionscontactOwner = [
  { value: "All Users", label: "All Users" },
  { value: "Muhammad Mousa", label: <div className='usermail'><i className='username-word-auto'>M</i>Muhammad Mousa</div> },
  { value: "Muhammad Mousa", label: <div className='usermail'><i className='username-word-auto'>WU</i>Waqar U Din</div> },
  { value: "Muhammad Mousa", label: <div className='usermail'><i className='username-word-auto'>M</i>Muhaddis</div> },
];



// Dropdown options
const optionscontactESP = [
  { value: "AllESPs", label: "All ESPs", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 3H15C15.825 3 16.5 3.675 16.5 4.5V13.5C16.5 14.325 15.825 15 15 15H3C2.175 15 1.5 14.325 1.5 13.5V4.5C1.5 3.675 2.175 3 3 3Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /><path d="M16.5 4.5L9 9.75L1.5 4.5" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "Google", label: "Google", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.3541 7.53113H15.75V7.5H9V10.5H13.2386C12.6203 12.2464 10.9586 13.5 9 13.5C6.51487 13.5 4.5 11.4851 4.5 9C4.5 6.51487 6.51487 4.5 9 4.5C10.1471 4.5 11.1908 4.93275 11.9854 5.63962L14.1068 3.51825C12.7673 2.26987 10.9755 1.5 9 1.5C4.85812 1.5 1.5 4.85812 1.5 9C1.5 13.1419 4.85812 16.5 9 16.5C13.1419 16.5 16.5 13.1419 16.5 9C16.5 8.49713 16.4482 8.00625 16.3541 7.53113Z" fill="#FFC107" /><path d="M2.36523 5.50912L4.82936 7.31625C5.49611 5.6655 7.11086 4.5 9.00048 4.5C10.1476 4.5 11.1912 4.93275 11.9859 5.63962L14.1072 3.51825C12.7677 2.26987 10.976 1.5 9.00048 1.5C6.11973 1.5 3.62148 3.12637 2.36523 5.50912Z" fill="#FF3D00" /><path d="M9.00012 16.4998C10.9374 16.4998 12.6976 15.7584 14.0285 14.5528L11.7072 12.5885C10.9291 13.1807 9.97796 13.5008 9.00012 13.4998C7.04937 13.4998 5.39299 12.2559 4.76899 10.52L2.32324 12.4044C3.56449 14.8333 6.08524 16.4998 9.00012 16.4998Z" fill="#4CAF50" /><path d="M16.3541 7.53113H15.75V7.5H9V10.5H13.2386C12.9428 11.3312 12.41 12.0574 11.706 12.5891L11.7071 12.5884L14.0284 14.5526C13.8641 14.7019 16.5 12.75 16.5 9C16.5 8.49713 16.4482 8.00625 16.3541 7.53113Z" fill="#1976D2" /></svg></> },
  { value: "Microsoft", label: "Microsoft", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_389_14020)"><path d="M1.5293 14.5207V3.57725L11.2098 0L16.4705 1.68277V16.4144L11.2098 18.0007L1.5293 14.5207L11.2098 15.6857V2.94648L4.89629 4.41971V13.0482L1.5293 14.5207Z" fill="#EB3C00" /></g><defs><clipPath id="clip0_389_14020"><rect width="18" height="18" fill="white" /></clipPath></defs></svg></> },
  { value: "Zoho", label: "Zoho", icon: <><svg width="53" height="18" viewBox="0 0 53 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_389_14040)"><path d="M52.0678 3.83398V16.1797L50.3594 17.8475V5.76619L52.0678 3.83398Z" fill="#E79225" /><path d="M40.8711 3.84415L39.1016 5.76619L39.1931 5.88822L50.288 5.84754L50.3897 5.76619L52.0677 3.83398L40.8711 3.84415Z" fill="#FFF16D" /><path d="M39.1016 5.76611H50.3897V17.8576H39.1016V5.76611Z" fill="url(#paint0_linear_389_14040)" /><path d="M48.6715 10.1189C48.4477 9.55955 48.1121 9.05108 47.6748 8.61379C47.2579 8.18667 46.7901 7.86125 46.2613 7.64769C45.7426 7.43413 45.1833 7.32227 44.5731 7.32227C43.963 7.32227 43.3935 7.43413 42.8748 7.64769C42.346 7.86125 41.8782 8.18667 41.4613 8.61379C41.024 9.05108 40.6986 9.55955 40.4748 10.1189C40.2511 10.6782 40.1494 11.2884 40.1494 11.9596C40.1494 12.6104 40.2613 13.2206 40.485 13.7901C40.7087 14.3596 41.0342 14.868 41.4714 15.3155C41.8782 15.7324 42.346 16.0477 42.8647 16.2612C43.3833 16.4748 43.963 16.5867 44.5833 16.5867C45.1833 16.5867 45.7426 16.4748 46.2613 16.2612C46.7799 16.0477 47.2579 15.7324 47.6748 15.3155C48.1121 14.868 48.4477 14.3596 48.6715 13.8002C48.8952 13.2409 49.007 12.6206 49.007 11.9697C49.007 11.2884 48.8952 10.6782 48.6715 10.1189ZM46.3426 14.1053C45.9053 14.624 45.3257 14.8884 44.5731 14.8884C43.8206 14.8884 43.2308 14.624 42.7935 14.1053C42.3562 13.5867 42.1426 12.8646 42.1426 11.9494C42.1426 11.0138 42.3664 10.2918 42.7935 9.76294C43.2308 9.23413 43.8104 8.97989 44.5731 8.97989C45.3257 8.97989 45.9053 9.2443 46.3426 9.76294C46.7698 10.2918 46.9935 11.0138 46.9935 11.9494C46.9935 12.8646 46.7799 13.5867 46.3426 14.1053Z" fill="white" /><path d="M37.9937 2.82715V2.88817L39.4377 13.9831L38.5937 16.3221L38.4818 16.2407L36.9971 5.60342L37.0276 5.46105L37.953 2.88817L37.9937 2.82715Z" fill="#009ADA" /><path d="M26.878 4.37291L37.9932 2.82715L37.0576 5.49156L36.9254 5.63393L26.5322 7.15935L26.5831 5.25766L26.878 4.37291Z" fill="#91C9ED" /><path d="M37.0575 5.4917L38.5931 16.3222L27.6406 17.8578L26.166 7.39339L26.8067 6.89509L37.0575 5.4917Z" fill="url(#paint1_linear_389_14040)" /><path d="M35.1964 7.5662C35.1455 7.23061 35.0337 6.97637 34.8506 6.80349C34.6981 6.67128 34.515 6.6001 34.3015 6.6001C34.2506 6.6001 34.1896 6.6001 34.1286 6.61027C33.8438 6.65094 33.6303 6.78315 33.4981 6.99671C33.3964 7.14925 33.3557 7.34247 33.3557 7.5662C33.3557 7.64756 33.3659 7.73908 33.376 7.83061L33.7726 10.6476L30.6201 11.1154L30.2235 8.2984C30.1726 7.97298 30.0608 7.71874 29.8777 7.54586C29.7252 7.40349 29.5421 7.3323 29.3387 7.3323C29.2879 7.3323 29.237 7.3323 29.1862 7.34247C28.8913 7.38315 28.6676 7.51535 28.5252 7.72891C28.4235 7.88145 28.3828 8.07467 28.3828 8.2984C28.3828 8.37976 28.393 8.47128 28.4031 8.57298L29.4811 15.9052C29.532 16.2408 29.6438 16.495 29.8472 16.6679C29.9998 16.8001 30.1828 16.8611 30.4065 16.8611C30.4676 16.8611 30.5286 16.8611 30.5896 16.8509C30.8642 16.8103 31.0676 16.6781 31.1998 16.4645C31.2913 16.312 31.332 16.1289 31.332 15.9154C31.332 15.834 31.3218 15.7425 31.3116 15.6509L30.8743 12.7526L34.0269 12.2848L34.4642 15.1831C34.515 15.5187 34.6269 15.773 34.8201 15.9357C34.9726 16.0679 35.1557 16.1391 35.3693 16.1391C35.4201 16.1391 35.4811 16.1391 35.5421 16.1289C35.8269 16.0882 36.0404 15.956 36.1726 15.7425C36.2642 15.5899 36.315 15.4069 36.315 15.1831C36.315 15.1018 36.3048 15.0103 36.2947 14.9187L35.1964 7.5662Z" fill="white" /><path d="M16.4745 0L12.5186 9.39661L13.0575 13.5254L13.088 13.5153L17.5321 3.51864L17.5118 3.30508L16.5558 0.132203L16.4745 0Z" fill="#66BF6B" /><path d="M16.4746 0L17.5017 3.44746L17.5221 3.51864L27.3051 7.90169L27.3356 7.88136L26.5017 4.58644L16.4746 0Z" fill="#98D0A0" /><path d="M17.5017 3.44727L27.3356 7.88116L22.8915 17.9591L13.0576 13.5252L17.5017 3.44727Z" fill="url(#paint2_linear_389_14040)" /><path d="M24.356 8.69473C24.1424 8.12524 23.8475 7.6371 23.4611 7.23032C23.0746 6.82354 22.6068 6.49812 22.0577 6.26422C21.5085 6.03032 20.9594 5.91846 20.4001 5.91846H20.3695C19.8 5.91846 19.2407 6.05066 18.6916 6.29473C18.1119 6.54897 17.6136 6.89473 17.1865 7.35236C16.7594 7.79981 16.4136 8.34897 16.1492 8.97947C15.8848 9.59981 15.7424 10.2303 15.7119 10.8507V11.0642C15.7119 11.6134 15.8034 12.1524 15.9967 12.6812C16.2 13.2405 16.495 13.7185 16.8814 14.1252C17.2678 14.532 17.7458 14.8574 18.3153 15.0913C18.8543 15.3252 19.4034 15.4371 19.9628 15.4371H19.9729C20.5323 15.4371 21.0916 15.3151 21.6407 15.0812C22.2204 14.8269 22.7289 14.471 23.156 14.0134C23.5831 13.5659 23.939 13.0269 24.2034 12.3964C24.4678 11.7659 24.6102 11.1456 24.6407 10.5252V10.3422C24.6509 9.78286 24.5594 9.23371 24.356 8.69473ZM22.3933 11.6235C22.0272 12.4981 21.5289 13.0981 20.9289 13.4235C20.6034 13.5964 20.2678 13.6879 19.9323 13.6879C19.6373 13.6879 19.3221 13.6168 19.0068 13.4846C18.3153 13.1896 17.8882 12.7218 17.7051 12.0507C17.6441 11.8269 17.6136 11.593 17.6136 11.349C17.6136 10.8608 17.7356 10.3218 17.9797 9.74219C18.356 8.84727 18.8543 8.2371 19.4543 7.90151C19.7797 7.71846 20.1153 7.6371 20.4509 7.6371C20.756 7.6371 21.0611 7.70829 21.3865 7.84049C22.0678 8.13541 22.495 8.6032 22.678 9.27439C22.739 9.48795 22.7695 9.72185 22.7695 9.96591C22.7695 10.4744 22.6475 11.0235 22.3933 11.6235Z" fill="white" /><path d="M11.7356 1.59668L13.3424 12.356L12.6102 16.1391L12.5085 16.0068L10.9424 5.61363V5.41024L11.6339 1.77973L11.7356 1.59668Z" fill="#760D16" /><path d="M0 7.15939L0.762712 3.356L11.7356 1.59668L10.9932 5.47126V5.72549L0.132203 7.26109L0 7.15939Z" fill="#EF463E" /><path d="M10.9932 5.47119L12.6102 16.139L1.74915 17.8373L0 7.15933L10.9932 5.47119Z" fill="url(#paint3_linear_389_14040)" /><path d="M9.82419 14.4409C9.74284 14.3392 9.6208 14.268 9.47843 14.2172C9.33606 14.1663 9.16318 14.146 8.94962 14.146C8.7564 14.146 8.53267 14.1663 8.2886 14.207L5.4208 14.6952C5.45131 14.4714 5.56317 14.1867 5.7564 13.8307C5.96995 13.4341 6.29538 12.9562 6.71233 12.407C6.8547 12.2138 6.96657 12.0714 7.04792 11.9697C7.09877 11.8985 7.18012 11.807 7.28182 11.6748C7.94284 10.8104 8.33945 10.1087 8.50216 9.55956C8.59368 9.2443 8.64453 8.92905 8.66487 8.6138C8.67504 8.52227 8.67504 8.44091 8.67504 8.35956C8.67504 8.13583 8.6547 7.9121 8.61402 7.68837C8.58351 7.48498 8.53267 7.32227 8.46148 7.19007C8.39029 7.05786 8.30894 6.95617 8.20724 6.89515C8.09538 6.82397 7.9225 6.79346 7.70894 6.79346C7.53606 6.79346 7.3225 6.8138 7.06826 6.85447L3.75301 7.42397C3.3564 7.49515 3.05131 7.60702 2.86826 7.79007C2.71572 7.93244 2.64453 8.11549 2.64453 8.31888C2.64453 8.36973 2.64453 8.43074 2.6547 8.49176C2.70555 8.77651 2.84792 8.9799 3.08182 9.08159C3.22419 9.14261 3.3869 9.17312 3.59029 9.17312C3.7225 9.17312 3.87504 9.16295 4.03775 9.13244L6.80385 8.6443C6.80385 8.69515 6.81402 8.746 6.81402 8.78668C6.81402 8.95956 6.78351 9.13244 6.7225 9.29515C6.64114 9.52905 6.43775 9.85447 6.10216 10.2714C6.01063 10.3833 5.86826 10.5663 5.67504 10.8002C4.9225 11.7053 4.39368 12.4782 4.06826 13.1189C3.83436 13.5663 3.68182 13.9935 3.59029 14.4307C3.53945 14.685 3.50894 14.9189 3.50894 15.1528C3.50894 15.3155 3.51911 15.4782 3.54962 15.6307C3.59029 15.8545 3.64114 16.0375 3.71233 16.1799C3.78351 16.3223 3.88521 16.4341 3.99707 16.4952C4.10894 16.5562 4.26148 16.5765 4.48521 16.5765C4.75979 16.5765 5.13606 16.5358 5.61402 16.4545L8.62419 15.9358C9.15301 15.8443 9.52928 15.7121 9.74284 15.5392C9.91572 15.3968 10.0072 15.2036 10.0072 14.9799C10.0072 14.9189 9.99707 14.8579 9.9869 14.7968C9.96656 14.6646 9.91572 14.5426 9.82419 14.4409Z" fill="white" /></g><defs><linearGradient id="paint0_linear_389_14040" x1="603.463" y1="23.0691" x2="603.463" y2="1178.41" gradientUnits="userSpaceOnUse"><stop offset="0.00562" stop-color="#FFE513" /><stop offset="1" stop-color="#FDB924" /></linearGradient><linearGradient id="paint1_linear_389_14040" x1="82.2372" y1="172.36" x2="1210.69" y2="1087.56" gradientUnits="userSpaceOnUse"><stop offset="0.00562" stop-color="#008CD2" /><stop offset="1" stop-color="#00649D" /></linearGradient><linearGradient id="paint2_linear_389_14040" x1="726.985" y1="406.572" x2="726.985" y2="1418.78" gradientUnits="userSpaceOnUse"><stop stop-color="#26A146" /><stop offset="1" stop-color="#008A52" /></linearGradient><linearGradient id="paint3_linear_389_14040" x1="551.493" y1="106.972" x2="719.129" y2="1159" gradientUnits="userSpaceOnUse"><stop stop-color="#D92231" /><stop offset="1" stop-color="#BA2234" /></linearGradient><clipPath id="clip0_389_14040"><rect width="52.0678" height="18" fill="white" /></clipPath></defs></svg></> },
  { value: "Yahoo", label: "Yahoo", },
  { value: "Yandex", label: "Yandex", },
  { value: "Other", label: "Other", },
  { value: "NotFound", label: "Not Found", },
  { value: "Processinginqueue", label: "Processing in queue", },
];


// Dropdown options
const optionscontactsSelectFilters = [
  { value: "Contact", label: "Contact", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "interested", label: "Interested", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#97E0B6" /></svg></> },
  { value: "Meetingbooked", label: "Meeting booked", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#BE83E4" /></svg></> },
  { value: "Meetingcompleted", label: "Meetingcompleted", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#F1A842" /></svg></> },
  { value: "Won", label: "Won", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#CAE32B" /></svg></> },
  { value: "Outofoffice", label: "Out of office", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#93BCED" /></svg></> },
  { value: "Wrongperson", label: "Wrong person", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#A5AAB6" /></svg></> },
  { value: "NotInterested", label: "Not Interested", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#EA7D84" /></svg></> },
  { value: "Lost", label: "Lost", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#FF0000" /></svg></> },
  { value: "Create-Lable", label: "Create Lable", icon: <><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4.1665V15.8332" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M4.1665 10H15.8332" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
];


function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

// Dropdown options
const optionsData = [
  { value: "RemoteJobLab", label: "Remote Job Lab" },
  { value: "CreateWorkspace", label: "Create Workspace", icon: <><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M5 12H19" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
];


// Dropdown options
const optionsStatus = [
  { value: "paused", label: "Pause campaign", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 3H4.5V15H7.5V3Z" fill="#242424" /><path d="M13.5 3H10.5V15H13.5V3Z" fill="#242424" /></svg></> },
  { value: "allStatus", label: "All Status", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "haserrors", label: "Has errors", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.96568 3.88897C7.18535 3.13969 6.13933 2.73108 5.05774 2.75304C3.97614 2.77499 2.94757 3.22571 2.19829 4.00604C1.44902 4.78636 1.04041 5.83238 1.06236 6.91398C1.08432 7.99557 1.53504 9.02414 2.31536 9.77342L8.59919 16.148C8.65153 16.2011 8.71392 16.2433 8.78273 16.2721C8.85153 16.3009 8.92538 16.3158 8.99997 16.3158C9.07457 16.3158 9.14841 16.3009 9.21722 16.2721C9.28603 16.2433 9.34841 16.2011 9.40075 16.148L15.6797 9.77342C16.4452 9.00885 16.8756 7.9715 16.8762 6.88958C16.8769 5.80765 16.4477 4.76978 15.6832 4.00428C14.9186 3.23878 13.8813 2.80835 12.7993 2.80769C11.7174 2.80703 10.6795 3.23619 9.91404 4.00076L8.19841 5.61795L10.0547 7.47561C10.107 7.52785 10.1484 7.58989 10.1768 7.65817C10.2051 7.72646 10.2196 7.79966 10.2196 7.87358C10.2196 7.9475 10.2051 8.02069 10.1768 8.08898C10.1484 8.15727 10.107 8.2193 10.0547 8.27154L8.5999 9.72631C8.54759 9.77853 8.48551 9.81993 8.4172 9.84815C8.34889 9.87638 8.27569 9.89087 8.20178 9.8908C8.12787 9.89074 8.0547 9.87612 7.98644 9.84777C7.91818 9.81943 7.85617 9.77792 7.80396 9.72561C7.75174 9.6733 7.71034 9.61122 7.68212 9.54291C7.65389 9.4746 7.6394 9.4014 7.63947 9.32749C7.63953 9.25358 7.65415 9.18041 7.6825 9.11215C7.71084 9.04389 7.75235 8.98189 7.80466 8.92967L8.85935 7.87498L6.99607 6.00608C6.94251 5.95256 6.9003 5.88878 6.87198 5.81856C6.84366 5.74835 6.82981 5.67313 6.83125 5.59743C6.8327 5.52173 6.84941 5.4471 6.88039 5.37802C6.91137 5.30893 6.95597 5.24681 7.01154 5.19537L7.96427 4.29678C7.99193 4.27051 8.01395 4.23888 8.029 4.20382C8.04405 4.16877 8.05181 4.13102 8.05181 4.09287C8.05181 4.05473 8.04405 4.01698 8.029 3.98192C8.01395 3.94687 7.99193 3.91524 7.96427 3.88897H7.96568Z" fill="#FF0000" /></svg></> },
  { value: "nocustomtrackingdomain", label: "No custom tracking domain", icon: <><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="2" fill="#242424" /><path d="M15.625 10.125C15.625 11.2375 15.2951 12.3251 14.677 13.2501C14.0589 14.1751 13.1804 14.8961 12.1526 15.3218C11.1248 15.7476 9.99376 15.859 8.90262 15.6419C7.81147 15.4249 6.80919 14.8891 6.02252 14.1025C5.23585 13.3158 4.70012 12.3135 4.48308 11.2224C4.26604 10.1312 4.37743 9.00024 4.80318 7.97241C5.22892 6.94457 5.94989 6.06607 6.87492 5.44798C7.79994 4.8299 8.88748 4.5 10 4.5" stroke="#242424" /><path d="M19 10.125C19 11.905 18.4722 13.6451 17.4832 15.1251C16.4943 16.6052 15.0887 17.7587 13.4442 18.4399C11.7996 19.1211 9.99002 19.2993 8.24419 18.9521C6.49836 18.6048 4.89471 17.7476 3.63604 16.489C2.37737 15.2303 1.5202 13.6266 1.17293 11.8808C0.825665 10.135 1.0039 8.32538 1.68508 6.68085C2.36627 5.03631 3.51983 3.63071 4.99987 2.64177C6.47991 1.65284 8.21997 1.125 10 1.125" stroke="#242424" /><line x1="10.5" y1="2.18557e-08" x2="10.5" y2="11" stroke="#242424" /></svg></> },
  { value: "pre-warmedaccounts", label: "Pre-warmed accounts", icon: <><svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_124_4015)"><path d="M2.58884 8.60638L3.43037 9.05502L3.32075 8.10769C3.11396 6.32069 3.54971 4.82767 4.52732 3.59679C5.30582 2.6166 6.44578 1.78093 7.9289 1.10562C7.75541 1.63812 7.71393 2.17784 7.77174 2.71816C7.87426 3.67637 8.28674 4.61617 8.75997 5.50414C8.98642 5.92905 9.23342 6.35379 9.47502 6.76926C9.48755 6.79081 9.50007 6.81233 9.51257 6.83383C9.76796 7.27311 10.0163 7.70233 10.2393 8.12878C10.6885 8.98789 11.0082 9.78788 11.0679 10.5485L11.1893 12.0937L11.9938 10.7688C12.4637 9.99492 12.7859 9.06275 12.9681 7.94752C13.6899 9.89058 13.5053 11.9813 12.6195 13.6633C11.5395 15.714 9.41823 17.159 6.58701 16.9802C5.62465 15.543 4.90997 14.2676 4.62814 13.6594L4.17005 12.6709L3.71928 13.6628C3.22087 14.7595 2.79828 15.0538 2.57194 15.0984C2.39047 15.1341 2.1028 15.0368 1.7333 14.5269C1.38428 14.0454 1.07252 13.3333 0.848219 12.5538C0.624909 11.7777 0.5 10.9757 0.5 10.3323C0.5 9.10503 0.908937 7.96143 1.52699 6.95549C1.57265 7.13167 1.62481 7.29863 1.68444 7.45444C1.86652 7.93018 2.14429 8.36938 2.58884 8.60638Z" stroke="#242424" /></g><defs><clipPath id="clip0_124_4015"><rect width="14" height="18" fill="white" transform="translate(0 0.125)" /></clipPath></defs></svg></> },
  { value: "dfyaccounts", label: "DFY accounts", icon: <><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.25 1.625C7.25544 1.625 6.30161 2.02009 5.59835 2.72335C4.89509 3.42661 4.5 4.38044 4.5 5.375C4.5 6.36956 4.89509 7.32339 5.59835 8.02665C6.30161 8.72991 7.25544 9.125 8.25 9.125C9.24456 9.125 10.1984 8.72991 10.9017 8.02665C11.6049 7.32339 12 6.36956 12 5.375C12 4.38044 11.6049 3.42661 10.9017 2.72335C10.1984 2.02009 9.24456 1.625 8.25 1.625ZM8.25 9.875C6.45375 9.875 4.81875 10.3955 3.6165 11.129C3.0165 11.495 2.5035 11.927 2.133 12.3965C1.7685 12.857 1.5 13.4097 1.5 14C1.5 14.6337 1.80825 15.1333 2.25225 15.4895C2.67225 15.827 3.2265 16.0505 3.81525 16.2065C4.99875 16.5192 6.57825 16.625 8.25 16.625L8.76375 16.6213C8.88936 16.6195 9.01252 16.5863 9.12193 16.5246C9.23135 16.4628 9.3235 16.3746 9.38995 16.268C9.45639 16.1614 9.49499 16.0398 9.50221 15.9144C9.50943 15.789 9.48503 15.6638 9.43125 15.5502C9.14685 14.9483 8.99957 14.2907 9 13.625C9 12.686 9.28725 11.816 9.77775 11.0953C9.85066 10.9881 9.89458 10.864 9.90522 10.7348C9.91587 10.6057 9.89288 10.476 9.8385 10.3584C9.78411 10.2408 9.70019 10.1393 9.59491 10.0638C9.48963 9.98828 9.36658 9.94132 9.23775 9.9275C8.91475 9.8925 8.5855 9.875 8.25 9.875ZM15.462 11.7267C15.512 11.6414 15.5447 11.547 15.5581 11.449C15.5715 11.351 15.5654 11.2514 15.5401 11.1557C15.5148 11.0601 15.4708 10.9704 15.4108 10.8919C15.3507 10.8133 15.2757 10.7474 15.19 10.6979C15.1043 10.6485 15.0097 10.6164 14.9117 10.6037C14.8136 10.5909 14.7139 10.5977 14.6185 10.6236C14.523 10.6496 14.4336 10.6941 14.3555 10.7547C14.2773 10.8153 14.2119 10.8908 14.163 10.9767L13.911 11.4132C13.6391 11.3624 13.3602 11.3622 13.0883 11.4125L12.837 10.9767C12.7881 10.8908 12.7227 10.8153 12.6445 10.7547C12.5664 10.6941 12.477 10.6496 12.3815 10.6236C12.2861 10.5977 12.1864 10.5909 12.0883 10.6037C11.9903 10.6164 11.8957 10.6485 11.81 10.6979C11.7243 10.7474 11.6493 10.8133 11.5892 10.8919C11.5292 10.9704 11.4852 11.0601 11.4599 11.1557C11.4346 11.2514 11.4285 11.351 11.4419 11.449C11.4553 11.547 11.488 11.6414 11.538 11.7267L11.7892 12.1617C11.6098 12.3723 11.4707 12.6141 11.379 12.875H10.875C10.6761 12.875 10.4853 12.954 10.3447 13.0947C10.204 13.2353 10.125 13.4261 10.125 13.625C10.125 13.8239 10.204 14.0147 10.3447 14.1553C10.4853 14.296 10.6761 14.375 10.875 14.375H11.3783C11.4705 14.6358 11.6101 14.8773 11.79 15.0875L11.538 15.5233C11.488 15.6086 11.4553 15.703 11.4419 15.801C11.4285 15.899 11.4346 15.9986 11.4599 16.0943C11.4852 16.1899 11.5292 16.2796 11.5892 16.3581C11.6493 16.4367 11.7243 16.5026 11.81 16.5521C11.8957 16.6015 11.9903 16.6336 12.0883 16.6463C12.1864 16.6591 12.2861 16.6523 12.3815 16.6264C12.477 16.6004 12.5664 16.5559 12.6445 16.4953C12.7227 16.4347 12.7881 16.3592 12.837 16.2733L13.089 15.8375C13.3582 15.887 13.6365 15.8885 13.9117 15.8375L14.163 16.2733C14.2119 16.3592 14.2773 16.4347 14.3555 16.4953C14.4336 16.5559 14.523 16.6004 14.6185 16.6264C14.7139 16.6523 14.8136 16.6591 14.9117 16.6463C15.0097 16.6336 15.1043 16.6015 15.19 16.5521C15.2757 16.5026 15.3507 16.4367 15.4108 16.3581C15.4708 16.2796 15.5148 16.1899 15.5401 16.0943C15.5654 15.9986 15.5715 15.899 15.5581 15.801C15.5447 15.703 15.512 15.6086 15.462 15.5233L15.2108 15.0883C15.3923 14.8752 15.5302 14.633 15.621 14.375H16.125C16.3239 14.375 16.5147 14.296 16.6553 14.1553C16.796 14.0147 16.875 13.8239 16.875 13.625C16.875 13.4261 16.796 13.2353 16.6553 13.0947C16.5147 12.954 16.3239 12.875 16.125 12.875H15.6217C15.5295 12.6142 15.3899 12.3727 15.21 12.1625L15.462 11.7267Z" fill="var(--sa-dark-accent-light)" /></svg></> },
  { value: "warmupactive", label: "Warmup active", icon: <><svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_124_4021)"><mask id="path-1-inside-1_124_4021" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.82406 8.16516C2.38182 4.34342 4.6951 1.65539 9.03146 0.125C6.37547 3.45116 11.2952 7.05468 11.5664 10.5093C12.2022 9.46219 12.5632 8.0638 12.6346 6.19586C15.886 11.1207 12.6317 18.0507 6.30729 17.4598C5.26823 15.9287 4.48438 14.5384 4.17448 13.8696C2.15104 18.3221 0 13.1315 0 10.3323C0 8.54811 0.790417 6.95507 1.81344 5.68937C1.95016 6.92938 2.24109 7.85437 2.82406 8.16516Z" /></mask><path d="M2.82406 8.16516L-2.1156 17.4307L15.5565 26.8521L13.2545 6.95819L2.82406 8.16516ZM9.03146 0.125L17.2365 6.67686L40.1209 -21.9818L5.53703 -9.77646L9.03146 0.125ZM11.5664 10.5093L1.09862 11.3312L3.64661 43.7823L20.5414 15.9591L11.5664 10.5093ZM12.6346 6.19586L21.3972 0.410827L3.39161 -26.8624L2.14231 5.79448L12.6346 6.19586ZM6.30729 17.4598L-2.38092 23.356L0.399851 27.4535L5.33041 27.9142L6.30729 17.4598ZM4.17448 13.8696L13.7013 9.45495L4.0815 -11.3045L-5.38471 9.52544L4.17448 13.8696ZM1.81344 5.68937L12.2502 4.53865L9.48843 -20.5099L-6.35266 -0.910989L1.81344 5.68937ZM13.2545 6.95819C13.2822 7.19772 13.292 7.67349 13.1257 8.28164C12.9565 8.90019 12.6673 9.42675 12.358 9.81616C11.7958 10.524 11.5028 10.3875 12.5259 10.0265L5.53703 -9.77646C2.2238 -8.60716 -1.39409 -6.63437 -4.08642 -3.24452C-6.98855 0.40949 -8.12848 4.85986 -7.60634 9.37214L13.2545 6.95819ZM0.826393 -6.42686C-1.65238 -3.32263 -2.54237 0.315635 -2.17152 3.78195C-1.85789 6.71336 -0.68456 9.04479 -0.0650136 10.2073C0.277909 10.8508 0.640902 11.4703 0.867475 11.86C1.13434 12.319 1.27354 12.5634 1.37772 12.7626C1.65447 13.2918 1.20078 12.6323 1.09862 11.3312L22.0342 9.68741C21.7964 6.65899 20.626 4.25356 19.9871 3.03158C19.6334 2.35521 19.2649 1.72262 19.0222 1.30504C18.7391 0.818161 18.5904 0.561448 18.4674 0.330666C18.1552 -0.2553 18.5796 0.335673 18.7093 1.54798C18.7864 2.26865 18.7629 3.20181 18.4746 4.2272C18.1839 5.2608 17.7088 6.08537 17.2365 6.67686L0.826393 -6.42686ZM20.5414 15.9591C22.4235 12.8595 23.0154 9.51254 23.127 6.59725L2.14231 5.79448C2.12793 6.17044 2.09258 6.24601 2.12617 6.11175C2.16359 5.96219 2.28346 5.56675 2.59144 5.05956L20.5414 15.9591ZM3.87202 11.9809C3.30365 11.12 3.25628 9.98182 3.77147 9.00356C4.04708 8.48024 4.53242 7.90714 5.27214 7.49089C6.05807 7.04865 6.81694 6.96165 7.28418 7.00531L5.33041 27.9142C12.9921 28.6301 19.3015 24.5819 22.3523 18.7889C25.2629 13.2622 25.217 6.19658 21.3972 0.410827L3.87202 11.9809ZM14.9955 11.5636C14.6114 10.9977 14.2795 10.4645 14.0281 10.0352C13.7477 9.5565 13.6586 9.36279 13.7013 9.45495L-5.35236 18.2843C-4.72457 19.6391 -3.61284 21.5407 -2.38092 23.356L14.9955 11.5636ZM-5.38471 9.52544C-5.37365 9.50111 -5.09339 8.86264 -4.36791 8.06172C-3.62758 7.24441 -1.99594 5.80602 0.639226 5.28692C6.55231 4.12213 9.68297 8.4552 9.83039 8.65861C10.1659 9.12159 10.3268 9.46651 10.3777 9.58078C10.4389 9.71806 10.4579 9.78722 10.4583 9.7885C10.4597 9.79356 10.4637 9.80599 10.4701 9.84728C10.4746 9.87578 10.5 10.0398 10.5 10.3323H-10.5C-10.5 12.2168 -10.1654 14.0576 -9.72284 15.5956C-9.30113 17.0612 -8.54163 19.0943 -7.17349 20.9821C-6.23538 22.2765 -2.18756 27.2473 4.69793 25.891C10.6414 24.7202 13.0714 19.6712 13.7337 18.2138L-5.38471 9.52544ZM10.5 10.3323C10.5 11.0155 10.3452 11.5439 10.2123 11.8622C10.1475 12.0174 10.0871 12.1257 10.048 12.1894C10.009 12.253 9.98339 12.285 9.97954 12.2897L-6.35266 -0.910989C-8.32554 1.52989 -10.5 5.38461 -10.5 10.3323H10.5ZM-8.62332 6.84009C-8.5115 7.85422 -8.27754 9.40204 -7.65492 11.0288C-7.08521 12.5174 -5.62151 15.5616 -2.1156 17.4307L7.76372 -1.10035C10.6867 0.457937 11.7134 2.88422 11.9577 3.5226C12.255 4.29921 12.2751 4.76453 12.2502 4.53865L-8.62332 6.84009Z" fill="#2ECA8B" mask="url(#path-1-inside-1_124_4021)" /></g><defs><clipPath id="clip0_124_4021"><rect width="14" height="18" fill="white" transform="translate(0 0.125)" /></clipPath></defs></svg></> },
  { value: "warmuppaused", label: "Warmup paused", icon: <><svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_124_4026)"><mask id="path-1-inside-1_124_4026" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.82406 8.16516C2.38182 4.34342 4.6951 1.65539 9.03146 0.125C6.37547 3.45116 11.2952 7.05468 11.5664 10.5093C12.2022 9.46219 12.5632 8.0638 12.6346 6.19586C15.886 11.1207 12.6317 18.0507 6.30729 17.4598C5.26823 15.9287 4.48438 14.5384 4.17448 13.8696C2.15104 18.3221 0 13.1315 0 10.3323C0 8.54811 0.790417 6.95507 1.81344 5.68937C1.95016 6.92938 2.24109 7.85437 2.82406 8.16516Z" /></mask><path d="M2.82406 8.16516L-2.1156 17.4307L15.5565 26.8521L13.2545 6.95819L2.82406 8.16516ZM9.03146 0.125L17.2365 6.67686L40.1209 -21.9818L5.53703 -9.77646L9.03146 0.125ZM11.5664 10.5093L1.09862 11.3312L3.64661 43.7823L20.5414 15.9591L11.5664 10.5093ZM12.6346 6.19586L21.3972 0.410827L3.39161 -26.8624L2.14231 5.79448L12.6346 6.19586ZM6.30729 17.4598L-2.38092 23.356L0.399851 27.4535L5.33041 27.9142L6.30729 17.4598ZM4.17448 13.8696L13.7013 9.45495L4.0815 -11.3045L-5.38471 9.52544L4.17448 13.8696ZM1.81344 5.68937L12.2502 4.53865L9.48843 -20.5099L-6.35266 -0.910989L1.81344 5.68937ZM13.2545 6.95819C13.2822 7.19772 13.292 7.67349 13.1257 8.28164C12.9565 8.90019 12.6673 9.42675 12.358 9.81616C11.7958 10.524 11.5028 10.3875 12.5259 10.0265L5.53703 -9.77646C2.2238 -8.60716 -1.39409 -6.63437 -4.08642 -3.24452C-6.98855 0.40949 -8.12848 4.85986 -7.60634 9.37214L13.2545 6.95819ZM0.826393 -6.42686C-1.65238 -3.32263 -2.54237 0.315635 -2.17152 3.78195C-1.85789 6.71336 -0.68456 9.04479 -0.0650136 10.2073C0.277909 10.8508 0.640902 11.4703 0.867475 11.86C1.13434 12.319 1.27354 12.5634 1.37772 12.7626C1.65447 13.2918 1.20078 12.6323 1.09862 11.3312L22.0342 9.68741C21.7964 6.65899 20.626 4.25356 19.9871 3.03158C19.6334 2.35521 19.2649 1.72262 19.0222 1.30504C18.7391 0.818161 18.5904 0.561448 18.4674 0.330666C18.1552 -0.2553 18.5796 0.335673 18.7093 1.54798C18.7864 2.26865 18.7629 3.20181 18.4746 4.2272C18.1839 5.2608 17.7088 6.08537 17.2365 6.67686L0.826393 -6.42686ZM20.5414 15.9591C22.4235 12.8595 23.0154 9.51254 23.127 6.59725L2.14231 5.79448C2.12793 6.17044 2.09258 6.24601 2.12617 6.11175C2.16359 5.96219 2.28346 5.56675 2.59144 5.05956L20.5414 15.9591ZM3.87202 11.9809C3.30365 11.12 3.25628 9.98182 3.77147 9.00356C4.04708 8.48024 4.53242 7.90714 5.27214 7.49089C6.05807 7.04865 6.81694 6.96165 7.28418 7.00531L5.33041 27.9142C12.9921 28.6301 19.3015 24.5819 22.3523 18.7889C25.2629 13.2622 25.217 6.19658 21.3972 0.410827L3.87202 11.9809ZM14.9955 11.5636C14.6114 10.9977 14.2795 10.4645 14.0281 10.0352C13.7477 9.5565 13.6586 9.36279 13.7013 9.45495L-5.35236 18.2843C-4.72457 19.6391 -3.61284 21.5407 -2.38092 23.356L14.9955 11.5636ZM-5.38471 9.52544C-5.37365 9.50111 -5.09339 8.86264 -4.36791 8.06172C-3.62758 7.24441 -1.99594 5.80602 0.639226 5.28692C6.55231 4.12213 9.68297 8.4552 9.83039 8.65861C10.1659 9.12159 10.3268 9.46651 10.3777 9.58078C10.4389 9.71806 10.4579 9.78722 10.4583 9.7885C10.4597 9.79356 10.4637 9.80599 10.4701 9.84728C10.4746 9.87578 10.5 10.0398 10.5 10.3323H-10.5C-10.5 12.2168 -10.1654 14.0576 -9.72284 15.5956C-9.30113 17.0612 -8.54163 19.0943 -7.17349 20.9821C-6.23538 22.2765 -2.18756 27.2473 4.69793 25.891C10.6414 24.7202 13.0714 19.6712 13.7337 18.2138L-5.38471 9.52544ZM10.5 10.3323C10.5 11.0155 10.3452 11.5439 10.2123 11.8622C10.1475 12.0174 10.0871 12.1257 10.048 12.1894C10.009 12.253 9.98339 12.285 9.97954 12.2897L-6.35266 -0.910989C-8.32554 1.52989 -10.5 5.38461 -10.5 10.3323H10.5ZM-8.62332 6.84009C-8.5115 7.85422 -8.27754 9.40204 -7.65492 11.0288C-7.08521 12.5174 -5.62151 15.5616 -2.1156 17.4307L7.76372 -1.10035C10.6867 0.457937 11.7134 2.88422 11.9577 3.5226C12.255 4.29921 12.2751 4.76453 12.2502 4.53865L-8.62332 6.84009Z" fill="#737373" mask="url(#path-1-inside-1_124_4026)" /></g><defs><clipPath id="clip0_124_4026"><rect width="14" height="18" fill="white" transform="translate(0 0.125)" /></clipPath></defs></svg></> },
  { value: "warmuphaserrors", label: "Warmup has errors", icon: <><svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_124_4028)"><mask id="path-1-inside-1_124_4028" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.82406 8.16516C2.38182 4.34342 4.6951 1.65539 9.03146 0.125C6.37547 3.45116 11.2952 7.05468 11.5664 10.5093C12.2022 9.46219 12.5632 8.0638 12.6346 6.19586C15.886 11.1207 12.6317 18.0507 6.30729 17.4598C5.26823 15.9287 4.48438 14.5384 4.17448 13.8696C2.15104 18.3221 0 13.1315 0 10.3323C0 8.54811 0.790417 6.95507 1.81344 5.68937C1.95016 6.92938 2.24109 7.85437 2.82406 8.16516Z" /></mask><path d="M2.82406 8.16516L-2.1156 17.4307L15.5565 26.8521L13.2545 6.95819L2.82406 8.16516ZM9.03146 0.125L17.2365 6.67686L40.1209 -21.9818L5.53703 -9.77646L9.03146 0.125ZM11.5664 10.5093L1.09862 11.3312L3.64661 43.7823L20.5414 15.9591L11.5664 10.5093ZM12.6346 6.19586L21.3972 0.410827L3.39161 -26.8624L2.14231 5.79448L12.6346 6.19586ZM6.30729 17.4598L-2.38092 23.356L0.399851 27.4535L5.33041 27.9142L6.30729 17.4598ZM4.17448 13.8696L13.7013 9.45495L4.0815 -11.3045L-5.38471 9.52544L4.17448 13.8696ZM1.81344 5.68937L12.2502 4.53865L9.48843 -20.5099L-6.35266 -0.910989L1.81344 5.68937ZM13.2545 6.95819C13.2822 7.19772 13.292 7.67349 13.1257 8.28164C12.9565 8.90019 12.6673 9.42675 12.358 9.81616C11.7958 10.524 11.5028 10.3875 12.5259 10.0265L5.53703 -9.77646C2.2238 -8.60716 -1.39409 -6.63437 -4.08642 -3.24452C-6.98855 0.40949 -8.12848 4.85986 -7.60634 9.37214L13.2545 6.95819ZM0.826393 -6.42686C-1.65238 -3.32263 -2.54237 0.315635 -2.17152 3.78195C-1.85789 6.71336 -0.68456 9.04479 -0.0650136 10.2073C0.277909 10.8508 0.640902 11.4703 0.867475 11.86C1.13434 12.319 1.27354 12.5634 1.37772 12.7626C1.65447 13.2918 1.20078 12.6323 1.09862 11.3312L22.0342 9.68741C21.7964 6.65899 20.626 4.25356 19.9871 3.03158C19.6334 2.35521 19.2649 1.72262 19.0222 1.30504C18.7391 0.818161 18.5904 0.561448 18.4674 0.330666C18.1552 -0.2553 18.5796 0.335673 18.7093 1.54798C18.7864 2.26865 18.7629 3.20181 18.4746 4.2272C18.1839 5.2608 17.7088 6.08537 17.2365 6.67686L0.826393 -6.42686ZM20.5414 15.9591C22.4235 12.8595 23.0154 9.51254 23.127 6.59725L2.14231 5.79448C2.12793 6.17044 2.09258 6.24601 2.12617 6.11175C2.16359 5.96219 2.28346 5.56675 2.59144 5.05956L20.5414 15.9591ZM3.87202 11.9809C3.30365 11.12 3.25628 9.98182 3.77147 9.00356C4.04708 8.48024 4.53242 7.90714 5.27214 7.49089C6.05807 7.04865 6.81694 6.96165 7.28418 7.00531L5.33041 27.9142C12.9921 28.6301 19.3015 24.5819 22.3523 18.7889C25.2629 13.2622 25.217 6.19658 21.3972 0.410827L3.87202 11.9809ZM14.9955 11.5636C14.6114 10.9977 14.2795 10.4645 14.0281 10.0352C13.7477 9.5565 13.6586 9.36279 13.7013 9.45495L-5.35236 18.2843C-4.72457 19.6391 -3.61284 21.5407 -2.38092 23.356L14.9955 11.5636ZM-5.38471 9.52544C-5.37365 9.50111 -5.09339 8.86264 -4.36791 8.06172C-3.62758 7.24441 -1.99594 5.80602 0.639226 5.28692C6.55231 4.12213 9.68297 8.4552 9.83039 8.65861C10.1659 9.12159 10.3268 9.46651 10.3777 9.58078C10.4389 9.71806 10.4579 9.78722 10.4583 9.7885C10.4597 9.79356 10.4637 9.80599 10.4701 9.84728C10.4746 9.87578 10.5 10.0398 10.5 10.3323H-10.5C-10.5 12.2168 -10.1654 14.0576 -9.72284 15.5956C-9.30113 17.0612 -8.54163 19.0943 -7.17349 20.9821C-6.23538 22.2765 -2.18756 27.2473 4.69793 25.891C10.6414 24.7202 13.0714 19.6712 13.7337 18.2138L-5.38471 9.52544ZM10.5 10.3323C10.5 11.0155 10.3452 11.5439 10.2123 11.8622C10.1475 12.0174 10.0871 12.1257 10.048 12.1894C10.009 12.253 9.98339 12.285 9.97954 12.2897L-6.35266 -0.910989C-8.32554 1.52989 -10.5 5.38461 -10.5 10.3323H10.5ZM-8.62332 6.84009C-8.5115 7.85422 -8.27754 9.40204 -7.65492 11.0288C-7.08521 12.5174 -5.62151 15.5616 -2.1156 17.4307L7.76372 -1.10035C10.6867 0.457937 11.7134 2.88422 11.9577 3.5226C12.255 4.29921 12.2751 4.76453 12.2502 4.53865L-8.62332 6.84009Z" fill="#FFAAB4" mask="url(#path-1-inside-1_124_4028)" /></g><defs><clipPath id="clip0_124_4028"><rect width="14" height="18" fill="white" transform="translate(0 0.125)" /></clipPath></defs></svg></> },
  { value: "salesaicamp", label: "Sales AI Camp...", icon: <><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.875 5.375C14.1734 5.375 14.4595 5.25647 14.6705 5.0455C14.8815 4.83452 15 4.54837 15 4.25C15 3.95163 14.8815 3.66548 14.6705 3.4545C14.4595 3.24353 14.1734 3.125 13.875 3.125C13.5766 3.125 13.2905 3.24353 13.0795 3.4545C12.8685 3.66548 12.75 3.95163 12.75 4.25C12.75 4.54837 12.8685 4.83452 13.0795 5.0455C13.2905 5.25647 13.5766 5.375 13.875 5.375ZM1.9425 8.81L8.6925 2.06C8.9625 1.79 9.3375 1.625 9.75 1.625H15C15.8325 1.625 16.5 2.2925 16.5 3.125V8.375C16.5 8.7875 16.335 9.1625 16.0575 9.4325L9.315 16.1825C9.0375 16.4525 8.6625 16.625 8.25 16.625C7.8375 16.625 7.4625 16.4525 7.1925 16.1825L1.9425 10.9325C1.665 10.6625 1.5 10.2875 1.5 9.875C1.5 9.455 1.6725 9.08 1.9425 8.81Z" fill="var(--sa-dark-accent-light)" /></svg></> },
  { value: "notag", label: "No Tag", icon: <><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.875 5.375C14.1734 5.375 14.4595 5.25647 14.6705 5.0455C14.8815 4.83452 15 4.54837 15 4.25C15 3.95163 14.8815 3.66548 14.6705 3.4545C14.4595 3.24353 14.1734 3.125 13.875 3.125C13.5766 3.125 13.2905 3.24353 13.0795 3.4545C12.8685 3.66548 12.75 3.95163 12.75 4.25C12.75 4.54837 12.8685 4.83452 13.0795 5.0455C13.2905 5.25647 13.5766 5.375 13.875 5.375ZM1.9425 8.81L8.6925 2.06C8.9625 1.79 9.3375 1.625 9.75 1.625H15C15.8325 1.625 16.5 2.2925 16.5 3.125V8.375C16.5 8.7875 16.335 9.1625 16.0575 9.4325L9.315 16.1825C9.0375 16.4525 8.6625 16.625 8.25 16.625C7.8375 16.625 7.4625 16.4525 7.1925 16.1825L1.9425 10.9325C1.665 10.6625 1.5 10.2875 1.5 9.875C1.5 9.455 1.6725 9.08 1.9425 8.81Z" fill="#242424" /></svg></> },
];


// Dropdown options
const optionsWeeks = [
  { value: "Last4weeks", label: "Last 4 weeks" },
  { value: "Last7days", label: "Last 7 days" },
  { value: "Monthtodate", label: "Month to date" },
  { value: "Last4weeks", label: "Last 4 weeks" },
  { value: "Last3months", label: "Last 3 months" },
  { value: "Last6months", label: "Last 6 months" },
  { value: "Last12months", label: "Last 12 months" },
  { value: "Custom", label: "Custom" },
];

// Dropdown options
const optionsSalesAI = [
  { value: "Sales AI", label: "Sales AI" },
  { value: "Sales AI", label: "Sales AI" },
  { value: "Sales AI", label: "Sales AI" },
  { value: "Sales AI", label: "Sales AI" },
  { value: "Sales AI", label: "Sales AI" },
  { value: "Sales AI", label: "Sales AI" },
  { value: "Sales AI", label: "Sales AI" },
  { value: "Sales AI", label: "Sales AI" },
];


let main_chart = {
  series: [{
    name: 'series1',
    data: [31, 40, 28, 51, 42, 109, 100]
  }, {
    name: 'series2',
    data: [11, 32, 45, 32, 34, 52, 41]
  }],
  options: {
    chart: {
      height: 350,
      type: 'area'
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth'
    },
    fill: {
      type: 'gradient',
    },
    xaxis: {
      type: 'datetime',
      categories: ["2018-09-19T00:00:00.000Z", "2018-09-19T01:30:00.000Z", "2018-09-19T02:30:00.000Z", "2018-09-19T03:30:00.000Z", "2018-09-19T04:30:00.000Z", "2018-09-19T05:30:00.000Z", "2018-09-19T06:30:00.000Z"]
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy HH:mm'
      },
    },
  },
};

const Campaign = ({ isVisible, setIsVisible, ...props }) => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [voice, setVoice] = useState("female");
  const [anchorEl, setAnchorEl] = useState(null);
  const [contactsData, setcontactsData] = useState([]);
  const [tone, setTone] = useState("Professional");
  const [callType, setCallType] = useState("Demo");
  const [modalAddNew, setModalAddNew] = useState(false);
  const [modalAddSms, setModalAddSms] = useState(false);
  const [modalAddCall, setModalAddCall] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [valuecontactDetails, setValuecontactDetails] = useState(0);
  const [enableDisable, setEnableDisable] = useState("Enable");
  const [isModalShareCart, setModalShareCart] = useState(false);
  const [valueAiPromptsTab, setValueAiPromptsTab] = useState(0);
  const [anchorPopularity, setAnchorPopularity] = useState(null);
  const [valueAgentDetailTab, setValueAgentDetailTab] = useState(0);
  const [isVisibleEmailBox, setIsVisibleEmailBox] = useState(false);
  const { allCampaign, campaignLogs } = useSelector(st => st.Campaign);
  const singleTask = useSelector((state) => state.Campaign.singleTask);
  const [isVisibleCompanyBox, setIsVisibleCompanyBox] = useState(false);
  const [modalAIPromptsModal, setModalAIPromptsModal] = useState(false);
  const toggleDropDwon = () => setDropdownOpen((prevState) => !prevState);
  const [isVisiblecontactsFilter, setIsVisiblecontactsFilter] = useState(false);
  const [modalRightcontactsDetails, setModalRightcontactsDetails] = useState(false);
  const [valueStepAnalyticsTab, setValueStepAnalyticsTabsSet] = useState(0);
  const [isVisibleCompanyTemplate, setIsVisibleCompanyTemplate] = useState(false);
  const [modalAllStatusesFiltters, setModalAllStatusesFiltters] = useState(false);
  const [isVisibleMoreOptions, setIsVisibleMoreOptions] = useState(false)


  const handleClick = () => history.push('/campaign');  // Navigate to /campaign

  useEffect(() => { dispatch(getAllEmailCampaign()) }, []);
  useEffect(() => { if (campaignLogs) setLogs(campaignLogs) }, [campaignLogs]);

  useEffect(() => {
    dispatch(getSingleTask(id));
  }, [dispatch, id]);

  const toggleSchedulingModal = () => {
    setIsSchedulingModalOpen((prevState) => !prevState);
    setIsScheduleConfirmed(false);
  };
  const handleScheduleConfirm = () => {
    console.log("Email scheduled for:", scheduledDate);
    setIsScheduleConfirmed(true);
    setTimeout(() => {
      toggleSchedulingModal();
    }, 1500);
  };

  const fetchcontacts = () => {
    dispatch(getSingleTask(id));
  };

  useEffect(() => {
    if (singleTask && singleTask.contact || null) {
      setcontactsData(singleTask.contact);
    } else {
      setcontactsData([]);
    }
  }, [singleTask]);

  const handleChangeButtonDisbled = (event, newEnableDisable) => {
    if (newEnableDisable !== null) {
      setEnableDisable(newEnableDisable);
    }
  };

  const handleClickMoreOptions = () => {
    setIsVisibleMoreOptions(!isVisibleMoreOptions)
  }

  const handleValueAgentDetailSet = (event, newValueAgentDetail) => {
    setValueAgentDetailTab(newValueAgentDetail);
  };

  const handleAiPromptsTabsSet = (event, newAiPromptsTabsSet) => {
    setValueAiPromptsTab(newAiPromptsTabsSet);
  };

  const handlecontactDetailsTabsSet = (event, newcontactDetails) => {
    setValuecontactDetails(newcontactDetails);
  };

  const handleStepAnalyticsTabsSet = (event, newcontactDetails) => {
    setValueStepAnalyticsTabsSet(newcontactDetails);
  };

  const handleOpenPopularity = (event) => {
    setAnchorPopularity(event.currentTarget);
  };


  const [subject, setSubject] = useState("Revolutionize Your Real Estate Contact Generation with AI 🚀");
  const [body, setBody] = useState(
    "Hi {{firstName}},\n\n" +
    "I see you’re the {{Job Title}} at {{CompanyName}}, which makes me excited to reach out and share how our AI agents can transform your contact generation. Imagine an AI agent driving contact generation, nurturing prospects, and closing deals—completely on autopilot.\n\n" +
    "Our AI SDR Agent acts as your dedicated partner, helping you:\n\n" +
    "• Automatically sync contacts into your CRM.\n" +
    "• Make calls to prospects, ensuring continuous engagement.\n" +
    "• Log every conversation in your CRM, keeping a complete record.\n" +
    "• Use various communication channels (SMS, WhatsApp, email, etc.).\n" +
    "• Recommend prospects based on client budget, location, and long-term goals.\n\n" +
    "Want to see it in action? Let’s book a 15-minute demo!\n\n" +
    "Looking forward to helping you scale your real estate business!\n\n" +
    "Warm regards,\n\n" +
    "{{accountSignature}}"
  );

  const [subjectStep2, setSubjectStep2] = useState("Thank You for Considering Our AI Solution");
  const [bodyStep2, setBodyStep2] = useState(
    "Hi {{firstName}},\n\n" +
    "I hope this message finds you well! I understand you’re likely busy, and I appreciate you taking the time to consider how our AI-powered platform could elevate your real estate contact generation.\n\n" +
    "If you're tied up with other tasks, I completely understand! However, if you're interested in learning how our AI Agent can optimize your time and accelerate your business, I’m available to assist.\n\n" +
    "You can schedule a 15-minute demo at your convenience, and I’ll be happy to demonstrate how our AI Agent can benefit your real estate business.\n\n" +
    "Looking forward to connecting with you!\n\n" +
    "Warm regards,\n\n" +
    "{{accountSignature}}"
  );

  const toggcontactdCall = () => setModalAddCall(!modalAddCall);
  const toggcontactdSms = () => setModalAddSms(!modalAddSms);

  const handleChange = (event, newVoice) => {
    if (newVoice !== null) {
      setVoice(newVoice);
    }
  };

  const handleChangeTone = (event, newTone) => {
    if (newTone !== null) {
      setTone(newTone);
    }
  };

  const handleChangeType = (event, newCallType) => {
    if (newCallType !== null) {
      setCallType(newCallType);
    }
  };


  const columns = [{
    id: 'firstName',
    minWidth: 80,
    Header: 'First Name',
    accessor: 'firstName',
  },
  {
    id: 'lastName',
    Header: 'Last Name',
    minWidth: 80,
    accessor: 'lastName',
  },
  {
    id: 'email',
    Header: 'Email',
    minWidth: 100,
    accessor: 'email'
  },
  {
    id: 'phone',
    minWidth: 80,
    Header: 'Phone',
    accessor: 'phone'
  },
  {
    id: 'status',
    minWidth: 80,
    Header: 'Status',
    accessor: 'status'

  },
  ];

  const columnAnalytics = [{
    id: 'step',
    minWidth: 100,
    Header: 'STEP',
    accessor: campaign =>
      <div className='switchbox' >
        <Switch />
        Step 1
      </div>
  },
  {
    id: 'sent',
    minWidth: 50,
    Header: 'SENT',
    accessor: campaign =>
      '894'
  },
  {
    id: 'opened',
    minWidth: 100,
    Header: 'OPENED',
    accessor: campaign =>
      <p>316  <span>| 35.3%</span></p>
  },

  {
    id: 'replied',
    minWidth: 50,
    Header: 'REPLIED',
    accessor: campaign =>
      '0'
  },

  {
    id: 'clicked',
    minWidth: 100,
    Header: 'CLICKED',
    accessor: campaign =>
      <p>61  <span>| 6.8%</span></p>
  },
  {
    id: 'opportunities',
    minWidth: 40,
    Header: 'OPPORTUNITIES',
    accessor: campaign =>
      '0'
  }];


  const columnActivity = [{
    id: 'step',
    minWidth: 100,
    Header: 'STEP',
    accessor: campaign =>
      <div className='switchbox' >
        <Switch />
        Step 2
      </div>
  },
  {
    id: 'sent',
    minWidth: 50,
    Header: 'SENT',
    accessor: campaign =>
      '694'
  },
  {
    id: 'opened',
    minWidth: 100,
    Header: 'OPENED',
    accessor: campaign =>
      <p>416  <span>| 45.3%</span></p>
  },

  {
    id: 'replied',
    minWidth: 50,
    Header: 'REPLIED',
    accessor: campaign =>
      '10'
  },

  {
    id: 'clicked',
    minWidth: 100,
    Header: 'CLICKED',
    accessor: campaign =>
      <p>81  <span>| 9.8%</span></p>
  },
  {
    id: 'opportunities',
    minWidth: 40,
    Header: 'OPPORTUNITIES',
    accessor: campaign =>
      '5'
  }];

  const handleCSVUpload = (csvData) => {
    Papa.parse(csvData, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const parsedData = [];
        let hasErrors = false;

        results.data.forEach((row, index) => {
          const firstName = row['First Name']?.trim() || '';
          const lastName = row['Last Name']?.trim() || '';
          const email = row['Email']?.trim() || '';
          const phone = row['Phone']?.trim() || '';

          if (!firstName || !lastName || !phone || !email) {
            const missingFields = [];
            if (!firstName) missingFields.push('First Name');
            if (!lastName) missingFields.push('Last Name');
            if (!phone) missingFields.push('Phone');
            if (!email) missingFields.push('Email');

            console.error(`Error in row ${index + 1}: Missing ${missingFields.join(', ')}`);
            toast.error(`Error in row ${index + 1}: Missing ${missingFields.join(', ')}`);
            hasErrors = true;
            return;
          }

          parsedData.push({
            firstName,
            lastName,
            email,
            phone,
            campaignId: id,
          });
        });

        if (!hasErrors && parsedData.length > 0) {
          console.log('Parsed contacts:', parsedData);
          parsedData.forEach((contactData) => {
            dispatch(createContact({
              data: contactData,
              successCallback: () => {
                console.log('Contact created successfully:', contactData);
                fetchcontacts();
              },
              failCallback: () => {
                console.log('Failed to create contact:', contactData);
                toast.error('Failed to create contact.');
              },
            }));
          });
        } else {
          console.error('Parsing aborted due to missing required fields.');
        }
      },
      error: (error) => {
        console.error('Error parsing CSV:', error);
      },
    });
  };

  const handleClosePopularity = () => {
    setAnchorPopularity(null);
  };

  const [checkedItems, setCheckedItems] = useState({
    "Sequence started": true,
    "Open rate": true,
    "Click rate": true,
    "Reply rate": true,
    "Positive Reply Rate": false,
    "Opportunities": false,
    "Conversions": false,
  });

  const [checkedItemsPopularity, setCheckedItemsPopularity] = useState({
    "Popularity": false,
    "Runs": false,
    "Name": false,
  });


  const filteredItems = Object.keys(checkedItems).filter((item) =>
    item.toLowerCase().includes(search.toLowerCase())
  );

  const filteredItemsPopularity = Object.keys(checkedItemsPopularity).filter((item) =>
    item.toLowerCase().includes(search.toLowerCase())
  );

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (item) => {
    setCheckedItems((prev) => ({ ...prev, [item]: !prev[item] }));
  };

  const toggleModalShareCart = () => setModalShareCart(!isModalShareCart);
  const toggcontactdNew = () => setModalAddNew(!modalAddNew);
  const toggleAIPrompts = () => setModalAIPromptsModal(!modalAIPromptsModal);
  const toggleWarmup = () => setModalRightcontactsDetails(!modalRightcontactsDetails);
  const toggleAllFilters = () => setModalAllStatusesFiltters(!modalAllStatusesFiltters);


  return (
    <div className='main-container'>
      <div className='page-header-new '>
        <h2>
          <button onClick={handleClick} className='back-btn'>
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 13L1 7L7 1" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          {singleTask ? singleTask.name : "Loading..."}
        </h2>
        <WorkspaceHeader />
      </div>
      <div className='bottom-content-area'>
        <div className='tabs-box'>
          <div className='tabs-email'>
            <AppBar position="static">
              <Tabs value={valueAgentDetailTab} onChange={handleValueAgentDetailSet} aria-label="simple tabs example">
                <Tab label="Insights" />
                <Tab label="People" />
                <Tab label="Sequences" />
                <Tab label="Schedule" />
                <Tab label="Options" />
              </Tabs>
            </AppBar>
          </div>
          <div className='right-btn right-btn-sharing'>
            <Autocomplete
              options={optionsStatus}
              getOptionLabel={(optionsStatus) => optionsStatus.label}
              componentsProps={{
                paper: {
                  sx: {
                    width: 230
                  }
                }
              }}
              sx={{ minWidth: 200 }}
              renderOption={(props, optionsStatus) => (
                <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <i style={{ marginRight: '10px' }}>{optionsStatus.icon}</i>
                  <Typography style={{ fontSize: '14px' }}>{optionsStatus.label}</Typography>
                </Box>
              )}
              renderInput={(params) => {
                const selectedOption = optionsStatus.find((opt) => opt.label === params.inputProps.value);
                return (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: selectedOption ? (
                        <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                      ) : null,
                    }}
                    label="Pause campaign"
                    variant="outlined"
                  />
                );
              }}
            />

            <Dropdown className="create-btn" isOpen={dropdownOpen} toggle={toggleDropDwon}>
              <DropdownToggle caret>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.99996 10.8332C10.4602 10.8332 10.8333 10.4601 10.8333 9.99984C10.8333 9.5396 10.4602 9.1665 9.99996 9.1665C9.53972 9.1665 9.16663 9.5396 9.16663 9.99984C9.16663 10.4601 9.53972 10.8332 9.99996 10.8332Z" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.8333 10.8332C16.2936 10.8332 16.6667 10.4601 16.6667 9.99984C16.6667 9.5396 16.2936 9.1665 15.8333 9.1665C15.3731 9.1665 15 9.5396 15 9.99984C15 10.4601 15.3731 10.8332 15.8333 10.8332Z" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M4.16671 10.8332C4.62694 10.8332 5.00004 10.4601 5.00004 9.99984C5.00004 9.5396 4.62694 9.1665 4.16671 9.1665C3.70647 9.1665 3.33337 9.5396 3.33337 9.99984C3.33337 10.4601 3.70647 10.8332 4.16671 10.8332Z" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <Link to="#" className='sharing-btn'>
                    <i className='icon'>
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.75 11.25V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V11.25" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M5.25 7.5L9 11.25L12.75 7.5" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9 11.25V2.25" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </i>
                    Download analytics CSV
                  </Link>
                </DropdownItem>
                <DropdownItem>
                  <Link to="#" className='sharing-btn'>
                    <i className='icon'>
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.5 6C14.7426 6 15.75 4.99264 15.75 3.75C15.75 2.50736 14.7426 1.5 13.5 1.5C12.2574 1.5 11.25 2.50736 11.25 3.75C11.25 4.99264 12.2574 6 13.5 6Z" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4.5 11.25C5.74264 11.25 6.75 10.2426 6.75 9C6.75 7.75736 5.74264 6.75 4.5 6.75C3.25736 6.75 2.25 7.75736 2.25 9C2.25 10.2426 3.25736 11.25 4.5 11.25Z" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M13.5 16.5C14.7426 16.5 15.75 15.4926 15.75 14.25C15.75 13.0074 14.7426 12 13.5 12C12.2574 12 11.25 13.0074 11.25 14.25C11.25 15.4926 12.2574 16.5 13.5 16.5Z" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.44238 10.1323L11.5649 13.1173" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M11.5574 4.88232L6.44238 7.86732" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </i>
                    Sharing Campaign
                  </Link>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        <div className='tabs-content'>
          <TabPanel value={valueAgentDetailTab} index={0}>
            <div className='anylatics-panel'>
              <div className='allemails-area'>
                <div className="subcjt-area">
                  <div className="subcjt-box">
                    <h4>Subject:</h4>
                    <button className="btn-style-new">
                      <i className="icon">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.19224 12.1273C10.1838 12.1273 12.6089 9.70215 12.6089 6.71061C12.6089 3.71907 10.1838 1.29395 7.19224 1.29395C4.2007 1.29395 1.77557 3.71907 1.77557 6.71061C1.77557 9.70215 4.2007 12.1273 7.19224 12.1273Z" fill="white" />
                          <path d="M7.19238 8.8776V6.71094" stroke="var(--sa-dark-accent-light)" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M7.19238 4.54395H7.1978" stroke="var(--sa-dark-accent-light)" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </i>
                      Active
                    </button>
                    <div className='content-area content-progress'>
                      <LinearProgressWithLabel value={30} />
                    </div>
                  </div>

                  <div className='right-btn-area'>
                    <button className='share-btn' onClick={toggleModalShareCart}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 6.66699C16.3807 6.66699 17.5 5.5477 17.5 4.16699C17.5 2.78628 16.3807 1.66699 15 1.66699C13.6193 1.66699 12.5 2.78628 12.5 4.16699C12.5 5.5477 13.6193 6.66699 15 6.66699Z" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M5 12.5C6.38071 12.5 7.5 11.3807 7.5 10C7.5 8.61929 6.38071 7.5 5 7.5C3.61929 7.5 2.5 8.61929 2.5 10C2.5 11.3807 3.61929 12.5 5 12.5Z" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M15 18.333C16.3807 18.333 17.5 17.2137 17.5 15.833C17.5 14.4523 16.3807 13.333 15 13.333C13.6193 13.333 12.5 14.4523 12.5 15.833C12.5 17.2137 13.6193 18.333 15 18.333Z" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.15833 11.2588L12.85 14.5755" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12.8417 5.4248L7.15833 8.74147" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Share
                    </button>
                    <Autocomplete
                      options={optionsWeeks}
                      getOptionLabel={(optionsWeeks) => optionsWeeks.label}
                      componentsProps={{
                        paper: {
                          sx: {
                            width: 230
                          }
                        }
                      }}
                      sx={{ minWidth: 150 }}
                      renderOption={(props, optionsWeeks) => (
                        <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <i style={{ marginRight: '10px' }}>{optionsWeeks.icon}</i>
                          <Typography style={{ fontSize: '14px' }}>{optionsWeeks.label}</Typography>
                        </Box>
                      )}
                      renderInput={(params) => {
                        const selectedOption = optionsWeeks.find((opt) => opt.label === params.inputProps.value);
                        return (
                          <TextField
                            {...params}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: selectedOption ? (
                                <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                              ) : null,
                            }}
                            label="Last 4 weeks"
                            variant="outlined"
                          />
                        );
                      }}
                    />

                    <button className='setting-btn' onClick={handleOpen}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8992 1.79366C11.5909 1.66699 11.1992 1.66699 10.4167 1.66699C9.63419 1.66699 9.24335 1.66699 8.93419 1.79366C8.73076 1.87678 8.54578 1.99931 8.38989 2.1542C8.234 2.30909 8.11028 2.49327 8.02585 2.69616C7.94752 2.88199 7.91752 3.09949 7.90502 3.41533C7.89907 3.64408 7.83507 3.86756 7.71904 4.06479C7.60301 4.26202 7.43875 4.42651 7.24168 4.54283C7.04064 4.65458 6.81464 4.71378 6.58462 4.71495C6.35461 4.71611 6.12802 4.6592 5.92585 4.54949C5.64419 4.40116 5.44002 4.31949 5.23835 4.29283C4.79717 4.23526 4.35107 4.35382 3.99669 4.62283C3.73169 4.82449 3.53585 5.16116 3.14502 5.83366C2.75335 6.50616 2.55835 6.84199 2.51419 7.17116C2.45585 7.60949 2.57585 8.05282 2.84752 8.40366C2.97085 8.56366 3.14502 8.69783 3.41419 8.86616C3.81169 9.11366 4.06669 9.53533 4.06669 10.0003C4.06669 10.4653 3.81169 10.887 3.41502 11.1337C3.14502 11.3028 2.97085 11.437 2.84669 11.597C2.71299 11.7705 2.61481 11.9687 2.55776 12.1801C2.5007 12.3916 2.4859 12.6123 2.51419 12.8295C2.55835 13.1578 2.75335 13.4945 3.14502 14.167C3.53669 14.8395 3.73169 15.1753 3.99669 15.3778C4.35002 15.647 4.79669 15.7653 5.23835 15.7078C5.44002 15.6812 5.64419 15.5995 5.92585 15.4512C6.12812 15.3413 6.35487 15.2843 6.58504 15.2855C6.81522 15.2866 7.04137 15.3459 7.24252 15.4578C7.64752 15.6912 7.88752 16.1203 7.90502 16.5853C7.91752 16.902 7.94752 17.1187 8.02585 17.3045C8.19585 17.7128 8.52252 18.0378 8.93419 18.207C9.24252 18.3337 9.63419 18.3337 10.4167 18.3337C11.1992 18.3337 11.5909 18.3337 11.8992 18.207C12.1026 18.1239 12.2876 18.0013 12.4435 17.8465C12.5994 17.6916 12.7231 17.5074 12.8075 17.3045C12.8859 17.1187 12.9159 16.902 12.9284 16.5853C12.945 16.1203 13.1859 15.6903 13.5917 15.4578C13.7927 15.3461 14.0187 15.2869 14.2487 15.2857C14.4788 15.2845 14.7053 15.3414 14.9075 15.4512C15.1892 15.5995 15.3934 15.6812 15.595 15.7078C16.0367 15.7662 16.4834 15.647 16.8367 15.3778C17.1017 15.1762 17.2975 14.8395 17.6884 14.167C18.08 13.4945 18.275 13.1587 18.3192 12.8295C18.3474 12.6122 18.3324 12.3915 18.2752 12.1801C18.218 11.9686 18.1197 11.7704 17.9859 11.597C17.8625 11.437 17.6884 11.3028 17.4192 11.1345C17.0217 10.887 16.7667 10.4653 16.7667 10.0003C16.7667 9.53533 17.0217 9.11366 17.4184 8.86699C17.6884 8.69783 17.8625 8.56366 17.9867 8.40366C18.1204 8.23015 18.2186 8.03199 18.2756 7.8205C18.3327 7.60902 18.3475 7.38837 18.3192 7.17116C18.275 6.84282 18.08 6.50616 17.6884 5.83366C17.2967 5.16116 17.1017 4.82533 16.8367 4.62283C16.4823 4.35382 16.0362 4.23526 15.595 4.29283C15.3934 4.31949 15.1892 4.40116 14.9075 4.54949C14.7052 4.65935 14.4785 4.71634 14.2483 4.71517C14.0182 4.71401 13.792 4.65473 13.5909 4.54283C13.3939 4.42641 13.2298 4.26187 13.114 4.06465C12.9981 3.86743 12.9342 3.644 12.9284 3.41533C12.9159 3.09866 12.8859 2.88199 12.8075 2.69616C12.7231 2.49327 12.5994 2.30909 12.4435 2.1542C12.2876 1.99931 12.1026 1.87678 11.8992 1.79366ZM10.4167 12.5003C11.8084 12.5003 12.9359 11.3812 12.9359 10.0003C12.9359 8.61949 11.8075 7.50033 10.4167 7.50033C9.02585 7.50033 7.89752 8.61949 7.89752 10.0003C7.89752 11.3812 9.02585 12.5003 10.4167 12.5003Z" fill="#4b5563" />
                      </svg>
                    </button>

                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                      <MenuItem>
                        <TextField
                          variant="standard"
                          placeholder="Search"
                          fullWidth
                          onChange={(e) => setSearch(e.target.value)}
                        />
                      </MenuItem>
                      {filteredItems.map((item) => (
                        <MenuItem key={item} onClick={() => handleToggle(item)}>
                          <ListItemText primary={item} />
                          <ListItemIcon>
                            <Checkbox
                              checked={checkedItems[item]}
                              icon={<CircleUnchecked />}
                              checkedIcon={<CircleCheckedFilled />}
                            />
                          </ListItemIcon>
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                </div>
                <div className='sequence-area'>
                  <div className='sequence-box'>
                    <p>Sequence started
                      <i className='icon'>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_261_22691)">
                            <path d="M8.50008 15.5837C12.4121 15.5837 15.5834 12.4123 15.5834 8.50033C15.5834 4.58831 12.4121 1.41699 8.50008 1.41699C4.58806 1.41699 1.41675 4.58831 1.41675 8.50033C1.41675 12.4123 4.58806 15.5837 8.50008 15.5837Z" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 11.3333V8.5" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 5.66699H8.50708" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_261_22691">
                              <rect width="17" height="17" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <div className='overlay-box'>
                          Number of contacts that have opened at least one email this campaign.
                        </div>
                      </i>
                    </p>
                    <h2>894</h2>
                  </div>
                  <div className='sequence-box'>
                    <p>Open rate
                      <i className='icon'>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_261_22691)">
                            <path d="M8.50008 15.5837C12.4121 15.5837 15.5834 12.4123 15.5834 8.50033C15.5834 4.58831 12.4121 1.41699 8.50008 1.41699C4.58806 1.41699 1.41675 4.58831 1.41675 8.50033C1.41675 12.4123 4.58806 15.5837 8.50008 15.5837Z" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 11.3333V8.5" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 5.66699H8.50708" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_261_22691">
                              <rect width="17" height="17" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <div className='overlay-box'>
                          Number of contacts that have opened at least one email this campaign.
                        </div>
                      </i>
                    </p>
                    <h2>35% <span>| 316</span></h2>
                  </div>
                  <div className='sequence-box'>
                    <p>Click rate
                      <i className='icon'>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_261_22691)">
                            <path d="M8.50008 15.5837C12.4121 15.5837 15.5834 12.4123 15.5834 8.50033C15.5834 4.58831 12.4121 1.41699 8.50008 1.41699C4.58806 1.41699 1.41675 4.58831 1.41675 8.50033C1.41675 12.4123 4.58806 15.5837 8.50008 15.5837Z" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 11.3333V8.5" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 5.66699H8.50708" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_261_22691">
                              <rect width="17" height="17" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <div className='overlay-box'>
                          Number of contacts that have opened at least one email this campaign.
                        </div>
                      </i>
                    </p>
                    <h2>7% <span>| 61</span></h2>
                  </div>
                  <div className='sequence-box'>
                    <p>Opportunities
                      <i className='icon'>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_261_22691)">
                            <path d="M8.50008 15.5837C12.4121 15.5837 15.5834 12.4123 15.5834 8.50033C15.5834 4.58831 12.4121 1.41699 8.50008 1.41699C4.58806 1.41699 1.41675 4.58831 1.41675 8.50033C1.41675 12.4123 4.58806 15.5837 8.50008 15.5837Z" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 11.3333V8.5" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 5.66699H8.50708" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_261_22691">
                              <rect width="17" height="17" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <div className='overlay-box'>
                          Number of contacts that have opened at least one email this campaign.
                        </div>
                      </i>
                    </p>
                    <h2>0 <span>| $0</span></h2>
                  </div>
                  <div className='sequence-box'>
                    <p>Conversions
                      <i className='icon'>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_261_22691)">
                            <path d="M8.50008 15.5837C12.4121 15.5837 15.5834 12.4123 15.5834 8.50033C15.5834 4.58831 12.4121 1.41699 8.50008 1.41699C4.58806 1.41699 1.41675 4.58831 1.41675 8.50033C1.41675 12.4123 4.58806 15.5837 8.50008 15.5837Z" stroke="#4b5563" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 11.3333V8.5" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 5.66699H8.50708" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_261_22691">
                              <rect width="17" height="17" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <div className='overlay-box'>
                          Number of contacts that have opened at least one email this campaign.
                        </div>
                      </i>
                    </p>
                    <h2>0 <span>| $0</span></h2>
                  </div>
                </div>
                <div className="chart-area">
                  <Apexcharts options={main_chart.options} series={main_chart.series} type='area' height={350} />
                </div>
                <div className="card-chart">
                  <AppBar position="static">
                    <Tabs value={valueStepAnalyticsTab} onChange={handleStepAnalyticsTabsSet} aria-label="simple tabs example">
                      <Tab label="Step Insights" />
                      <Tab label="Activity" />
                    </Tabs>
                  </AppBar>
                  <TabPanel value={valueStepAnalyticsTab} index={0}>
                    <div className="table-container">
                      <ReactTable
                        width='100'
                        className='table campaign-table responsive'
                        minRows={6}
                        columns={columnAnalytics}
                        filterable={false}
                        data={Array.isArray(allCampaign) ? allCampaign : []}
                        // defaultFilterMethod={filterCaseInsensitive}
                        resolveData={allCampaign => allCampaign.map(row => row)}
                      />
                    </div>
                  </TabPanel>
                  <TabPanel value={valueStepAnalyticsTab} index={1}>
                    <div className="table-container">
                      <ReactTable
                        width='100'
                        className='table campaign-table responsive'
                        minRows={6}
                        columns={columnActivity}
                        filterable={false}
                        data={Array.isArray(allCampaign) ? allCampaign : []}
                        // defaultFilterMethod={filterCaseInsensitive}
                        resolveData={allCampaign => allCampaign.map(row => row)}
                      />
                    </div>
                  </TabPanel>
                </div>
              </div>

              {/* --------------- Share Moodal--------------- */}
              <Modal isOpen={isModalShareCart} className={`main-modal new-user-modal modal-dialog-centered download-chart-modal`}>
                <ModalHeader toggle={toggleModalShareCart}>
                </ModalHeader>
                <ModalBody>
                  <div className='share-chart-content'>
                    <h3>Download this Chart</h3>
                    <div className='search-area'>
                      <p>Header</p>
                      <Autocomplete
                        options={optionsSalesAI}
                        getOptionLabel={(optionsSalesAI) => optionsSalesAI.label}
                        componentsProps={{
                          paper: {
                            sx: {
                              width: 230
                            }
                          }
                        }}
                        sx={{ minWidth: 150 }}
                        renderOption={(props, optionsSalesAI) => (
                          <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <i style={{ marginRight: '10px' }}>{optionsSalesAI.icon}</i>
                            <Typography style={{ fontSize: '14px' }}>{optionsSalesAI.label}</Typography>
                          </Box>
                        )}
                        renderInput={(params) => {
                          const selectedOption = optionsSalesAI.find((opt) => opt.label === params.inputProps.value);
                          return (
                            <TextField
                              {...params}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: selectedOption ? (
                                  <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                ) : null,
                              }}
                              label="Sales AI"
                              variant="outlined"
                            />
                          );
                        }}
                      />
                    </div>
                    <div className='sell-chart-area'>
                      <h3>Sales AI</h3>
                      <div className='connted-area'>
                        <div className='connted-box'>
                          <div className='icon-area'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_374_6848)">
                                <path d="M19.6878 0.122768C19.9333 0.301339 20.0337 0.539435 19.9891 0.837054L17.132 17.9799C17.0948 18.1957 16.9757 18.3631 16.7748 18.4821C16.6707 18.5417 16.5553 18.5714 16.4288 18.5714C16.347 18.5714 16.2577 18.5528 16.161 18.5156L11.1052 16.4509L8.40428 19.7433C8.27035 19.9144 8.08806 20 7.85741 20C7.76068 20 7.67883 19.9851 7.61187 19.9554C7.4705 19.9033 7.35703 19.8158 7.27147 19.6931C7.1859 19.5703 7.14312 19.4345 7.14312 19.2857V15.3906L16.786 3.57143L4.85517 13.8951L0.446692 12.0871C0.171394 11.9829 0.0225849 11.7783 0.000263517 11.4732C-0.0146174 11.1756 0.10443 10.9561 0.357406 10.8147L18.9288 0.100446C19.0404 0.0334821 19.1595 0 19.286 0C19.4348 0 19.5687 0.0409226 19.6878 0.122768Z" fill="var(--sa-dark-accent-light)" />
                              </g>
                              <defs>
                                <clipPath id="clip0_374_6848">
                                  <rect width="20" height="20" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className='text-box'>
                            <h4>1,688</h4>
                            <p>Contacted</p>
                          </div>
                        </div>
                        <div className='connted-box'>
                          <div className='icon-area'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_374_6868)">
                                <path d="M0.833313 8.0854C0.833313 6.68632 0.833313 5.98737 1.17592 5.42565C1.51738 4.86276 2.13383 4.54992 3.36675 3.92539L7.95008 1.59942C8.95613 1.0877 9.45915 0.833008 9.99998 0.833008C10.5408 0.833008 11.0438 1.08887 12.0499 1.59825L16.6332 3.92423C17.8661 4.54992 18.4826 4.86276 18.824 5.42448C19.1666 5.98853 19.1666 6.68749 19.1666 8.08656V14.5144C19.1666 16.7078 19.1666 17.8033 18.4952 18.4848C17.8237 19.1663 16.7444 19.1663 14.5833 19.1663H5.41665C3.2556 19.1663 2.17623 19.1663 1.50477 18.4848C0.833313 17.8033 0.833313 16.7078 0.833313 14.5144V8.0854Z" stroke="#99D400" strokeWidth="2" />
                                <path d="M0.833313 7.49951L3.59935 10.1817C4.02903 10.5985 4.61183 10.8327 5.21956 10.8328H14.7804C15.3881 10.8327 15.9709 10.5985 16.4006 10.1817L19.1666 7.49951" stroke="#99D400" strokeWidth="2" stroke-linecap="round" />
                              </g>
                              <defs>
                                <clipPath id="clip0_374_6868">
                                  <rect width="20" height="20" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div className='text-box'>
                            <h4>497</h4>
                            <p>Opened</p>
                          </div>
                        </div>
                        <div className='connted-box'>
                          <div className='icon-area'>
                            <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.70695 5.24064V0.833496L3.87454 5.62657L0 9.46958L3.94333 12.7291L8.70695 16.6668V12.3544C17.07 11.7292 20 16.5294 20 16.5294C20 13.5387 19.7516 10.4349 17.381 8.08471C14.6255 5.35061 10.635 5.15714 8.70695 5.24064Z" fill="#49D5A2" />
                            </svg>
                          </div>
                          <div className='text-box'>
                            <h4>0</h4>
                            <p>Replied</p>
                          </div>
                        </div>
                        <div className='connted-box'>
                          <div className='icon-area'>
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.66875 0.45752L6.775 1.82439L5.73125 2.71502L7.06875 3.03814L7.59375 4.30377L8.3125 3.13627L9.675 3.02689L8.7875 1.98252L9.10625 0.65002L7.8375 1.17189L6.66875 0.45752ZM28 1.00002C27.7348 1.00002 27.4804 1.10538 27.2929 1.29291C27.1054 1.48045 27 1.7348 27 2.00002C27 2.26524 27.1054 2.51959 27.2929 2.70713C27.4804 2.89466 27.7348 3.00002 28 3.00002C28.2652 3.00002 28.5196 2.89466 28.7071 2.70713C28.8946 2.51959 29 2.26524 29 2.00002C29 1.7348 28.8946 1.48045 28.7071 1.29291C28.5196 1.10538 28.2652 1.00002 28 1.00002ZM13.9875 1.65627C13.7223 1.65627 13.4679 1.76163 13.2804 1.94916C13.0929 2.1367 12.9875 2.39105 12.9875 2.65627C12.9875 2.92149 13.0929 3.17584 13.2804 3.36338C13.4679 3.55091 13.7223 3.65627 13.9875 3.65627C14.2527 3.65627 14.5071 3.55091 14.6946 3.36338C14.8821 3.17584 14.9875 2.92149 14.9875 2.65627C14.9875 2.39105 14.8821 2.1367 14.6946 1.94916C14.5071 1.76163 14.2527 1.65627 13.9875 1.65627ZM25.4813 2.08377C24.9063 2.19252 24.375 2.53252 23.8625 2.97627C23.3875 3.38439 22.9438 3.89252 22.5688 4.44189C21.3938 4.63002 20.2188 5.10877 19.4313 5.76252C18.425 6.58752 17.5313 8.00002 17.0438 9.45627C16.5813 9.65002 16.1438 9.88127 15.7875 10.1313C14.8188 10.8125 14.3188 12.1188 13.95 13.2563C13.5813 14.4 13.4 15.4 13.4 15.4L14.5125 15.6C14.5125 15.6 14.6813 14.6625 15.0188 13.6063C15.3625 12.55 15.9438 11.4 16.4375 11.0563C16.5188 11 16.625 10.9375 16.7188 10.8813C16.6813 11.2375 16.6813 11.5938 16.7375 11.9313C16.85 12.6438 17.2375 13.325 17.925 13.6938C18.4125 13.9563 18.9625 13.8938 19.425 13.7063C19.8875 13.5125 20.3 13.1938 20.6563 12.8188C21.0125 12.4438 21.3063 12 21.4813 11.5313C21.6563 11.0625 21.7188 10.5313 21.4938 10.0375H21.4875C21.2438 9.51252 20.775 9.17502 20.275 9.03127C19.775 8.88752 19.2375 8.89377 18.7 8.97502C18.6063 8.98752 18.5188 9.01877 18.425 9.03752C18.8875 8.05002 19.55 7.11877 20.1438 6.62502C20.5313 6.30627 21.1813 6.00002 21.875 5.77502C21.7875 6.01252 21.7188 6.25002 21.6875 6.49377C21.5875 7.15002 21.7313 7.86252 22.2563 8.35002C22.6375 8.70002 23.15 8.75627 23.6 8.68127C24.0438 8.60627 24.475 8.40627 24.8625 8.15002C25.25 7.88752 25.5938 7.56252 25.8375 7.18127C26.0813 6.80002 26.2438 6.31252 26.0875 5.82502V5.81877C25.8813 5.18939 25.3688 4.75689 24.8 4.55189C24.5563 4.46439 24.3 4.41502 24.0375 4.38564C24.2188 4.18189 24.4063 3.99127 24.5938 3.82814C25.0188 3.46314 25.45 3.23439 25.6938 3.18877L25.4813 2.08377ZM9.925 4.27439L8.975 4.87189L11.1313 8.32502L7.60625 8.50627L9.2625 12.1188L10.2875 11.6438L9.31875 9.54377L13.1063 9.35002L9.925 4.27439ZM23.45 5.48127C23.8313 5.47502 24.1688 5.51877 24.4188 5.61252C24.7563 5.73127 24.925 5.88127 25.0125 6.16252C25.0375 6.23127 25.025 6.36877 24.8938 6.57502C24.7563 6.78752 24.5125 7.02502 24.2375 7.21252C23.9563 7.40002 23.6438 7.53127 23.4125 7.56877C23.175 7.61252 23.0688 7.56877 23.0188 7.52502C22.8 7.32502 22.7375 7.07502 22.8 6.65627C22.85 6.31877 23.0063 5.91252 23.2375 5.49377C23.3125 5.49377 23.3813 5.48127 23.45 5.48127ZM4.93688 6.68752C4.67166 6.68752 4.41731 6.79288 4.22977 6.98041C4.04223 7.16795 3.93688 7.4223 3.93688 7.68752C3.93688 7.95274 4.04223 8.20709 4.22977 8.39463C4.41731 8.58216 4.67166 8.68752 4.93688 8.68752C5.06825 8.6876 5.19835 8.6618 5.31975 8.61158C5.44115 8.56136 5.55146 8.48771 5.64439 8.39485C5.73731 8.30198 5.81103 8.19171 5.86132 8.07035C5.91162 7.94898 5.9375 7.81889 5.9375 7.68752C5.9375 7.55615 5.91162 7.42606 5.86132 7.30469C5.81103 7.18333 5.73731 7.07306 5.64439 6.98019C5.55146 6.88732 5.44115 6.81368 5.31975 6.76346C5.19835 6.71324 5.06825 6.68744 4.93688 6.68752ZM27.1938 9.01252L26.2938 10.05L24.9313 9.93752L25.6438 11.1125L25.1125 12.375L26.45 12.0625L27.4875 12.9563L27.6063 11.5875L28.775 10.875L27.5125 10.3438L27.1938 9.01252ZM19.475 10.0438C19.6563 10.05 19.825 10.075 19.9563 10.1125C20.225 10.1875 20.3688 10.3 20.4688 10.5125C20.525 10.6313 20.5313 10.85 20.425 11.1375C20.3188 11.4313 20.1 11.7688 19.8375 12.05C19.575 12.3313 19.2563 12.5563 18.9938 12.6625C18.7313 12.7688 18.5688 12.7625 18.4625 12.7063H18.4563C18.0938 12.5063 17.9188 12.2188 17.85 11.7563C17.7875 11.3625 17.8313 10.8625 17.9625 10.325C18.2688 10.2188 18.575 10.1313 18.8688 10.0875C19.0875 10.0563 19.2875 10.0438 19.475 10.0438ZM6.825 13.2875C6.375 13.275 6.09375 13.3813 5.91875 13.5563C5.74375 13.7313 5.6375 14.0125 5.65 14.4625C5.6625 14.9188 5.8125 15.5188 6.1 16.1875C6.675 17.5313 7.80625 19.15 9.325 20.675C10.8438 22.1938 12.4688 23.3188 13.8125 23.8938C14.475 24.1813 15.075 24.3313 15.5313 24.3438C15.9875 24.3625 16.2625 24.25 16.4375 24.075C16.6125 23.9 16.725 23.625 16.7063 23.1688C16.6938 22.7125 16.5438 22.1125 16.2563 21.4438C15.6813 20.1063 14.5563 18.4813 13.0375 16.9625C11.5188 15.4375 9.89375 14.3125 8.55 13.7375C7.88125 13.45 7.28125 13.3 6.825 13.2875ZM21.325 15.2438L19.2625 18.6188L17.4438 16.875L16.6688 17.6875L19.4875 20.3938L21.6 16.9438L24.0188 18.9625L29.6 16.575L29.1625 15.5375L24.2063 17.6625L21.325 15.2438ZM4.83938 16.0375L3.73688 19.6563C6.325 22.725 9.34375 24.45 12.6188 25.575L13.9688 25.1625C13.775 25.0938 13.5688 25.0125 13.3625 24.925C11.8375 24.275 10.1313 23.075 8.53125 21.4688C6.925 19.8625 5.725 18.1563 5.0725 16.6313C4.98438 16.4313 4.90688 16.2313 4.83938 16.0375ZM3.35063 20.925L2.475 23.8C4.28063 25.4875 6.1625 26.25 8.1375 26.9375L10.85 26.1125C8.15 25.0125 5.6 23.4063 3.35063 20.925ZM22 21C21.7348 21 21.4804 21.1054 21.2929 21.2929C21.1054 21.4804 21 21.7348 21 22C21 22.2652 21.1054 22.5196 21.2929 22.7071C21.4804 22.8947 21.7348 23 22 23C22.2652 23 22.5196 22.8947 22.7071 22.7071C22.8946 22.5196 23 22.2652 23 22C23 21.7348 22.8946 21.4804 22.7071 21.2929C22.5196 21.1054 22.2652 21 22 21ZM2.11313 24.9938L0.845001 29.1563L6.3625 27.475C4.93938 26.9063 3.50125 26.1813 2.11313 24.9938Z" fill="#FF6C00" />
                            </svg>
                          </div>
                          <div className='text-box'>
                            <h4>0 | <span>$</span>0</h4>
                            <p>Opportunities</p>
                          </div>
                        </div>
                      </div>
                      <div className='chart-area'>
                        <Apexcharts options={main_chart.options} series={main_chart.series} type='area' height={200} />
                      </div>
                    </div>
                    <div className='btn-groups text-right'>
                      <button className='cancels-btn'>Cancel</button>
                      <button className='btn-style-new'><i className='icon'><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="white" stroke-linecap="round" stroke-linejoin="round" /><path d="M7 10L12 15L17 10" stroke="white" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 15V3" stroke="white" stroke-linecap="round" stroke-linejoin="round" /></svg></i>Download</button>
                    </div>
                  </div>
                </ModalBody>
              </Modal>
            </div>
          </TabPanel>

          {/* Contact Tab */}
          <TabPanel value={valueAgentDetailTab} index={1}>
            <div className='content'>
              <div className='allemails-area contacts-campion-page'>
                <div className='row'>
                  <div className='col-lg-6 col-md-6 col-sm-6'>
                    <div className='left-search-and-reaction'>
                      <div className='searchbox'>
                        <i className='icon'>
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_224_579)">
                              <path d="M17.8568 16.2345L13.203 11.5807C14.0782 10.377 14.5958 8.8965 14.5958 7.2975C14.5958 3.27375 11.322 0 7.2975 0C3.27375 0 0 3.27375 0 7.2975C0 11.322 3.27375 14.595 7.2975 14.595C8.823 14.595 10.2397 14.1247 11.4128 13.3215L16.0912 18L17.8568 16.2345ZM2.1405 7.2975C2.1405 4.4535 4.45425 2.13975 7.29825 2.13975C10.1423 2.13975 12.456 4.4535 12.456 7.2975C12.456 10.1415 10.1423 12.4552 7.29825 12.4552C4.4535 12.4552 2.1405 10.1415 2.1405 7.2975Z" fill="#89868D" />
                            </g>
                            <defs>
                              <clipPath id="clip0_224_579">
                                <rect width="18" height="18" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </i>
                        <TextField
                          fullWidth
                          hiddenLabel
                          placeholder='Search...'
                          variant="standard"
                          size="small"
                          // value={editState?.type || agentData?.type || ''}
                          // onChange={handleEditChange}
                          name='search'
                        />
                      </div>
                      <div className='reaction-area'>
                        <div className='reaction-box'>
                          <div className='icon'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.295 8.33333C13.1 8.33333 13.7533 8.98667 13.7533 9.79167V13.7492C13.7533 14.7439 13.3581 15.698 12.6547 16.4014C11.9513 17.1048 10.9972 17.5 10.0025 17.5C9.00768 17.5 8.05364 17.1048 7.35022 16.4014C6.6468 15.698 6.25163 14.7439 6.25163 13.7492V9.79167C6.25163 8.98667 6.90413 8.33333 7.70996 8.33333H12.295ZM5.94246 8.33333C5.64135 8.69397 5.46068 9.13981 5.42579 9.60833L5.41746 9.79167V13.7492C5.41746 14.455 5.57746 15.1233 5.86246 15.72C5.5869 15.795 5.2994 15.8328 4.99996 15.8333C4.56215 15.8333 4.12863 15.7471 3.72416 15.5795C3.31968 15.412 2.95218 15.1663 2.64264 14.8567C2.3331 14.5471 2.08759 14.1795 1.92012 13.775C1.75266 13.3705 1.66652 12.937 1.66663 12.4992V9.79167C1.66664 9.42567 1.80427 9.07307 2.05219 8.80384C2.30012 8.53461 2.64021 8.36845 3.00496 8.33833L3.12496 8.33333H5.94246ZM14.0625 8.33333H16.875C17.68 8.33333 18.3333 8.98667 18.3333 9.79167V12.5C18.3334 13.011 18.216 13.5151 17.9903 13.9735C17.7645 14.4319 17.4364 14.8323 17.0313 15.1436C16.6261 15.455 16.1548 15.6691 15.6538 15.7693C15.1527 15.8695 14.6354 15.8532 14.1416 15.7217C14.3916 15.1983 14.545 14.6217 14.5791 14.0117L14.5866 13.7492V9.79167C14.5866 9.2375 14.3908 8.72917 14.0625 8.33333ZM9.99996 2.5C10.663 2.5 11.2989 2.76339 11.7677 3.23223C12.2366 3.70107 12.5 4.33696 12.5 5C12.5 5.66304 12.2366 6.29893 11.7677 6.76777C11.2989 7.23661 10.663 7.5 9.99996 7.5C9.33692 7.5 8.70103 7.23661 8.23219 6.76777C7.76335 6.29893 7.49996 5.66304 7.49996 5C7.49996 4.33696 7.76335 3.70107 8.23219 3.23223C8.70103 2.76339 9.33692 2.5 9.99996 2.5ZM15.4166 3.33333C15.9692 3.33333 16.4991 3.55283 16.8898 3.94353C17.2805 4.33423 17.5 4.86413 17.5 5.41667C17.5 5.9692 17.2805 6.4991 16.8898 6.88981C16.4991 7.28051 15.9692 7.5 15.4166 7.5C14.8641 7.5 14.3342 7.28051 13.9435 6.88981C13.5528 6.4991 13.3333 5.9692 13.3333 5.41667C13.3333 4.86413 13.5528 4.33423 13.9435 3.94353C14.3342 3.55283 14.8641 3.33333 15.4166 3.33333ZM4.58329 3.33333C5.13583 3.33333 5.66573 3.55283 6.05643 3.94353C6.44713 4.33423 6.66663 4.86413 6.66663 5.41667C6.66663 5.9692 6.44713 6.4991 6.05643 6.88981C5.66573 7.28051 5.13583 7.5 4.58329 7.5C4.03076 7.5 3.50085 7.28051 3.11015 6.88981C2.71945 6.4991 2.49996 5.9692 2.49996 5.41667C2.49996 4.86413 2.71945 4.33423 3.11015 3.94353C3.50085 3.55283 4.03076 3.33333 4.58329 3.33333Z" fill="#BDBDBD" />
                            </svg>
                          </div>
                          2K
                        </div>
                        <div className='reaction-box'>
                          <div className='icon'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9.16665 4.99992H11.6667L14.4083 2.24992C14.4858 2.17181 14.578 2.10981 14.6795 2.06751C14.7811 2.0252 14.89 2.00342 15 2.00342C15.11 2.00342 15.2189 2.0252 15.3205 2.06751C15.422 2.10981 15.5142 2.17181 15.5917 2.24992L17.7417 4.40825C17.8969 4.56439 17.984 4.77559 17.984 4.99575C17.984 5.2159 17.8969 5.42711 17.7417 5.58325L15.8333 7.49992H9.16665V9.16658C9.16665 9.3876 9.07885 9.59956 8.92257 9.75584C8.76629 9.91212 8.55433 9.99992 8.33332 9.99992C8.1123 9.99992 7.90034 9.91212 7.74406 9.75584C7.58778 9.59956 7.49998 9.3876 7.49998 9.16658V6.66658C7.49998 6.22456 7.67558 5.80063 7.98814 5.48807C8.3007 5.17551 8.72462 4.99992 9.16665 4.99992ZM4.16665 9.16658V12.4999L2.25832 14.4083C2.10311 14.5644 2.01599 14.7756 2.01599 14.9958C2.01599 15.2159 2.10311 15.4271 2.25832 15.5833L4.40832 17.7416C4.48579 17.8197 4.57796 17.8817 4.6795 17.924C4.78105 17.9663 4.88998 17.9881 4.99998 17.9881C5.10999 17.9881 5.21892 17.9663 5.32047 17.924C5.42201 17.8817 5.51418 17.8197 5.59165 17.7416L9.16665 14.1666H12.5C12.721 14.1666 12.933 14.0788 13.0892 13.9225C13.2455 13.7662 13.3333 13.5543 13.3333 13.3333V12.4999H14.1667C14.3877 12.4999 14.5996 12.4121 14.7559 12.2558C14.9122 12.0996 15 11.8876 15 11.6666V10.8333H15.8333C16.0543 10.8333 16.2663 10.7455 16.4226 10.5892C16.5789 10.4329 16.6667 10.2209 16.6667 9.99992V9.16658H10.8333V9.99992C10.8333 10.4419 10.6577 10.8659 10.3452 11.1784C10.0326 11.491 9.60868 11.6666 9.16665 11.6666H7.49998C7.05796 11.6666 6.63403 11.491 6.32147 11.1784C6.00891 10.8659 5.83332 10.4419 5.83332 9.99992V7.49992L4.16665 9.16658Z" fill="#BDBDBD" />
                            </svg>
                          </div>
                          1.7K
                        </div>
                        <div className='reaction-box'>
                          <div className='icon'>
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.85072 1.32118C6.98369 0.488652 5.82145 0.0346457 4.61968 0.0590401C3.41791 0.0834345 2.27505 0.584232 1.44252 1.45126C0.60999 2.31829 0.155984 3.48053 0.180378 4.6823C0.204772 5.88407 0.705569 7.02693 1.5726 7.85946L8.55463 14.9423C8.61279 15.0013 8.68211 15.0482 8.75856 15.0802C8.83501 15.1122 8.91706 15.1287 8.99994 15.1287C9.08282 15.1287 9.16488 15.1122 9.24133 15.0802C9.31778 15.0482 9.3871 15.0013 9.44526 14.9423L16.4218 7.85946C17.2724 7.00994 17.7506 5.85733 17.7514 4.6552C17.7521 3.45306 17.2752 2.29987 16.4257 1.44931C15.5762 0.598751 14.4236 0.120501 13.2215 0.119768C12.0193 0.119036 10.8661 0.595881 10.0156 1.4454L8.10932 3.24228L10.1718 5.30634C10.2299 5.36438 10.276 5.43331 10.3075 5.50919C10.3389 5.58506 10.3551 5.66639 10.3551 5.74853C10.3551 5.83066 10.3389 5.91199 10.3075 5.98786C10.276 6.06374 10.2299 6.13267 10.1718 6.19071L8.55541 7.80712C8.49729 7.86514 8.42831 7.91114 8.35242 7.9425C8.27652 7.97386 8.19518 7.98996 8.11306 7.98989C8.03094 7.98982 7.94964 7.97357 7.87379 7.94208C7.79795 7.91058 7.72905 7.86446 7.67104 7.80634C7.61302 7.74822 7.56702 7.67924 7.53566 7.60334C7.5043 7.52744 7.48819 7.44611 7.48827 7.36399C7.48834 7.28187 7.50459 7.20056 7.53608 7.12472C7.56757 7.04888 7.6137 6.97998 7.67182 6.92196L8.84369 5.75009L6.77338 3.67353C6.71387 3.61406 6.66697 3.5432 6.63551 3.46518C6.60404 3.38716 6.58865 3.30359 6.59025 3.21948C6.59186 3.13537 6.61043 3.05244 6.64485 2.97568C6.67927 2.89892 6.72883 2.82989 6.79057 2.77275L7.84916 1.77431C7.87989 1.74511 7.90436 1.70997 7.92108 1.67103C7.9378 1.63208 7.94643 1.59013 7.94643 1.54775C7.94643 1.50536 7.9378 1.46342 7.92108 1.42447C7.90436 1.38552 7.87989 1.35038 7.84916 1.32118H7.85072Z" fill="#BDBDBD" />
                            </svg>
                          </div>
                          0
                        </div>
                        <div className='reaction-box'>
                          <div className='icon'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.9666 11.8582C11.4096 12.3073 10.7155 12.5522 9.99996 12.5522C9.28439 12.5522 8.59036 12.3073 8.0333 11.8582C7.86312 11.7167 7.64371 11.6487 7.42336 11.669C7.203 11.6893 6.99975 11.7963 6.8583 11.9665C6.71685 12.1367 6.6488 12.3561 6.66911 12.5764C6.68943 12.7968 6.79645 13.0001 6.96663 13.1415C7.81774 13.852 8.89126 14.2412 9.99996 14.2412C11.1087 14.2412 12.1822 13.852 13.0333 13.1415C13.2035 13.0001 13.3105 12.7968 13.3308 12.5764C13.3511 12.3561 13.2831 12.1367 13.1416 11.9665C13.0716 11.8822 12.9856 11.8126 12.8887 11.7615C12.7917 11.7105 12.6857 11.679 12.5766 11.669C12.3562 11.6487 12.1368 11.7167 11.9666 11.8582ZM7.49996 9.1665C7.66478 9.1665 7.8259 9.11763 7.96294 9.02606C8.09998 8.93449 8.20679 8.80435 8.26986 8.65207C8.33294 8.4998 8.34944 8.33225 8.31728 8.1706C8.28513 8.00894 8.20576 7.86046 8.08922 7.74392C7.97267 7.62737 7.82419 7.548 7.66254 7.51585C7.50089 7.4837 7.33333 7.5002 7.18106 7.56327C7.02879 7.62634 6.89864 7.73315 6.80707 7.8702C6.7155 8.00724 6.66663 8.16835 6.66663 8.33317C6.66663 8.55418 6.75443 8.76615 6.91071 8.92243C7.06699 9.07871 7.27895 9.1665 7.49996 9.1665ZM12.5 7.49984C12.3351 7.49984 12.174 7.54871 12.037 7.64028C11.8999 7.73185 11.7931 7.862 11.7301 8.01427C11.667 8.16654 11.6505 8.3341 11.6826 8.49575C11.7148 8.6574 11.7942 8.80588 11.9107 8.92243C12.0273 9.03897 12.1757 9.11834 12.3374 9.15049C12.499 9.18265 12.6666 9.16614 12.8189 9.10307C12.9711 9.04 13.1013 8.93319 13.1929 8.79615C13.2844 8.65911 13.3333 8.49799 13.3333 8.33317C13.3333 8.11216 13.2455 7.9002 13.0892 7.74392C12.9329 7.58764 12.721 7.49984 12.5 7.49984ZM9.99996 1.6665C8.35179 1.6665 6.74062 2.15525 5.37021 3.07092C3.9998 3.9866 2.9317 5.28809 2.30097 6.81081C1.67024 8.33353 1.50521 10.0091 1.82675 11.6256C2.1483 13.2421 2.94197 14.727 4.10741 15.8924C5.27284 17.0578 6.7577 17.8515 8.37421 18.173C9.99072 18.4946 11.6663 18.3296 13.189 17.6988C14.7117 17.0681 16.0132 16 16.9289 14.6296C17.8446 13.2592 18.3333 11.648 18.3333 9.99984C18.3333 8.90549 18.1177 7.82186 17.699 6.81081C17.2802 5.79976 16.6663 4.8811 15.8925 4.10728C15.1187 3.33346 14.2 2.71963 13.189 2.30084C12.1779 1.88205 11.0943 1.6665 9.99996 1.6665ZM9.99996 16.6665C8.68142 16.6665 7.39249 16.2755 6.29616 15.543C5.19983 14.8104 4.34535 13.7692 3.84077 12.5511C3.33618 11.3329 3.20416 9.99244 3.46139 8.69924C3.71863 7.40603 4.35357 6.21814 5.28592 5.28579C6.21827 4.35344 7.40615 3.7185 8.69936 3.46127C9.99257 3.20403 11.333 3.33606 12.5512 3.84064C13.7694 4.34522 14.8105 5.19971 15.5431 6.29604C16.2756 7.39236 16.6666 8.6813 16.6666 9.99984C16.6666 11.7679 15.9643 13.4636 14.714 14.7139C13.4638 15.9641 11.7681 16.6665 9.99996 16.6665Z" fill="#BDBDBD" />
                            </svg>
                          </div>
                          23
                        </div>
                        <div className='reaction-box'>
                          <div className='icon'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M17.5 10C17.5 5.85938 14.1406 2.5 10 2.5C5.85938 2.5 2.5 5.85938 2.5 10C2.5 14.1406 5.85938 17.5 10 17.5C14.1406 17.5 17.5 14.1406 17.5 10Z" stroke="#BDBDBD" strokeWidth="2" stroke-miterlimit="10" />
                              <path d="M13.75 6.875L8.5 13.125L6.25 10.625" stroke="#BDBDBD" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </div>
                          0
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-6 col-sm-6'>
                    <div className='right-btn-area'>
                      <button className='statuses-btn' onClick={toggleAllFilters}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16 10H4" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M19 6H1" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M13 14H7" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        All statuses
                      </button>
                      <button className='app-btn' onClick={toggleAIPrompts} >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.74913 14.6632C3.10913 15.7732 4.20329 16.4815 5.37079 16.4815H5.41663C5.52374 17.0043 5.80803 17.474 6.22148 17.8114C6.63492 18.1488 7.15216 18.3331 7.68579 18.3332C8.06663 18.3332 8.42246 18.2373 8.73746 18.0723C8.86904 18.0004 8.97853 17.894 9.05414 17.7644C9.12976 17.6349 9.16865 17.4873 9.16663 17.3373V2.52233C9.16784 2.33153 9.10355 2.1461 8.98449 1.997C8.86542 1.84791 8.6988 1.74419 8.51246 1.70317C8.09439 1.62171 7.66113 1.68059 7.27996 1.87067C6.65996 2.16733 6.29663 2.82983 6.29663 3.519V3.56483C5.83264 3.47013 5.35076 3.52001 4.916 3.70773C4.48124 3.89544 4.11451 4.21198 3.86527 4.61464C3.61603 5.01729 3.49626 5.4867 3.52214 5.95955C3.54801 6.4324 3.71827 6.88594 4.00996 7.259C3.35691 7.36184 2.76203 7.69444 2.33243 8.19692C1.90282 8.6994 1.66672 9.33874 1.66663 9.99983C1.66663 10.9815 2.17579 11.8423 2.94413 12.3432C2.58579 12.9857 2.46829 13.7982 2.74913 14.6632ZM15.99 7.259C16.2816 6.88594 16.4519 6.4324 16.4778 5.95955C16.5037 5.4867 16.3839 5.01729 16.1347 4.61464C15.8854 4.21198 15.5187 3.89544 15.0839 3.70773C14.6492 3.52001 14.1673 3.47013 13.7033 3.56483V3.519C13.7033 2.83067 13.3391 2.16733 12.7191 1.87067C12.3382 1.68078 11.9053 1.6219 11.4875 1.70317C11.3011 1.74419 11.1345 1.84791 11.0154 1.997C10.8964 2.1461 10.8321 2.33153 10.8333 2.52233V17.3365C10.8333 17.6407 10.9933 17.9298 11.2633 18.0715C11.5783 18.2373 11.9333 18.3332 12.3141 18.3332C12.8479 18.333 13.3652 18.1486 13.7787 17.8111C14.1921 17.4735 14.4764 17.0036 14.5833 16.4807H14.63C15.7966 16.4807 16.8916 15.7723 17.2516 14.6623C17.5325 13.7973 17.415 12.9848 17.0566 12.3423C17.448 12.0894 17.7699 11.7426 17.9929 11.3335C18.2159 10.9243 18.3329 10.4658 18.3333 9.99983C18.3332 9.33874 18.0971 8.6994 17.6675 8.19692C17.2379 7.69444 16.643 7.36184 15.99 7.259Z" fill="var(--sa-dark-accent-light)" />
                        </svg>
                      </button>
                      <input
                        type="file"
                        className='btn-style-new'
                        id="upload-contacts"
                        accept=".csv"
                        style={{ display: 'none' }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            console.log('File uploaded:', file.name);

                            const reader = new FileReader();

                            reader.onload = (event) => {
                              const csvData = event.target.result;
                              handleCSVUpload(csvData);
                            };

                            reader.readAsText(file);
                          }
                        }}
                      />
                      <label htmlFor="upload-contacts" className='btn-style-new' style={{ cursor: 'pointer' }}>
                       + Add Campaign
                      </label>
                      {/* </div> */}
                    </div>
                  </div>
                  <div className='col-12'>
                    <div className="table-container">
                      <ReactTable
                        width='100'
                        className='table campaign-table responsive'
                        minRows={6}
                        columns={columns}
                        filterable={true}
                        data={contactsData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>

          <TabPanel value={valueAgentDetailTab} index={2}>
            <div className='anylatics-panel'>
              <div className='step-boxs-main'>
                <div className='left-step-box'>
                  <div className='top-call-area'>
                    <button className='call-box' onClick={toggcontactdCall}>
                      <i className='icon'>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_334_10089)">
                            <path d="M19.25 14.8051V17.4301C19.251 17.6738 19.2011 17.915 19.1034 18.1383C19.0058 18.3615 18.8626 18.562 18.6831 18.7267C18.5035 18.8915 18.2915 19.0169 18.0607 19.095C17.8298 19.173 17.5852 19.202 17.3425 19.1801C14.65 18.8875 12.0636 17.9675 9.79125 16.4938C7.6771 15.1504 5.88467 13.358 4.54125 11.2438C3.06248 8.96114 2.14222 6.3622 1.855 3.65758C1.83314 3.41562 1.86189 3.17175 1.93944 2.94151C2.01699 2.71126 2.14163 2.49969 2.30542 2.32025C2.46922 2.14082 2.66858 1.99746 2.89082 1.89929C3.11306 1.80113 3.3533 1.75031 3.59625 1.75008H6.22125C6.6459 1.74591 7.05757 1.89628 7.37954 2.17318C7.70152 2.45007 7.91182 2.8346 7.97125 3.25508C8.08205 4.09514 8.28752 4.91997 8.58375 5.71383C8.70148 6.02702 8.72696 6.36738 8.65717 6.6946C8.58738 7.02182 8.42526 7.32218 8.19 7.56008L7.07875 8.67133C8.32436 10.8619 10.1382 12.6757 12.3288 13.9213L13.44 12.8101C13.6779 12.5748 13.9783 12.4127 14.3055 12.3429C14.6327 12.2731 14.9731 12.2986 15.2863 12.4163C16.0801 12.7126 16.9049 12.918 17.745 13.0288C18.17 13.0888 18.5582 13.3029 18.8357 13.6304C19.1132 13.9579 19.2607 14.376 19.25 14.8051Z" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_334_10089">
                              <rect width="21" height="21" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </i>
                      Add Call
                    </button>
                    <button className='call-box' onClick={toggcontactdSms}>
                      <i className='icon'>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18.375 13.125C18.375 13.5891 18.1906 14.0342 17.8624 14.3624C17.5342 14.6906 17.0891 14.875 16.625 14.875H6.125L2.625 18.375V4.375C2.625 3.91087 2.80937 3.46575 3.13756 3.13756C3.46575 2.80937 3.91087 2.625 4.375 2.625H16.625C17.0891 2.625 17.5342 2.80937 17.8624 3.13756C18.1906 3.46575 18.375 3.91087 18.375 4.375V13.125Z" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </i>
                      Add SMS
                    </button>
                  </div>
                  <div className={`stepboxes ${isVisibleEmailBox ? "" : "active"}`} onClick={() => setIsVisibleEmailBox(false)}>
                    <div className='step-header'>
                      <h2>Step 1</h2>
                      <button className='remove-btn'>
                        <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.8332 0.833333H8.9165L8.08317 0H3.9165L3.08317 0.833333H0.166504V2.5H11.8332M0.999837 13.3333C0.999837 13.7754 1.17543 14.1993 1.48799 14.5118C1.80055 14.8244 2.22448 15 2.6665 15H9.33317C9.7752 15 10.1991 14.8244 10.5117 14.5118C10.8242 14.1993 10.9998 13.7754 10.9998 13.3333V3.33333H0.999837V13.3333Z" fill="#4b5563" />
                        </svg>
                      </button>
                    </div>
                    <div className='step-body'>
                      <button className='subject'>Revolutionize Your Real Estate Contact Gene...</button>
                      <button className='add-variant'>
                        <i className='icon'>
                          <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.5 4.58301V17.4163" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.375 11H16.625" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </i>
                        Add variant
                      </button>
                    </div>
                    <div className='step-footer'>
                      <div className='step-footer-box'>
                        <p>Send next message in </p>
                        <TextField
                          fullWidth
                          hiddenLabel
                          placeholder='Days'
                          variant="standard"
                          size="small"
                          // value={editState?.type || agentData?.type || ''}
                          // onChange={handleEditChange}
                          name='days'
                        />
                        <p>Days</p>
                      </div>
                    </div>
                  </div>
                  <div className={`stepboxes ${isVisibleEmailBox ? "active" : ""}`} onClick={() => setIsVisibleEmailBox(true)}>
                    <div className='step-header'>
                      <h2>Step 2</h2>
                      <button className='remove-btn'>
                        <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.8332 0.833333H8.9165L8.08317 0H3.9165L3.08317 0.833333H0.166504V2.5H11.8332M0.999837 13.3333C0.999837 13.7754 1.17543 14.1993 1.48799 14.5118C1.80055 14.8244 2.22448 15 2.6665 15H9.33317C9.7752 15 10.1991 14.8244 10.5117 14.5118C10.8242 14.1993 10.9998 13.7754 10.9998 13.3333V3.33333H0.999837V13.3333Z" fill="#4b5563" />
                        </svg>
                      </button>
                    </div>
                    <div className='step-body'>
                      <button className='subject'>Revolutionize Your Real Estate Contact Gene...</button>
                      <button className='add-variant'>
                        <i className='icon'>
                          <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.5 4.58301V17.4163" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.375 11H16.625" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </i>
                        Add variant
                      </button>
                    </div>
                  </div>
                  <button className='add-step'>
                    <i className='icon'>
                      <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="mr-2 text-primary" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    </i>
                    Add Step
                  </button>
                </div>
                <div className='right-box'>
                  {isVisibleEmailBox
                    ? <div class="email-box">
                      <div class="subject-line">
                        <div className='left-area-subject'>
                          <label className="text-gray-700 font-semibold">Subject</label>
                          <input
                            type="text"
                            value={subjectStep2}
                            onChange={(e) => setSubjectStep2(e.target.value)}
                            className="w-full mt-1 p-2 border rounded-md"
                          />
                        </div>
                        <div className='btn-groups'>
                          <button class="btn-style-border">
                            <i className='icon'>
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.583374 6.99967C0.583374 6.99967 2.91671 2.33301 7.00004 2.33301C11.0834 2.33301 13.4167 6.99967 13.4167 6.99967C13.4167 6.99967 11.0834 11.6663 7.00004 11.6663C2.91671 11.6663 0.583374 6.99967 0.583374 6.99967Z" stroke="var(--sa-dark-accent-light)" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z" stroke="var(--sa-dark-accent-light)" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </i>
                            Preview
                          </button>
                          <button class="btn-style-border">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.58333 1.16699L1.75 8.16699H7L6.41667 12.8337L12.25 5.83366H7L7.58333 1.16699Z" stroke="var(--sa-dark-accent-light)" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </button>
                        </div>
                      </div>
                      <textarea
                        rows={10}
                        value={bodyStep2}
                        onChange={(e) => setBodyStep2(e.target.value)}
                        className="email-body"
                      />
                      {/* <!-- Bottom bar --> */}
                      <div class="bottom-bar">
                        <button className='btn-style-new'>Save</button>
                        <Dropdown className="btn-arrow" isOpen={dropdownOpen} toggle={toggleDropDwon}>
                          <DropdownToggle caret>
                            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0.5 1.25L4 4.75L7.5 1.25" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem>Save Draft</DropdownItem>
                            <DropdownItem>Save as Template</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>

                        <div class="tool-icons">
                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.706 4.31252H9.29401C8.63978 4.31226 7.9919 4.44091 7.3874 4.69113C6.78291 4.94134 6.23363 5.30821 5.77097 5.77078C5.30831 6.23335 4.94133 6.78254 4.691 7.38699C4.44066 7.99144 4.31188 8.63929 4.31201 9.29352V14.7055C4.31175 15.3598 4.44043 16.0078 4.69071 16.6124C4.94098 17.2169 5.30795 17.7662 5.77062 18.2289C6.23329 18.6916 6.78261 19.0586 7.38717 19.3088C7.99174 19.5591 8.63969 19.6878 9.29401 19.6875H14.706C15.3603 19.6878 16.0083 19.5591 16.6129 19.3088C17.2174 19.0586 17.7667 18.6916 18.2294 18.2289C18.6921 17.7662 19.059 17.2169 19.3093 16.6124C19.5596 16.0078 19.6883 15.3598 19.688 14.7055V9.29352C19.6883 8.6392 19.5596 7.99125 19.3093 7.38668C19.059 6.78212 18.6921 6.23281 18.2294 5.77013C17.7667 5.30746 17.2174 4.9405 16.6129 4.69022C16.0083 4.43994 15.3603 4.31126 14.706 4.31152V4.31252Z" stroke="#4b5563" strokeWidth="1.5" />
                                <path d="M19.606 15.5871H21.225C21.4968 15.5871 21.7576 15.4791 21.9498 15.2869C22.142 15.0947 22.25 14.834 22.25 14.5621V9.43711C22.25 9.16526 22.142 8.90455 21.9498 8.71233C21.7576 8.5201 21.4968 8.41211 21.225 8.41211H19.605M4.395 15.5871H2.775C2.6404 15.5871 2.50711 15.5606 2.38275 15.5091C2.25839 15.4576 2.1454 15.3821 2.05022 15.2869C1.95504 15.1917 1.87953 15.0787 1.82802 14.9544C1.77651 14.83 1.75 14.6967 1.75 14.5621V9.43711C1.75 9.16526 1.85799 8.90455 2.05022 8.71233C2.24244 8.5201 2.50315 8.41211 2.775 8.41211H4.395" stroke="#4b5563" strokeWidth="1.5" />
                                <path d="M2.76501 8.4125V4.3125M21.225 8.4125L21.215 4.3125M8.91501 8.7625V11.4605M15.065 8.7625V11.4605M9.94001 15.5875H14.04" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </i>
                            AI Tools
                          </button>
                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3 9H21" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9 21V9" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </i>
                            Templates
                          </button>
                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.904 9.728H3.248L2.448 12H0.544L4.528 0.863999H6.64L10.624 12H8.704L7.904 9.728ZM7.392 8.24L5.584 3.072L3.76 8.24H7.392Z" fill="#4b5563" />
                              </svg>
                            </i>
                          </button>
                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.894 20.4478C20.8109 20.6137 20.6832 20.7532 20.5254 20.8507C20.3675 20.9482 20.1856 20.9998 20 20.9998H5.50002C4.86802 20.9998 4.56802 20.4368 4.30002 19.9548C4.01085 19.4369 3.76405 18.8965 3.56202 18.3388C3.06202 16.9748 2.64502 15.0458 3.01402 12.8358C3.24062 11.4284 3.72471 10.0748 4.44202 8.84283C5.09702 7.73383 6.37302 7.42283 7.43302 7.70583L9.62002 8.29183L10.655 4.42783C10.861 3.65923 11.3638 3.00392 12.0529 2.60606C12.3941 2.40906 12.7708 2.2812 13.1614 2.22977C13.552 2.17834 13.9489 2.20436 14.3295 2.30633C14.7101 2.4083 15.0668 2.58423 15.3794 2.82408C15.692 3.06393 15.9543 3.36299 16.1513 3.7042C16.3483 4.04541 16.4761 4.42208 16.5276 4.8127C16.579 5.20333 16.553 5.60026 16.451 5.98083L15.415 9.84483L16.773 10.2088C18.427 10.6518 19.283 12.3278 19.051 13.8638C18.941 14.5938 18.897 15.3108 18.986 15.8318C19.1 16.5018 19.517 17.3688 19.971 18.1378C20.351 18.7818 20.711 19.2798 20.787 19.3818C21.014 19.6898 21.068 20.1008 20.894 20.4478ZM13.812 4.23783C13.6851 4.20382 13.5527 4.19515 13.4224 4.21233C13.2922 4.22951 13.1666 4.2722 13.0528 4.33795C12.939 4.4037 12.8393 4.49123 12.7594 4.59554C12.6795 4.69984 12.6209 4.81887 12.587 4.94583L11.293 9.77583C11.259 9.90269 11.2004 10.0216 11.1204 10.1258C11.0404 10.23 10.9407 10.3174 10.827 10.3831C10.7132 10.4487 10.5876 10.4913 10.4574 10.5084C10.3272 10.5256 10.1949 10.5169 10.068 10.4828L6.91602 9.63783C6.53302 9.53483 6.27002 9.68083 6.16502 9.85883C5.88535 10.3346 5.65002 10.835 5.46202 11.3538L16.972 14.4068C16.997 14.1128 17.033 13.8288 17.073 13.5648C17.178 12.8738 16.776 12.2798 16.255 12.1408L13.932 11.5178C13.8052 11.4838 13.6862 11.4252 13.582 11.3452C13.4778 11.2652 13.3904 11.1655 13.3248 11.0518C13.2591 10.938 13.2165 10.8124 13.1994 10.6822C13.1823 10.552 13.191 10.4197 13.225 10.2928L14.519 5.46283C14.5874 5.20677 14.5514 4.93402 14.4188 4.70451C14.2863 4.475 14.068 4.3065 13.812 4.23783ZM17.084 16.5048L4.96602 13.2908C4.70602 15.0148 5.03302 16.5388 5.44002 17.6508C5.64802 18.2198 5.87402 18.6728 6.04502 18.9798L6.05702 18.9998H7.75702C7.38002 18.2078 6.99402 17.1338 6.98702 16.0068C6.98195 15.873 7.00382 15.7395 7.05131 15.6143C7.09881 15.4891 7.17097 15.3747 7.26352 15.2779C7.35607 15.1811 7.46711 15.1039 7.59007 15.0508C7.71303 14.9978 7.84539 14.97 7.9793 14.969C8.11321 14.9681 8.24595 14.9941 8.36964 15.0454C8.49333 15.0967 8.60544 15.1724 8.69934 15.2679C8.79323 15.3634 8.86699 15.4767 8.91623 15.6013C8.96548 15.7258 8.98921 15.8589 8.98602 15.9928C8.99102 16.7688 9.29302 17.6068 9.64202 18.3008C9.78002 18.5768 9.91902 18.8158 10.034 19.0008H18.159C17.756 18.3008 17.299 17.3908 17.084 16.5048Z" fill="#4b5563" />
                              </svg>
                            </i>
                          </button>
                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 7H18C18.6566 7 19.3068 7.12933 19.9134 7.3806C20.52 7.63188 21.0712 8.00017 21.5355 8.46447C21.9998 8.92876 22.3681 9.47996 22.6194 10.0866C22.8707 10.6932 23 11.3434 23 12C23 12.6566 22.8707 13.3068 22.6194 13.9134C22.3681 14.52 21.9998 15.0712 21.5355 15.5355C21.0712 15.9998 20.52 16.3681 19.9134 16.6194C19.3068 16.8707 18.6566 17 18 17H15M9 17H6C5.34339 17 4.69321 16.8707 4.08658 16.6194C3.47995 16.3681 2.92876 15.9998 2.46447 15.5355C1.52678 14.5979 1 13.3261 1 12C1 10.6739 1.52678 9.40215 2.46447 8.46447C3.40215 7.52678 4.67392 7 6 7H9" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 12H16" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </i>
                          </button>

                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 5V19" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5 12H19" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </i>
                          </button>

                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.82496 12.0254L8.69996 15.9004C8.8833 16.0837 8.97497 16.3171 8.97497 16.6004C8.97497 16.8837 8.8833 17.1171 8.69996 17.3004C8.51663 17.4837 8.2833 17.5754 7.99996 17.5754C7.71663 17.5754 7.4833 17.4837 7.29996 17.3004L2.69996 12.7004C2.59996 12.6004 2.52896 12.4921 2.48696 12.3754C2.44496 12.2587 2.42463 12.1337 2.42596 12.0004C2.4273 11.8671 2.4483 11.7421 2.48896 11.6254C2.52963 11.5087 2.6003 11.4004 2.70096 11.3004L7.30096 6.70039C7.50096 6.50039 7.73863 6.40039 8.01396 6.40039C8.2893 6.40039 8.52663 6.50039 8.72596 6.70039C8.9253 6.90039 9.0253 7.13806 9.02596 7.41339C9.02663 7.68872 8.92663 7.92606 8.72596 8.12539L4.82496 12.0254ZM19.175 11.9754L15.3 8.10039C15.1166 7.91706 15.025 7.68372 15.025 7.40039C15.025 7.11706 15.1166 6.88372 15.3 6.70039C15.4833 6.51706 15.7166 6.42539 16 6.42539C16.2833 6.42539 16.5166 6.51706 16.7 6.70039L21.3 11.3004C21.4 11.4004 21.471 11.5087 21.513 11.6254C21.555 11.7421 21.5756 11.8671 21.575 12.0004C21.5743 12.1337 21.5536 12.2587 21.513 12.3754C21.4723 12.4921 21.4013 12.6004 21.3 12.7004L16.7 17.3004C16.5 17.5004 16.2666 17.5964 16 17.5884C15.7333 17.5804 15.5 17.4761 15.3 17.2754C15.1 17.0747 15 16.8374 15 16.5634C15 16.2894 15.1 16.0517 15.3 15.8504L19.175 11.9754Z" fill="#4b5563" />
                              </svg>
                            </i>
                          </button>
                        </div>
                      </div>
                    </div>
                    : <div class="email-box">
                      <div class="subject-line">
                        <div className='left-area-subject'>
                          <label className="text-gray-700 font-semibold">Subject</label>
                          <input
                            type="text"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            className="w-full mt-1 p-2 border rounded-md"
                          />
                        </div>
                        <div className='btn-groups'>
                          <button class="btn-style-border">
                            <i className='icon'>
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.583374 6.99967C0.583374 6.99967 2.91671 2.33301 7.00004 2.33301C11.0834 2.33301 13.4167 6.99967 13.4167 6.99967C13.4167 6.99967 11.0834 11.6663 7.00004 11.6663C2.91671 11.6663 0.583374 6.99967 0.583374 6.99967Z" stroke="var(--sa-dark-accent-light)" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z" stroke="var(--sa-dark-accent-light)" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </i>
                            Preview
                          </button>
                          <button class="btn-style-border">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.58333 1.16699L1.75 8.16699H7L6.41667 12.8337L12.25 5.83366H7L7.58333 1.16699Z" stroke="var(--sa-dark-accent-light)" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </button>
                        </div>
                      </div>
                      <textarea
                        rows={10}
                        value={body}
                        onChange={(e) => setBody(e.target.value)}
                        className="email-body"
                      />
                      {/* <!-- Bottom bar --> */}
                      <div class="bottom-bar">
                        <button className='btn-style-new'>Save</button>
                        <Dropdown className="btn-arrow" isOpen={dropdownOpen} toggle={toggleDropDwon}>
                          <DropdownToggle caret>
                            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0.5 1.25L4 4.75L7.5 1.25" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem>Save Draft</DropdownItem>
                            <DropdownItem>Save as Template</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>

                        <div class="tool-icons">
                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.706 4.31252H9.29401C8.63978 4.31226 7.9919 4.44091 7.3874 4.69113C6.78291 4.94134 6.23363 5.30821 5.77097 5.77078C5.30831 6.23335 4.94133 6.78254 4.691 7.38699C4.44066 7.99144 4.31188 8.63929 4.31201 9.29352V14.7055C4.31175 15.3598 4.44043 16.0078 4.69071 16.6124C4.94098 17.2169 5.30795 17.7662 5.77062 18.2289C6.23329 18.6916 6.78261 19.0586 7.38717 19.3088C7.99174 19.5591 8.63969 19.6878 9.29401 19.6875H14.706C15.3603 19.6878 16.0083 19.5591 16.6129 19.3088C17.2174 19.0586 17.7667 18.6916 18.2294 18.2289C18.6921 17.7662 19.059 17.2169 19.3093 16.6124C19.5596 16.0078 19.6883 15.3598 19.688 14.7055V9.29352C19.6883 8.6392 19.5596 7.99125 19.3093 7.38668C19.059 6.78212 18.6921 6.23281 18.2294 5.77013C17.7667 5.30746 17.2174 4.9405 16.6129 4.69022C16.0083 4.43994 15.3603 4.31126 14.706 4.31152V4.31252Z" stroke="#4b5563" strokeWidth="1.5" />
                                <path d="M19.606 15.5871H21.225C21.4968 15.5871 21.7576 15.4791 21.9498 15.2869C22.142 15.0947 22.25 14.834 22.25 14.5621V9.43711C22.25 9.16526 22.142 8.90455 21.9498 8.71233C21.7576 8.5201 21.4968 8.41211 21.225 8.41211H19.605M4.395 15.5871H2.775C2.6404 15.5871 2.50711 15.5606 2.38275 15.5091C2.25839 15.4576 2.1454 15.3821 2.05022 15.2869C1.95504 15.1917 1.87953 15.0787 1.82802 14.9544C1.77651 14.83 1.75 14.6967 1.75 14.5621V9.43711C1.75 9.16526 1.85799 8.90455 2.05022 8.71233C2.24244 8.5201 2.50315 8.41211 2.775 8.41211H4.395" stroke="#4b5563" strokeWidth="1.5" />
                                <path d="M2.76501 8.4125V4.3125M21.225 8.4125L21.215 4.3125M8.91501 8.7625V11.4605M15.065 8.7625V11.4605M9.94001 15.5875H14.04" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </i>
                            AI Tools
                          </button>
                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3 9H21" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9 21V9" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </i>
                            Templates
                          </button>
                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.904 9.728H3.248L2.448 12H0.544L4.528 0.863999H6.64L10.624 12H8.704L7.904 9.728ZM7.392 8.24L5.584 3.072L3.76 8.24H7.392Z" fill="#4b5563" />
                              </svg>
                            </i>
                          </button>
                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.894 20.4478C20.8109 20.6137 20.6832 20.7532 20.5254 20.8507C20.3675 20.9482 20.1856 20.9998 20 20.9998H5.50002C4.86802 20.9998 4.56802 20.4368 4.30002 19.9548C4.01085 19.4369 3.76405 18.8965 3.56202 18.3388C3.06202 16.9748 2.64502 15.0458 3.01402 12.8358C3.24062 11.4284 3.72471 10.0748 4.44202 8.84283C5.09702 7.73383 6.37302 7.42283 7.43302 7.70583L9.62002 8.29183L10.655 4.42783C10.861 3.65923 11.3638 3.00392 12.0529 2.60606C12.3941 2.40906 12.7708 2.2812 13.1614 2.22977C13.552 2.17834 13.9489 2.20436 14.3295 2.30633C14.7101 2.4083 15.0668 2.58423 15.3794 2.82408C15.692 3.06393 15.9543 3.36299 16.1513 3.7042C16.3483 4.04541 16.4761 4.42208 16.5276 4.8127C16.579 5.20333 16.553 5.60026 16.451 5.98083L15.415 9.84483L16.773 10.2088C18.427 10.6518 19.283 12.3278 19.051 13.8638C18.941 14.5938 18.897 15.3108 18.986 15.8318C19.1 16.5018 19.517 17.3688 19.971 18.1378C20.351 18.7818 20.711 19.2798 20.787 19.3818C21.014 19.6898 21.068 20.1008 20.894 20.4478ZM13.812 4.23783C13.6851 4.20382 13.5527 4.19515 13.4224 4.21233C13.2922 4.22951 13.1666 4.2722 13.0528 4.33795C12.939 4.4037 12.8393 4.49123 12.7594 4.59554C12.6795 4.69984 12.6209 4.81887 12.587 4.94583L11.293 9.77583C11.259 9.90269 11.2004 10.0216 11.1204 10.1258C11.0404 10.23 10.9407 10.3174 10.827 10.3831C10.7132 10.4487 10.5876 10.4913 10.4574 10.5084C10.3272 10.5256 10.1949 10.5169 10.068 10.4828L6.91602 9.63783C6.53302 9.53483 6.27002 9.68083 6.16502 9.85883C5.88535 10.3346 5.65002 10.835 5.46202 11.3538L16.972 14.4068C16.997 14.1128 17.033 13.8288 17.073 13.5648C17.178 12.8738 16.776 12.2798 16.255 12.1408L13.932 11.5178C13.8052 11.4838 13.6862 11.4252 13.582 11.3452C13.4778 11.2652 13.3904 11.1655 13.3248 11.0518C13.2591 10.938 13.2165 10.8124 13.1994 10.6822C13.1823 10.552 13.191 10.4197 13.225 10.2928L14.519 5.46283C14.5874 5.20677 14.5514 4.93402 14.4188 4.70451C14.2863 4.475 14.068 4.3065 13.812 4.23783ZM17.084 16.5048L4.96602 13.2908C4.70602 15.0148 5.03302 16.5388 5.44002 17.6508C5.64802 18.2198 5.87402 18.6728 6.04502 18.9798L6.05702 18.9998H7.75702C7.38002 18.2078 6.99402 17.1338 6.98702 16.0068C6.98195 15.873 7.00382 15.7395 7.05131 15.6143C7.09881 15.4891 7.17097 15.3747 7.26352 15.2779C7.35607 15.1811 7.46711 15.1039 7.59007 15.0508C7.71303 14.9978 7.84539 14.97 7.9793 14.969C8.11321 14.9681 8.24595 14.9941 8.36964 15.0454C8.49333 15.0967 8.60544 15.1724 8.69934 15.2679C8.79323 15.3634 8.86699 15.4767 8.91623 15.6013C8.96548 15.7258 8.98921 15.8589 8.98602 15.9928C8.99102 16.7688 9.29302 17.6068 9.64202 18.3008C9.78002 18.5768 9.91902 18.8158 10.034 19.0008H18.159C17.756 18.3008 17.299 17.3908 17.084 16.5048Z" fill="#4b5563" />
                              </svg>
                            </i>
                          </button>
                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 7H18C18.6566 7 19.3068 7.12933 19.9134 7.3806C20.52 7.63188 21.0712 8.00017 21.5355 8.46447C21.9998 8.92876 22.3681 9.47996 22.6194 10.0866C22.8707 10.6932 23 11.3434 23 12C23 12.6566 22.8707 13.3068 22.6194 13.9134C22.3681 14.52 21.9998 15.0712 21.5355 15.5355C21.0712 15.9998 20.52 16.3681 19.9134 16.6194C19.3068 16.8707 18.6566 17 18 17H15M9 17H6C5.34339 17 4.69321 16.8707 4.08658 16.6194C3.47995 16.3681 2.92876 15.9998 2.46447 15.5355C1.52678 14.5979 1 13.3261 1 12C1 10.6739 1.52678 9.40215 2.46447 8.46447C3.40215 7.52678 4.67392 7 6 7H9" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 12H16" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </i>
                          </button>

                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 5V19" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5 12H19" stroke="#4b5563" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </i>
                          </button>

                          <button className='btn-ioncs'>
                            <i className='icon'>
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.82496 12.0254L8.69996 15.9004C8.8833 16.0837 8.97497 16.3171 8.97497 16.6004C8.97497 16.8837 8.8833 17.1171 8.69996 17.3004C8.51663 17.4837 8.2833 17.5754 7.99996 17.5754C7.71663 17.5754 7.4833 17.4837 7.29996 17.3004L2.69996 12.7004C2.59996 12.6004 2.52896 12.4921 2.48696 12.3754C2.44496 12.2587 2.42463 12.1337 2.42596 12.0004C2.4273 11.8671 2.4483 11.7421 2.48896 11.6254C2.52963 11.5087 2.6003 11.4004 2.70096 11.3004L7.30096 6.70039C7.50096 6.50039 7.73863 6.40039 8.01396 6.40039C8.2893 6.40039 8.52663 6.50039 8.72596 6.70039C8.9253 6.90039 9.0253 7.13806 9.02596 7.41339C9.02663 7.68872 8.92663 7.92606 8.72596 8.12539L4.82496 12.0254ZM19.175 11.9754L15.3 8.10039C15.1166 7.91706 15.025 7.68372 15.025 7.40039C15.025 7.11706 15.1166 6.88372 15.3 6.70039C15.4833 6.51706 15.7166 6.42539 16 6.42539C16.2833 6.42539 16.5166 6.51706 16.7 6.70039L21.3 11.3004C21.4 11.4004 21.471 11.5087 21.513 11.6254C21.555 11.7421 21.5756 11.8671 21.575 12.0004C21.5743 12.1337 21.5536 12.2587 21.513 12.3754C21.4723 12.4921 21.4013 12.6004 21.3 12.7004L16.7 17.3004C16.5 17.5004 16.2666 17.5964 16 17.5884C15.7333 17.5804 15.5 17.4761 15.3 17.2754C15.1 17.0747 15 16.8374 15 16.5634C15 16.2894 15.1 16.0517 15.3 15.8504L19.175 11.9754Z" fill="#4b5563" />
                              </svg>
                            </i>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </TabPanel>

          <TabPanel value={valueAgentDetailTab} index={3}>
            <div className='schedule-panel'>
              <div className='schedule-inner'>
                <div className='left-area'>
                  <div className='start-time'>
                    <div className='left-start'>
                      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.0833 2.83301H2.91667C2.27233 2.83301 1.75 3.35534 1.75 3.99967V12.1663C1.75 12.8107 2.27233 13.333 2.91667 13.333H11.0833C11.7277 13.333 12.25 12.8107 12.25 12.1663V3.99967C12.25 3.35534 11.7277 2.83301 11.0833 2.83301Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.33325 1.66699V4.00033" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4.66675 1.66699V4.00033" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M1.75 6.33301H12.25" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Start
                    </div>
                    <button className='time-area'>
                      <i className='icon'>
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.33344 5.10897V2.22363L4.19544 5.36163L1.67944 7.87763L4.24011 10.0116L7.33344 12.5896V9.7663C12.7641 9.35697 14.6668 12.4996 14.6668 12.4996C14.6668 10.5416 14.5054 8.50963 12.9661 6.97097C11.1768 5.18097 8.58544 5.0543 7.33344 5.10897Z" fill="#242424" />
                        </svg>

                      </i>
                      Jan 24, 2025
                    </button>
                  </div>

                  <div className='start-time style-two'>
                    <div className='left-start'>
                      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.0833 2.83301H2.91667C2.27233 2.83301 1.75 3.35534 1.75 3.99967V12.1663C1.75 12.8107 2.27233 13.333 2.91667 13.333H11.0833C11.7277 13.333 12.25 12.8107 12.25 12.1663V3.99967C12.25 3.35534 11.7277 2.83301 11.0833 2.83301Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.33325 1.66699V4.00033" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4.66675 1.66699V4.00033" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M1.75 6.33301H12.25" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      End
                    </div>
                    <button className='time-area'>
                      No end date
                    </button>
                  </div>
                </div>
                <div className='schedule-right'>
                  <div className='schedule-box'>
                    <h4>Schedule Name</h4>
                    <TextField
                      fullWidth
                      hiddenLabel
                      placeholder="New Schedule"
                      variant="standard"
                      size="small"
                      // value={editState?.type || agentData?.type || ''}
                      // onChange={handleEditChange}
                      name='NewSchedule'
                    />
                  </div>

                  <div className='schedule-box'>
                    <h4>Timing</h4>
                    <div className='timing-box'>
                      <div className='timing-group-filter'>
                        <Autocomplete
                          options={optionsFromTime}
                          getOptionLabel={(optionsFromTime) => optionsFromTime.label}
                          componentsProps={{
                            paper: {
                              sx: {
                                width: '100%'
                              }
                            }
                          }}
                          sx={{ minWidth: 130 }}
                          renderOption={(props, optionsFromTime) => (
                            <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <i style={{ marginRight: '10px' }}>{optionsFromTime.icon}</i>
                              <Typography style={{ fontSize: '14px' }}>{optionsFromTime.label}</Typography>
                            </Box>
                          )}
                          renderInput={(params) => {
                            const selectedOption = optionsFromTime.find((opt) => opt.label === params.inputProps.value);
                            return (
                              <TextField
                                {...params}
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: selectedOption ? (
                                    <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                  ) : null,
                                }}
                                label="From"
                                variant="outlined"
                              />
                            );
                          }}
                        />
                      </div>
                      <div className='timing-group-filter'>
                        <Autocomplete
                          options={optionsToTime}
                          getOptionLabel={(optionsToTime) => optionsToTime.label}
                          componentsProps={{
                            paper: {
                              sx: {
                                width: '100%'
                              }
                            }
                          }}
                          sx={{ minWidth: 130 }}
                          renderOption={(props, optionsToTime) => (
                            <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <i style={{ marginRight: '10px' }}>{optionsToTime.icon}</i>
                              <Typography style={{ fontSize: '14px' }}>{optionsToTime.label}</Typography>
                            </Box>
                          )}
                          renderInput={(params) => {
                            const selectedOption = optionsToTime.find((opt) => opt.label === params.inputProps.value);
                            return (
                              <TextField
                                {...params}
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: selectedOption ? (
                                    <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                  ) : null,
                                }}
                                label="To"
                                variant="outlined"
                              />
                            );
                          }}
                        />
                      </div>
                      <div className='timing-group-filter'>
                        <Autocomplete
                          options={optionsTimezone}
                          getOptionLabel={(optionsTimezone) => optionsTimezone.label}
                          componentsProps={{
                            paper: {
                              sx: {
                                width: '100%'
                              }
                            }
                          }}
                          sx={{ minWidth: 130 }}
                          renderOption={(props, optionsTimezone) => (
                            <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <i style={{ marginRight: '10px' }}>{optionsTimezone.icon}</i>
                              <Typography style={{ fontSize: '14px' }}>{optionsTimezone.label}</Typography>
                            </Box>
                          )}
                          renderInput={(params) => {
                            const selectedOption = optionsTimezone.find((opt) => opt.label === params.inputProps.value);
                            return (
                              <TextField
                                {...params}
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: selectedOption ? (
                                    <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                  ) : null,
                                }}
                                label="Timezone"
                                variant="outlined"
                              />
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='schedule-box'>
                    <h4>Days</h4>
                    <div className='days-box'>
                      <label>
                        <Checkbox />
                        Monday
                      </label>
                      <label>
                        <Checkbox />
                        Tuesday
                      </label>
                      <label>
                        <Checkbox />
                        Wednesday
                      </label>
                      <label>
                        <Checkbox />
                        Thursday
                      </label>
                      <label>
                        <Checkbox />
                        Friday
                      </label>
                      <label>
                        <Checkbox />
                        Saturday
                      </label>
                      <label>
                        <Checkbox />
                        Sunday
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel value={valueAgentDetailTab} index={4}>
            <div className='options-panel'>
              <div className='options-inner'>
                <div className='option-box'>
                  <div className='options-left'>
                    <h4>Accounts to use</h4>
                    <p>Select one or more accounts to send emails from</p>
                  </div>
                  <div className='options-right'>
                    <div className='timing-group-filter'>
                      <Autocomplete
                        multiple
                        options={optionsAccountEmails}
                        getOptionLabel={(optionsAccountEmails) => optionsAccountEmails.label}
                        componentsProps={{
                          paper: {
                            sx: {
                              width: '100%'
                            }
                          }
                        }}
                        sx={{ minWidth: 130 }}
                        renderOption={(props, optionsAccountEmails) => (
                          <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <i style={{ marginRight: '10px' }}>{optionsAccountEmails.icon}</i>
                            <Typography style={{ fontSize: '14px' }}>{optionsAccountEmails.label}</Typography>
                          </Box>
                        )}
                        renderInput={(params) => {
                          const selectedOption = optionsAccountEmails.find((opt) => opt.label === params.inputProps.value);
                          return (
                            <TextField
                              {...params}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: selectedOption ? (
                                  <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                ) : null,
                              }}
                              label="Timezone"
                              variant="outlined"
                            />
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className='option-box style-two'>
                  <div className='options-left'>
                    <h4>Stop sending emails on reply</h4>
                    <p>Stop sending emails to a contact if a response has been received</p>
                  </div>
                  <div className='options-right'>
                    <div className='timing-group-filter'>
                      <ToggleButtonGroup
                        value={enableDisable}
                        exclusive
                        onChange={handleChangeButtonDisbled}
                        aria-label="voice selection"
                      >
                        <ToggleButton value="Disable">Disable</ToggleButton>
                        <ToggleButton value="Enable">Enable</ToggleButton>
                      </ToggleButtonGroup>
                    </div>
                  </div>
                </div>

                <div className='option-box style-two'>
                  <div className='options-left'>
                    <h4>Open Tracking</h4>
                    <p>Track email opens</p>
                  </div>
                  <div className='options-right'>
                    <div className='track-check'>
                      <label>
                        <Checkbox />
                        Link tracking
                      </label>
                    </div>
                    <div className='timing-group-filter'>
                      <ToggleButtonGroup
                        value={enableDisable}
                        exclusive
                        onChange={handleChange}
                        aria-label="voice selection"
                      >
                        <ToggleButton value="Disable">Disable</ToggleButton>
                        <ToggleButton value="Enable">Enable</ToggleButton>
                      </ToggleButtonGroup>
                    </div>
                  </div>
                </div>

                <div className='option-box style-two'>
                  <div className='options-left'>
                    <h4>Delivery Optimization</h4>
                    <p>Disables open tracking</p>
                  </div>
                  <div className='options-right'>
                    <div className='track-check'>
                      <label>
                        <Checkbox />
                        Send emails as text-only (no HTML)
                      </label>
                      <label>
                        <Checkbox />
                        Send first email as text-only
                      </label>
                    </div>
                  </div>
                </div>

                <div className='option-box style-two'>
                  <div className='options-left'>
                    <h4>Daily Limit</h4>
                    <p>Max number of emails to send per day for this campaign</p>
                  </div>
                  <div className='options-right'>
                    <div className='add-class-area'>
                      <TextField
                        fullWidth
                        hiddenLabel
                        placeholder="Daily Limit"
                        variant="standard"
                        size="small"
                        // value={editState?.type || agentData?.type || ''}
                        // onChange={handleEditChange}
                        name='Limit'
                      />
                    </div>
                  </div>
                </div>

                <div className={isVisibleMoreOptions ? 'bottom-hide-btn-area text-center active' : 'bottom-hide-btn-area text-center '}>
                  <button onClick={handleClickMoreOptions}>
                    Show advanced Options
                    <i className='icon'>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5916 12.3584L14.125 8.82507C14.2031 8.74761 14.2651 8.65544 14.3074 8.55389C14.3497 8.45234 14.3715 8.34342 14.3715 8.23341C14.3715 8.1234 14.3497 8.01448 14.3074 7.91293C14.2651 7.81138 14.2031 7.71921 14.125 7.64174C13.9688 7.48653 13.7576 7.39941 13.5375 7.39941C13.3173 7.39941 13.1061 7.48653 12.95 7.64174L9.99996 10.5917L7.04996 7.64174C6.89383 7.48653 6.68261 7.39941 6.46246 7.39941C6.2423 7.39941 6.0311 7.48653 5.87496 7.64174C5.79773 7.71961 5.73662 7.81195 5.69515 7.91349C5.65368 8.01502 5.63266 8.12374 5.63329 8.23341C5.63266 8.34308 5.65368 8.4518 5.69515 8.55333C5.73662 8.65486 5.79773 8.74721 5.87496 8.82507L9.40829 12.3584C9.48576 12.4365 9.57793 12.4985 9.67948 12.5408C9.78103 12.5831 9.88995 12.6049 9.99996 12.6049C10.11 12.6049 10.2189 12.5831 10.3204 12.5408C10.422 12.4985 10.5142 12.4365 10.5916 12.3584Z" fill="var(--text-color)" />
                      </svg>
                    </i>
                  </button>
                </div>

                {isVisibleMoreOptions &&
                  <div className='more-options'>
                    <div className='title-area'>
                      <h4>CRM</h4>
                    </div>
                    <div className='option-box style-two'>
                      <div className='options-left'>
                        <h4>Daily Limit</h4>
                        <p>Max number of emails to send per day for this campaign</p>
                      </div>
                      <div className='options-right'>
                        <div className='timing-group-filter'>
                          <Autocomplete
                            multiple
                            options={optionsOwners}
                            getOptionLabel={(optionsOwners) => optionsOwners.label}
                            componentsProps={{
                              paper: {
                                sx: {
                                  width: '100%'
                                }
                              }
                            }}
                            sx={{ minWidth: 230 }}
                            renderOption={(props, optionsOwners) => (
                              <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <i style={{ marginRight: '10px' }}>{optionsOwners.icon}</i>
                                <Typography style={{ fontSize: '14px' }}>{optionsOwners.label}</Typography>
                              </Box>
                            )}
                            renderInput={(params) => {
                              const selectedOption = optionsOwners.find((opt) => opt.label === params.inputProps.value);
                              return (
                                <TextField
                                  {...params}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: selectedOption ? (
                                      <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                    ) : null,
                                  }}
                                  label="Owners"
                                  variant="outlined"
                                />
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='title-area'>
                      <h4>Custom Tags</h4>
                      <p>Tags are used to group your campaigns</p>
                    </div>
                    <div className='option-box style-three'>
                      <div className='options-right'>
                        <div className='timing-group-filter'>
                          <Autocomplete
                            multiple
                            options={optionsTags}
                            getOptionLabel={(optionsTags) => optionsTags.label}
                            componentsProps={{
                              paper: {
                                sx: {
                                  width: '100%'
                                }
                              }
                            }}
                            sx={{ minWidth: 230 }}
                            renderOption={(props, optionsTags) => (
                              <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <i style={{ marginRight: '10px' }}>{optionsTags.icon}</i>
                                <Typography style={{ fontSize: '14px' }}>{optionsTags.label}</Typography>
                              </Box>
                            )}
                            renderInput={(params) => {
                              const selectedOption = optionsTags.find((opt) => opt.label === params.inputProps.value);
                              return (
                                <TextField
                                  {...params}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: selectedOption ? (
                                      <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                    ) : null,
                                  }}
                                  label="Tags"
                                  variant="outlined"
                                />
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='title-area'>
                      <h4>Sending pattern</h4>
                      <p>Specify how you want your emails to go</p>
                    </div>
                    <div className='option-box style-four'>
                      <div className='options-left'>
                        <h4>Time gap between emails</h4>
                      </div>
                      <div className='options-right'>
                        <div className='timing-group-filter'>
                          <Autocomplete
                            multiple
                            options={optionsTime}
                            getOptionLabel={(optionsTime) => optionsTime.label}
                            componentsProps={{
                              paper: {
                                sx: {
                                  width: '100%'
                                }
                              }
                            }}
                            sx={{ minWidth: 180 }}
                            renderOption={(props, optionsTime) => (
                              <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <i style={{ marginRight: '10px' }}>{optionsTime.icon}</i>
                                <Typography style={{ fontSize: '14px' }}>{optionsTime.label}</Typography>
                              </Box>
                            )}
                            renderInput={(params) => {
                              const selectedOption = optionsTime.find((opt) => opt.label === params.inputProps.value);
                              return (
                                <TextField
                                  {...params}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: selectedOption ? (
                                      <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                    ) : null,
                                  }}
                                  label="Minimum time"
                                  variant="outlined"
                                />
                              );
                            }}
                          />
                          <p>minutes</p>
                        </div>

                        <div className='timing-group-filter'>
                          <Autocomplete
                            multiple
                            options={optionsTime}
                            getOptionLabel={(optionsTime) => optionsTime.label}
                            componentsProps={{
                              paper: {
                                sx: {
                                  width: '100%'
                                }
                              }
                            }}
                            sx={{ minWidth: 200 }}
                            renderOption={(props, optionsTime) => (
                              <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <i style={{ marginRight: '10px' }}>{optionsTime.icon}</i>
                                <Typography style={{ fontSize: '14px' }}>{optionsTime.label}</Typography>
                              </Box>
                            )}
                            renderInput={(params) => {
                              const selectedOption = optionsTime.find((opt) => opt.label === params.inputProps.value);
                              return (
                                <TextField
                                  {...params}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: selectedOption ? (
                                      <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                    ) : null,
                                  }}
                                  label="Random additional time"
                                  variant="outlined"
                                />
                              );
                            }}
                          />
                          <p>minutes</p>
                        </div>
                      </div>
                    </div>

                    <div className='option-box style-two'>
                      <div className='options-left'>
                        <h4>Time gap between emails</h4>
                      </div>
                      <div className='options-right'>
                        <div className='add-class-area'>
                          <TextField
                            fullWidth
                            hiddenLabel
                            placeholder="Daily Limit"
                            variant="standard"
                            size="small"
                            // value={editState?.type || agentData?.type || ''}
                            // onChange={handleEditChange}
                            name='No limit'
                          />
                          <p>per day</p>
                        </div>
                      </div>
                    </div>

                    <div className='option-box'>
                      <div className='options-left'>
                        <h4>Prioritize new contacts</h4>
                      </div>
                      <div className='options-right'>
                        <label>
                          <Checkbox />
                          Prioritize reaching out to new contacts over scheduled follow-ups
                        </label>
                      </div>
                    </div>

                    <div className='option-box style-four'>
                      <div className='options-left'>
                        <h4>Auto optimize A/Z testing</h4>
                        <p>When using A/Z testing, the Sales AI algorithm will automatically select the best performing variant after a certain number of emails have been sent.</p>
                      </div>
                      <div className='options-right style-two'>
                        <div className='timing-group-filter'>
                          <p>Choose winning metric</p>
                          <Autocomplete
                            multiple
                            options={optionsRate}
                            getOptionLabel={(optionsRate) => optionsRate.label}
                            componentsProps={{
                              paper: {
                                sx: {
                                  width: '100%'
                                }
                              }
                            }}
                            sx={{ minWidth: 180 }}
                            renderOption={(props, optionsRate) => (
                              <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <i style={{ marginRight: '10px' }}>{optionsRate.icon}</i>
                                <Typography style={{ fontSize: '14px' }}>{optionsRate.label}</Typography>
                              </Box>
                            )}
                            renderInput={(params) => {
                              const selectedOption = optionsRate.find((opt) => opt.label === params.inputProps.value);
                              return (
                                <TextField
                                  {...params}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: selectedOption ? (
                                      <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                    ) : null,
                                  }}
                                  label="Select..."
                                  variant="outlined"
                                />
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>


                    <div className='option-box style-five'>
                      <div className='options-left'>
                        <h4>Provider Matching</h4>
                        <p>Matches your contact's email provider with your mailbox provider for boosted deliverability. (Outlook to Outlook, Google to Google, etc.)Configure custom rules for email sending based on email service providers</p>

                        <h4 className='mt-4'>ESP Routing</h4>
                        <p>Create rules to control email sending based on sender and recipient email service providers</p>
                        <button className='btn-style-border'>
                          + Add custom rule
                        </button>
                      </div>
                      <div className='options-right'>
                        <label>
                          <Checkbox />
                          Enable provider matching for deliverability boost
                        </label>
                      </div>
                    </div>

                    <div className='option-box style-five'>
                      <div className='options-left'>
                        <h4>Stop campaign for company on reply</h4>
                        <p>Stops the campaign automatically for all contacts from a company if a reply is received from any of them.</p>
                      </div>
                      <div className='options-right'>
                        <label>
                          <Checkbox />
                          Enable company reply stop
                        </label>
                      </div>
                    </div>

                    <div className='option-box style-five'>
                      <div className='options-left'>
                        <h4>Stop sending emails on Auto-reply</h4>
                        <p>Stop sending emails to a contact if an automatic response has been received, for example for out-of-office replies.</p>
                      </div>
                      <div className='options-right'>
                        <label>
                          <Checkbox />
                          Stop on auto-reply
                        </label>
                      </div>
                    </div>

                    <div className='option-box style-five'>
                      <div className='options-left'>
                        <h4>Insert unsubscribe link header</h4>
                        <p>Automatically adds an unsubscribe link to email headers for one-click unsubscription by supported email providers</p>
                      </div>
                      <div className='options-right'>
                        <label>
                          <Checkbox />
                          Insert unsubscribe link header
                        </label>
                      </div>
                    </div>

                    <div className='option-box style-five'>
                      <div className='options-left'>
                        <h4>Allow risky emails</h4>
                        <p>When using verification, allow emails that are marked as risky to be contacted; or disable BounceProtect to allow known risky emails to be contacted.</p>
                      </div>
                      <div className='options-right'>
                        <label>
                          <Checkbox />
                          Enable risky emails
                        </label>
                        <label>
                          <Checkbox />
                          Disable BonuceProtect
                        </label>
                      </div>
                    </div>
                    <div className='title-area'>
                      <h4>CC and BCC</h4>
                      <p>Add cc and bcc recipients to your emails.</p>
                    </div>
                    <div className='option-box style-five'>
                      <div className='options-left'>
                        <h4>CC</h4>
                        <p>Send a copy of the email to the addresses listed in the field</p>
                      </div>
                      <div className='options-right'>
                        <div className='add-class-area'>
                          <TextField
                            fullWidth
                            multiline
                            rows={4}
                            hiddenLabel
                            placeholder="Separate email with a comma"
                            variant="standard"
                            size="small"
                            // value={editState?.type || agentData?.type || ''}
                            // onChange={handleEditChange}
                            name='Message'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='option-box style-five'>
                      <div className='options-left'>
                        <h4>BCC</h4>
                        <p>Send a copy of the email to certain recipients without the other recipents knowing about it</p>
                      </div>
                      <div className='options-right'>
                        <div className='add-class-area'>
                          <TextField
                            fullWidth
                            multiline
                            rows={4}
                            hiddenLabel
                            placeholder="Separate email with a comma"
                            variant="standard"
                            size="small"
                            // value={editState?.type || agentData?.type || ''}
                            // onChange={handleEditChange}
                            name='Message'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }


                <div className='btn-area text-center'>
                  <button className='btn-style-border'>Save</button>
                  <button className='btn-style-new'>Launch</button>
                </div>
              </div>
            </div>
          </TabPanel>
        </div>
      </div>

      {/* All statuses filters modal */}
      <Modal isOpen={modalAllStatusesFiltters} modalClassName="right" className={`main-modal right right-side-modal style-two`}>
        <ModalHeader toggle={toggleAllFilters}></ModalHeader>
        <ModalBody>
          <div className='wramup-content'>
            <div className='top-area'>
              <h4>Filters</h4>
            </div>

            <div className='contacts-group-filter'>
              <Autocomplete
                options={optionscontacts}
                getOptionLabel={(optionscontacts) => optionscontacts.label}
                componentsProps={{
                  paper: {
                    sx: {
                      width: '100%'
                    }
                  }
                }}
                sx={{ minWidth: 130 }}
                renderOption={(props, optionscontacts) => (
                  <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <i style={{ marginRight: '10px' }}>{optionscontacts.icon}</i>
                    <Typography style={{ fontSize: '14px' }}>{optionscontacts.label}</Typography>
                  </Box>
                )}
                renderInput={(params) => {
                  const selectedOption = optionscontacts.find((opt) => opt.label === params.inputProps.value);
                  return (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: selectedOption ? (
                          <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                        ) : null,
                      }}
                      label="Contact Straus"
                      variant="outlined"
                    />
                  );
                }}
              />
            </div>

            <div className='contacts-group-filter'>
              <Autocomplete
                options={optionscontactOwner}
                getOptionLabel={(optionscontactOwner) => optionscontactOwner.label}
                componentsProps={{
                  paper: {
                    sx: {
                      width: '100%'
                    }
                  }
                }}
                sx={{ minWidth: 130 }}
                renderOption={(props, optionscontactOwner) => (
                  <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <i style={{ marginRight: '10px' }}>{optionscontactOwner.icon}</i>
                    <Typography style={{ fontSize: '14px' }}>{optionscontactOwner.label}</Typography>
                  </Box>
                )}
                renderInput={(params) => {
                  const selectedOption = optionscontactOwner.find((opt) => opt.label === params.inputProps.value);
                  return (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: selectedOption ? (
                          <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                        ) : null,
                      }}
                      label="Contact Owner"
                      variant="outlined"
                    />
                  );
                }}
              />
            </div>

            <div className='contacts-group-filter'>
              <Autocomplete
                options={optionscontactESP}
                getOptionLabel={(optionscontactESP) => optionscontactESP.label}
                componentsProps={{
                  paper: {
                    sx: {
                      width: '100%'
                    }
                  }
                }}
                sx={{ minWidth: 130 }}
                renderOption={(props, optionscontactESP) => (
                  <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <i style={{ marginRight: '10px' }}>{optionscontactESP.icon}</i>
                    <Typography style={{ fontSize: '14px' }}>{optionscontactESP.label}</Typography>
                  </Box>
                )}
                renderInput={(params) => {
                  const selectedOption = optionscontactESP.find((opt) => opt.label === params.inputProps.value);
                  return (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: selectedOption ? (
                          <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                        ) : null,
                      }}
                      label="Contact ESP"
                      variant="outlined"
                    />
                  );
                }}
              />
            </div>

            <div className='contacts-group-filter'>
              {isVisiblecontactsFilter
                ? <>
                  <h4>Conditions</h4>
                  <p>Add conditions filter the contacts</p>
                  <div className='conditions-area'>
                    <div className='contacts-select-filtes'>
                      <div className='contacts-group-filter'>
                        <Autocomplete
                          options={optionscontactsSelectFilters}
                          getOptionLabel={(optionscontactsSelectFilters) => optionscontactsSelectFilters.label}
                          componentsProps={{
                            paper: {
                              sx: {
                                width: '100%'
                              }
                            }
                          }}
                          sx={{ minWidth: 130 }}
                          renderOption={(props, optionscontactsSelectFilters) => (
                            <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <i style={{ marginRight: '10px' }}>{optionscontactsSelectFilters.icon}</i>
                              <Typography style={{ fontSize: '14px' }}>{optionscontactsSelectFilters.label}</Typography>
                            </Box>
                          )}
                          renderInput={(params) => {
                            const selectedOption = optionscontactsSelectFilters.find((opt) => opt.label === params.inputProps.value);
                            return (
                              <TextField
                                {...params}
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: selectedOption ? (
                                    <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                  ) : null,
                                }}
                                label="Contact Straus"
                                variant="outlined"
                              />
                            );
                          }}
                        />
                      </div>
                      <button className='close-btn' onClick={() => setIsVisiblecontactsFilter(false)}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8" cy="8" r="7.5" fill="white" stroke="#FF4F4F" />
                          <path d="M11.5 4.5L4.5 11.5" stroke="#FF4F4F" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.5 4.5L11.5 11.5" stroke="#FF4F4F" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </button>

                    </div>
                    <div className='conditions-btn-area'>
                      <button className='conditions-btn' onClick={() => setIsVisiblecontactsFilter(true)}>+ Add Condition</button>
                    </div>
                  </div>
                </>
                : <>
                  <h4>Conditions</h4>
                  <p>Add conditions filter the contacts</p>
                  <div className='conditions-area'>
                    <div className='conditions-btn-area'>
                      <button className='conditions-btn' onClick={() => setIsVisiblecontactsFilter(!isVisiblecontactsFilter)}>+ Add Condition</button>
                    </div>
                  </div>
                </>
              }

            </div>

          </div>
        </ModalBody>
      </Modal>

      {/* AI Prompts modal */}
      <Modal isOpen={modalAIPromptsModal} modalClassName="right" className={`main-modal right right-side-modal style-two`}>
        <ModalHeader toggle={toggleAIPrompts}></ModalHeader>
        <ModalBody>
          <div className='wramup-content'>
            <div className='top-area'>
              <h4>AI Prompts</h4>
            </div>
            <div className='tabs-box'>
              <div className='tabs-email'>
                <AppBar position="static">
                  <Tabs value={valueAiPromptsTab} onChange={handleAiPromptsTabsSet} aria-label="simple tabs example">
                    <Tab label="Template Hub" />
                    <Tab label="My Template " />
                    <Tab label="Settings " />
                  </Tabs>
                </AppBar>

              </div>
            </div>
            <div className='tabs-content'>
              <TabPanel value={valueAiPromptsTab} index={0}>
                <div className='ai-prompts-inner'>
                  {isVisibleCompanyBox
                    ? <div className='company-name-area'>
                      <div className='company-name-detail'>
                        <h4>
                          <button className='back-btn' onClick={() => setIsVisibleCompanyBox(false)}><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 13L1 7L7 1" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /></svg></button>
                          Company Name Cleanup
                        </h4>
                        <p>This is a prompt to clean up all company names to prepare them for outreach and reference.</p>

                        <div className='searchbox'>
                          <p>Put your company name here.</p>
                          <TextField
                            fullWidth
                            hiddenLabel
                            placeholder='Company name'
                            variant="standard"
                            size="small"
                            // value={editState?.type || agentData?.type || ''}
                            // onChange={handleEditChange}
                            name='Companyname'
                          />
                        </div>
                        <div className='contacts-group-filter'>
                          <p>Output Column</p>
                          <Autocomplete
                            options={optionsSelectType}
                            getOptionLabel={(optionsSelectType) => optionsSelectType.label}
                            componentsProps={{
                              paper: {
                                sx: {
                                  width: '100%'
                                }
                              }
                            }}
                            sx={{ minWidth: 130 }}
                            renderOption={(props, optionsSelectType) => (
                              <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <i style={{ marginRight: '10px' }}>{optionsSelectType.icon}</i>
                                <Typography style={{ fontSize: '14px' }}>{optionsSelectType.label}</Typography>
                              </Box>
                            )}
                            renderInput={(params) => {
                              const selectedOption = optionsSelectType.find((opt) => opt.label === params.inputProps.value);
                              return (
                                <TextField
                                  {...params}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: selectedOption ? (
                                      <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                    ) : null,
                                  }}
                                  label="Select..."
                                  variant="outlined"
                                />
                              );
                            }}
                          />
                        </div>
                        <div className='checkbox-grop'>
                          <label>
                            <Checkbox />
                            Overwrite output rows if they already exists
                          </label>
                        </div>
                        <div className='btn-group'>
                          <button className='btn-style-border'>Generate test output</button>
                          <button className='btn-style-new'>Generate For All Contacts</button>
                        </div>
                      </div>
                    </div>
                    : <>
                      <div className='top-area-search'>
                        <div className='searchbox'>
                          <button className='icon'>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_224_579)">
                                <path d="M17.8568 16.2345L13.203 11.5807C14.0782 10.377 14.5958 8.8965 14.5958 7.2975C14.5958 3.27375 11.322 0 7.2975 0C3.27375 0 0 3.27375 0 7.2975C0 11.322 3.27375 14.595 7.2975 14.595C8.823 14.595 10.2397 14.1247 11.4128 13.3215L16.0912 18L17.8568 16.2345ZM2.1405 7.2975C2.1405 4.4535 4.45425 2.13975 7.29825 2.13975C10.1423 2.13975 12.456 4.4535 12.456 7.2975C12.456 10.1415 10.1423 12.4552 7.29825 12.4552C4.4535 12.4552 2.1405 10.1415 2.1405 7.2975Z" fill="#89868D" />
                              </g>
                              <defs>
                                <clipPath id="clip0_224_579">
                                  <rect width="18" height="18" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </button>
                          <TextField
                            fullWidth
                            hiddenLabel
                            placeholder='Search...'
                            variant="standard"
                            size="small"
                            // value={editState?.type || agentData?.type || ''}
                            // onChange={handleEditChange}
                            name='search'
                          />
                          <div className='popularity-btn-area'>
                            <button className='setting-btn' onClick={handleOpen}>
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_412_5135)">
                                  <path d="M14.4001 9H3.6001" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M17.0999 5.3999H0.899902" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M11.7 12.6001H6.30005" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_412_5135">
                                    <rect width="18" height="18" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </button>
                            <Menu className='popularity-dropdown' anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                              <MenuItem>
                                Categories
                              </MenuItem>
                              {filteredItems.map((item) => (
                                <MenuItem key={item} onClick={() => handleToggle(item)}>
                                  <ListItemIcon>
                                    <Checkbox
                                      checked={checkedItems[item]}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary={item} />
                                </MenuItem>
                              ))}
                            </Menu>
                          </div>
                        </div>
                        <div className='popularity-btn-area-right'>
                          <button className='setting-btn' onClick={handleOpenPopularity}>
                            Popularity
                            <i className='icon'>
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.5917 12.3584L14.1251 8.82507C14.2032 8.74761 14.2652 8.65544 14.3075 8.55389C14.3498 8.45234 14.3716 8.34342 14.3716 8.23341C14.3716 8.1234 14.3498 8.01448 14.3075 7.91293C14.2652 7.81138 14.2032 7.71921 14.1251 7.64174C13.9689 7.48653 13.7577 7.39941 13.5376 7.39941C13.3174 7.39941 13.1062 7.48653 12.9501 7.64174L10.0001 10.5917L7.05008 7.64174C6.89395 7.48653 6.68274 7.39941 6.46258 7.39941C6.24243 7.39941 6.03122 7.48653 5.87508 7.64174C5.79785 7.71961 5.73674 7.81195 5.69527 7.91349C5.6538 8.01502 5.63278 8.12374 5.63342 8.23341C5.63278 8.34308 5.6538 8.4518 5.69527 8.55333C5.73674 8.65486 5.79785 8.74721 5.87508 8.82507L9.40842 12.3584C9.48589 12.4365 9.57805 12.4985 9.6796 12.5408C9.78115 12.5831 9.89007 12.6049 10.0001 12.6049C10.1101 12.6049 10.219 12.5831 10.3206 12.5408C10.4221 12.4985 10.5143 12.4365 10.5917 12.3584Z" fill="#242424" />
                              </svg>
                            </i>
                          </button>

                          <Menu className='popularity-dropdown' anchorEl={anchorPopularity} open={Boolean(anchorPopularity)} onClose={handleClosePopularity}>
                            {filteredItemsPopularity.map((item) => (
                              <MenuItem key={item} onClick={() => handleTogglePopularity(item)}>
                                <ListItemText primary={item} />
                              </MenuItem>
                            ))}
                          </Menu>
                        </div>
                      </div>
                      <div className='company-name-area'>
                        <div className='company-name-inner'>
                          <div className='company-name-box' onClick={() => setIsVisibleCompanyBox(true)}>
                            <h4>Company Name Cleanup</h4>
                            <p>This is a prompt to clean up all company names to prepare them for outreach and reference.</p>
                            <ul className='tag-company'>
                              <li>34,098,167 runs</li>
                              <li>Cleaning</li>
                            </ul>
                            <div className='bottom-area'>
                              <i className='name-word'>T</i>
                              Timothy Wenger
                            </div>
                          </div>
                          <div className='company-name-box' onClick={() => setIsVisibleCompanyBox(true)}>
                            <h4>Company Name Cleanup</h4>
                            <p>This is a prompt to clean up all company names to prepare them for outreach and reference.</p>
                            <ul className='tag-company'>
                              <li>34,098,167 runs</li>
                              <li>Cleaning</li>
                            </ul>
                            <div className='bottom-area'>
                              <i className='name-word'>T</i>
                              Timothy Wenger
                            </div>
                          </div>
                          <div className='company-name-box' onClick={() => setIsVisibleCompanyBox(true)}>
                            <h4>Company Name Cleanup</h4>
                            <p>This is a prompt to clean up all company names to prepare them for outreach and reference.</p>
                            <ul className='tag-company'>
                              <li>34,098,167 runs</li>
                              <li>Cleaning</li>
                            </ul>
                            <div className='bottom-area'>
                              <i className='name-word'>T</i>
                              Timothy Wenger
                            </div>
                          </div>
                          <div className='company-name-box' onClick={() => setIsVisibleCompanyBox(true)}>
                            <h4>Company Name Cleanup</h4>
                            <p>This is a prompt to clean up all company names to prepare them for outreach and reference.</p>
                            <ul className='tag-company'>
                              <li>34,098,167 runs</li>
                              <li>Cleaning</li>
                            </ul>
                            <div className='bottom-area'>
                              <i className='name-word'>T</i>
                              Timothy Wenger
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </div>
              </TabPanel>

              <TabPanel value={valueAiPromptsTab} index={1}>
                <div className='ai-prompts-inner'>
                  {isVisibleCompanyTemplate
                    ? <div className='company-name-area'>
                      <div className='company-name-detail'>
                        <h4>
                          <button className='back-btn' onClick={() => setIsVisibleCompanyTemplate(false)}><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 13L1 7L7 1" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /></svg></button>
                          Waqar | Company personalization
                        </h4>
                        <p>Company name test</p>

                        <div className='contacts-group-filter style-two'>
                          <p>company test</p>
                          <Autocomplete
                            options={optionsSelectType}
                            getOptionLabel={(optionsSelectType) => optionsSelectType.label}
                            componentsProps={{
                              paper: {
                                sx: {
                                  width: '100%'
                                }
                              }
                            }}
                            sx={{ minWidth: 130 }}
                            renderOption={(props, optionsSelectType) => (
                              <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <i style={{ marginRight: '10px' }}>{optionsSelectType.icon}</i>
                                <Typography style={{ fontSize: '14px' }}>{optionsSelectType.label}</Typography>
                              </Box>
                            )}
                            renderInput={(params) => {
                              const selectedOption = optionsSelectType.find((opt) => opt.label === params.inputProps.value);
                              return (
                                <TextField
                                  {...params}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: selectedOption ? (
                                      <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                    ) : null,
                                  }}
                                  label="Select..."
                                  variant="outlined"
                                />
                              );
                            }}
                          />
                        </div>

                        <div className='contacts-group-filter'>
                          <p>Output Column</p>
                          <Autocomplete
                            options={optionsSelectType}
                            getOptionLabel={(optionsSelectType) => optionsSelectType.label}
                            componentsProps={{
                              paper: {
                                sx: {
                                  width: '100%'
                                }
                              }
                            }}
                            sx={{ minWidth: 130 }}
                            renderOption={(props, optionsSelectType) => (
                              <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <i style={{ marginRight: '10px' }}>{optionsSelectType.icon}</i>
                                <Typography style={{ fontSize: '14px' }}>{optionsSelectType.label}</Typography>
                              </Box>
                            )}
                            renderInput={(params) => {
                              const selectedOption = optionsSelectType.find((opt) => opt.label === params.inputProps.value);
                              return (
                                <TextField
                                  {...params}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: selectedOption ? (
                                      <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                                    ) : null,
                                  }}
                                  label="Select..."
                                  variant="outlined"
                                />
                              );
                            }}
                          />
                        </div>
                        <div className='checkbox-grop'>
                          <label>
                            <Checkbox />
                            Overwrite output rows if they already exists
                          </label>
                        </div>
                        <div className='btn-group'>
                          <button className='btn-style-border'>Generate test output</button>
                          <button className='btn-style-new'>Generate For All Contacts</button>
                        </div>
                      </div>
                    </div>
                    : <>
                      <div className='create-prompt'>
                        <button className='prompt-btn' onClick={() => setIsVisibleCompanyTemplate(true)}>
                          <i className='icon'>
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M17.5 2.99981C17.7626 2.73717 18.0744 2.52883 18.4176 2.38669C18.7608 2.24455 19.1286 2.17139 19.5 2.17139C19.8714 2.17139 20.2392 2.24455 20.5824 2.38669C20.9256 2.52883 21.2374 2.73717 21.5 2.99981C21.7626 3.26246 21.971 3.57426 22.1131 3.91742C22.2553 4.26058 22.3284 4.62838 22.3284 4.99981C22.3284 5.37125 22.2553 5.73905 22.1131 6.08221C21.971 6.42537 21.7626 6.73717 21.5 6.99981L8 20.4998L2.5 21.9998L4 16.4998L17.5 2.99981Z" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </i>
                          Create new prompt
                        </button>
                        <button className='upload-area'>
                          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M26.25 18.75V23.75C26.25 24.413 25.9866 25.0489 25.5178 25.5178C25.0489 25.9866 24.413 26.25 23.75 26.25H6.25C5.58696 26.25 4.95107 25.9866 4.48223 25.5178C4.01339 25.0489 3.75 24.413 3.75 23.75V18.75" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M21.25 10L15 3.75L8.75 10" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15 3.75V18.75" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </button>
                      </div>
                      <div className='top-area-search style-two'>
                        <div className='searchbox'>
                          <button className='icon'>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_224_579)">
                                <path d="M17.8568 16.2345L13.203 11.5807C14.0782 10.377 14.5958 8.8965 14.5958 7.2975C14.5958 3.27375 11.322 0 7.2975 0C3.27375 0 0 3.27375 0 7.2975C0 11.322 3.27375 14.595 7.2975 14.595C8.823 14.595 10.2397 14.1247 11.4128 13.3215L16.0912 18L17.8568 16.2345ZM2.1405 7.2975C2.1405 4.4535 4.45425 2.13975 7.29825 2.13975C10.1423 2.13975 12.456 4.4535 12.456 7.2975C12.456 10.1415 10.1423 12.4552 7.29825 12.4552C4.4535 12.4552 2.1405 10.1415 2.1405 7.2975Z" fill="#89868D" />
                              </g>
                              <defs>
                                <clipPath id="clip0_224_579">
                                  <rect width="18" height="18" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </button>
                          <TextField
                            fullWidth
                            hiddenLabel
                            placeholder='Search...'
                            variant="standard"
                            size="small"
                            // value={editState?.type || agentData?.type || ''}
                            // onChange={handleEditChange}
                            name='search'
                          />
                          <div className='popularity-btn-area'>
                            <button className='setting-btn' onClick={handleOpen}>
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_412_5135)">
                                  <path d="M14.4001 9H3.6001" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M17.0999 5.3999H0.899902" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M11.7 12.6001H6.30005" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_412_5135">
                                    <rect width="18" height="18" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </button>
                            <Menu className='popularity-dropdown' anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                              <MenuItem>
                                Categories
                              </MenuItem>
                              {filteredItems.map((item) => (
                                <MenuItem key={item} onClick={() => handleToggle(item)}>
                                  <ListItemIcon>
                                    <Checkbox
                                      checked={checkedItems[item]}
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary={item} />
                                </MenuItem>
                              ))}
                            </Menu>
                          </div>
                        </div>
                      </div>
                      <div className='company-name-area'>
                        <div className='company-name-inner'>
                          <div className='company-name-box' onClick={() => setIsVisibleCompanyTemplate(true)}>
                            <h4>
                              Waqar | Company personalization
                              <button className='dots-btn'>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="var(--text-color)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="var(--text-color)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="var(--text-color)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </button>
                            </h4>
                            <p>Company name test</p>
                            <ul className='tag-company'>
                              <li>0 runs</li>
                              <li>Copywriting</li>
                            </ul>
                            <div className='bottom-area'>
                              <div className='left-area'>
                                <i className='name-word'>T</i>
                                Timothy Wenger
                              </div>
                              <button className='share-btn'>
                                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M18 7.5L11 0.5V4.5C4 5.5 1 10.5 0 15.5C2.5 12 6 10.4 11 10.4V14.5L18 7.5Z" fill="var(--text-color)" />
                                </svg>
                              </button>
                            </div>
                          </div>
                          <div className='company-name-box' onClick={() => setIsVisibleCompanyTemplate(true)}>
                            <h4>
                              Waqar | Company personalization
                              <button className='dots-btn'>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="var(--text-color)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="var(--text-color)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="var(--text-color)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </button>
                            </h4>
                            <p>Company name test</p>
                            <ul className='tag-company'>
                              <li>0 runs</li>
                              <li>Copywriting</li>
                            </ul>
                            <div className='bottom-area'>
                              <div className='left-area'>
                                <i className='name-word'>T</i>
                                Timothy Wenger
                              </div>
                              <button className='share-btn'>
                                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M18 7.5L11 0.5V4.5C4 5.5 1 10.5 0 15.5C2.5 12 6 10.4 11 10.4V14.5L18 7.5Z" fill="var(--text-color)" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </div>
              </TabPanel>

              <TabPanel value={valueAiPromptsTab} index={2}>
                <div className='ai-prompts-inner'>
                  <div className='top-area-search style-three'>
                    <div className='searchbox'>
                      <p>OpenAI API Key</p>
                      <TextField
                        fullWidth
                        hiddenLabel
                        placeholder='sk-...1BAz'
                        variant="standard"
                        size="small"
                        // value={editState?.type || agentData?.type || ''}
                        // onChange={handleEditChange}
                        name='api'
                      />
                    </div>
                  </div>
                  <div className='api-bottom'>
                    <p>you can find the API key <Link className="link-here">here</Link></p>
                    <button className='btn-style-new'>Save</button>
                  </div>

                </div>
              </TabPanel>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Contacts Detail modal */}
      <Modal isOpen={modalRightcontactsDetails} modalClassName="right" className={`main-modal right right-side-modal style-two`}>
        <ModalHeader toggle={toggleWarmup}></ModalHeader>
        <ModalBody>
          <div className='wramup-content'>
            <div className='top-area'>
              <h4><i className='name-word'>BN</i>billn@told.com</h4>
              <Autocomplete
                options={optionscontacts}
                getOptionLabel={(optionscontacts) => optionscontacts.label}
                componentsProps={{
                  paper: {
                    sx: {
                      width: 230
                    }
                  }
                }}
                sx={{ minWidth: 130 }}
                renderOption={(props, optionscontacts) => (
                  <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <i style={{ marginRight: '10px' }}>{optionscontacts.icon}</i>
                    <Typography style={{ fontSize: '14px' }}>{optionscontacts.label}</Typography>
                  </Box>
                )}
                renderInput={(params) => {
                  const selectedOption = optionscontacts.find((opt) => opt.label === params.inputProps.value);
                  return (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: selectedOption ? (
                          <i style={{ marginRight: '10px' }}>{selectedOption.icon}</i>
                        ) : null,
                      }}
                      label="Contact"
                      variant="outlined"
                    />
                  );
                }}
              />
            </div>
            <div className='tabs-box'>
              <div className='tabs-email'>
                <AppBar position="static">
                  <Tabs value={valuecontactDetails} onChange={handlecontactDetailsTabsSet} aria-label="simple tabs example">
                    <Tab label="Contact Details" />
                    <Tab label="Activates" />
                  </Tabs>
                </AppBar>

              </div>
            </div>
            <div className='tabs-content'>
              <TabPanel value={valuecontactDetails} index={0}>
                <div className='contact-tabs-inner'>
                  <div className='form-contacts'>
                    <div className='group-form'>
                      <TextField
                        fullWidth
                        variant="standard"
                        size="small"
                        // value={editState?.type || agentData?.type || ''}
                        // onChange={handleEditChange}
                        name='email'
                        label="Email"
                        style={{
                          backgroundColor: 'var(--sa-dark-surface-light)'
                        }}
                      />
                    </div>
                    <div className='group-form'>
                      <TextField
                        fullWidth
                        variant="standard"
                        size="small"
                        // value={editState?.type || agentData?.type || ''}
                        // onChange={handleEditChange}
                        name='FName'
                        label="First Name"
                        style={{
                          backgroundColor: 'var(--sa-dark-surface-light)'
                        }}
                      />
                    </div>
                    <div className='group-form'>
                      <TextField
                        fullWidth
                        variant="standard"
                        size="small"
                        // value={editState?.type || agentData?.type || ''}
                        // onChange={handleEditChange}
                        name='LName'
                        label="Last Name"
                        style={{
                          backgroundColor: 'var(--sa-dark-surface-light)'
                        }}
                      />
                    </div>
                    <div className='group-form'>
                      <TextField
                        fullWidth
                        variant="standard"
                        size="small"
                        // value={editState?.type || agentData?.type || ''}
                        // onChange={handleEditChange}
                        name='CName'
                        label="Company Name"
                        style={{
                          backgroundColor: 'var(--sa-dark-surface-light)'
                        }}
                      />
                    </div>
                    <div className='group-form'>
                      <TextField
                        fullWidth
                        variant="standard"
                        size="small"
                        // value={editState?.type || agentData?.type || ''}
                        // onChange={handleEditChange}
                        name='JobTitle'
                        label="Job Title"
                        style={{
                          backgroundColor: 'var(--sa-dark-surface-light)'
                        }}
                      />
                    </div>
                    <div className='group-form'>
                      <TextField
                        fullWidth
                        variant="standard"
                        size="small"
                        // value={editState?.type || agentData?.type || ''}
                        // onChange={handleEditChange}
                        name='JobTitle'
                        label="Valid Status"
                        style={{
                          backgroundColor: 'var(--sa-dark-surface-light)'
                        }}
                      />
                    </div>

                    <div className='group-form'>
                      <TextField
                        fullWidth
                        variant="standard"
                        size="small"
                        // value={editState?.type || agentData?.type || ''}
                        // onChange={handleEditChange}
                        name='ValidStatus'
                        label="Valid Status"
                        style={{
                          backgroundColor: 'var(--sa-dark-surface-light)'
                        }}
                      />
                    </div>

                    <div className='group-form'>
                      <Autocomplete
                        options={optionsCampaign}
                        className='tags-select'
                        getOptionLabel={(optionsCampaign) => optionsCampaign.label}
                        componentsProps={{
                          paper: {
                            sx: {
                              width: 300
                            }
                          }
                        }}
                        sx={{ minWidth: 300 }}
                        renderOption={(props, optionsCampaign) => (
                          <Box component="li" {...props} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <i style={{ marginRight: '10px' }}>{optionsCampaign.icon}</i>
                            <Typography style={{ fontSize: '14px' }}>{optionsCampaign.label}</Typography>
                          </Box>
                        )}
                        renderInput={(params) => {
                          const selectedOption = optionsCampaign.find((opt) => opt.label === params.inputProps.value);
                          return (
                            <TextField
                              {...params}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: selectedOption ? (
                                  <i style={{ marginRight: '5px' }}>{selectedOption.icon}</i>
                                ) : null,
                              }}
                              label="List Category"
                              variant="outlined"
                            />
                          );
                        }}
                      />
                    </div>
                    <div className='group-form text-right'>
                      <button className='btn-style-new'>Save</button>
                    </div>
                  </div>
                </div>
              </TabPanel>

              <TabPanel value={valuecontactDetails} index={1}>
                <div className='contact-tabs-inner'>
                  <div className='activates-inner'>
                    <div className="table-container">
                      <ReactTable
                        width='100'
                        className='table campaign-table responsive contacts-campaign-table'
                        minRows={6}
                        columns={columns}
                        filterable={false}
                        // data={contactsData}
                        data={Array.isArray(allCampaign) ? allCampaign : []}
                      />
                    </div>
                  </div>
                </div>
              </TabPanel>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* --------------- Add New Account--------------- */}
      <Modal isOpen={modalAddNew} toggle={toggcontactdNew} className={`main-modal new-user-modal modal-dialog-centered`}>
        <ModalHeader toggle={toggcontactdNew}></ModalHeader>
        <ModalBody>
          <div className='add-content'>
            <h2>Add Campaign</h2>
            <div className='tabs-domain'>

              <div className='tabs-content'>
                <div className='tabs-domain-area'>
                  <div className='group-form'>
                    <TextField
                      fullWidth
                      variant="standard"
                      size="small"
                      // value={editState?.type || agentData?.type || ''}
                      // onChange={handleEditChange}
                      name='type'
                      label="Add Campaign Name"
                      style={{ backgroundColor: 'var(--sa-dark-surface-light)' }}
                    />
                  </div>

                  <div className='group-form'>
                    <button className='btn-style-new'>Add</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Add Call modal */}
      <Modal isOpen={modalAddCall} modalClassName="right" className={`main-modal right right-side-modal style-two`}>
        <ModalHeader toggle={toggcontactdCall}></ModalHeader>
        <ModalBody>
          <div className='wramup-content'>
            <div className='top-area'>
              <h4>Add SMS</h4>
            </div>
            <div className='tabs-content'>
              <div className='ai-prompts-inner'>
                <div className='add-class-area'>
                  <p>Message Editor</p>
                  <p className='msg-editor'>Personalization Tags (FirstName, Company)</p>
                  <button className='send-msg'>Send Test Message</button>
                </div>

                <div className='add-class-area'>
                  <p>From</p>
                  <TextField
                    fullWidth
                    hiddenLabel
                    placeholder="Sales AI"
                    variant="standard"
                    size="small"
                    // value={editState?.type || agentData?.type || ''}
                    // onChange={handleEditChange}
                    name='search'
                  />
                </div>

                <div className='add-class-area'>
                  <p>Message</p>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    hiddenLabel
                    placeholder="Hi (FirstName) I’m wih Sales AI We’re Offering a 10% discount on all products for a limited time. Use code SUMMER10 at checkout."
                    variant="standard"
                    size="small"
                    // value={editState?.type || agentData?.type || ''}
                    // onChange={handleEditChange}
                    name='Message'
                  />
                </div>

                <div className='add-class-area'>
                  <p>Personalization</p>
                  <label>
                    <Checkbox />
                    First Name
                  </label>
                  <label>
                    <Checkbox />
                    Company Name
                  </label>
                </div>

                <div className='add-class-area'>
                  <p>Scheduling</p>
                  <ToggleButtonGroup
                    value={voice}
                    exclusive
                    onChange={handleChange}
                    aria-label="voice selection"
                  >
                    <ToggleButton value="SendImmediately">Send Immediately</ToggleButton>
                    <ToggleButton value="Sendafter">Send after</ToggleButton>
                  </ToggleButtonGroup>
                </div>

                <div className='step-footer'>
                  <div className='step-footer-box'>
                    <p>Send next message in </p>
                    <TextField
                      fullWidth
                      hiddenLabel
                      placeholder='Days'
                      variant="standard"
                      size="small"
                      // value={editState?.type || agentData?.type || ''}
                      // onChange={handleEditChange}
                      name='days'
                    />
                    <p>Days</p>
                  </div>
                </div>
                <div className='btn-group-add text-right mt-4'>
                  <button className='btn-style-cancel'>Cancel</button>
                  <button className='btn-style-new'>Save</button>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Add Sms modal */}
      <Modal isOpen={modalAddSms} modalClassName="right" className={`main-modal right right-side-modal style-two`}>
        <ModalHeader toggle={toggcontactdSms}></ModalHeader>
        <ModalBody>
          <div className='wramup-content'>
            <div className='top-area'>
              <h4>Add Call</h4>
            </div>
            <div className='tabs-content'>
              <div className='ai-prompts-inner'>
                <div className='add-class-area'>
                  <p>Add Call</p>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    hiddenLabel
                    placeholder="Hi [First Name]! I'm a member of the Sales AI team. I'd love to chat about your experience with our product and how we can make it better for you. Let me know if you're available to chat this week."
                    variant="standard"
                    size="small"
                    // value={editState?.type || agentData?.type || ''}
                    // onChange={handleEditChange}
                    name='search'
                  />
                </div>

                <div className='add-class-area'>
                  <p>Script</p>
                  <ul className='tag-list'>
                    <li>Intro</li>
                    <li>Status</li>
                    <li>Follow-up</li>
                    <li>Qualification</li>
                    <li>Demo</li>
                    <li>Feedback</li>
                    <li>Custom Script</li>
                  </ul>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    hiddenLabel
                    placeholder="Write your custom script..."
                    variant="standard"
                    size="small"
                    // value={editState?.type || agentData?.type || ''}
                    // onChange={handleEditChange}
                    name='search'
                  />
                </div>

                <div className='add-class-area'>
                  <p>Voice</p>
                  <ToggleButtonGroup
                    value={voice}
                    exclusive
                    onChange={handleChange}
                    aria-label="voice selection"
                  >
                    <ToggleButton value="female">Female</ToggleButton>
                    <ToggleButton value="male">Male</ToggleButton>
                  </ToggleButtonGroup>
                </div>
                <div className='add-class-area'>
                  <p>Tone</p>
                  <ToggleButtonGroup
                    value={tone}
                    exclusive
                    onChange={handleChangeTone}
                    aria-label="voice selection"
                  >
                    <ToggleButton value="Empathetic">Empathetic</ToggleButton>
                    <ToggleButton value="Professional">Professional</ToggleButton>
                    <ToggleButton value="Conversational">Conversational</ToggleButton>
                  </ToggleButtonGroup>
                </div>

                <div className='add-class-area'>
                  <p>Call Type</p>
                  <ToggleButtonGroup
                    value={callType}
                    exclusive
                    onChange={handleChangeType}
                    aria-label="voice selection"
                  >
                    <ToggleButton value="Follow-up">Follow-up</ToggleButton>
                    <ToggleButton value="Qualification">Qualification</ToggleButton>
                    <ToggleButton value="Demo">Demo</ToggleButton>
                    <ToggleButton value="Feedback">Feedback</ToggleButton>
                    <ToggleButton value="Other">Other</ToggleButton>
                  </ToggleButtonGroup>
                </div>
                <div className='add-class-area'>
                  <p>Summary</p>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    hiddenLabel
                    placeholder=""
                    variant="standard"
                    size="small"
                    // value={editState?.type || agentData?.type || ''}
                    // onChange={handleEditChange}
                    name='summary'
                  />
                </div>
                <div className='add-class-area'>
                  <p>Logs</p>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    hiddenLabel
                    placeholder=""
                    variant="standard"
                    size="small"
                    // value={editState?.type || agentData?.type || ''}
                    // onChange={handleEditChange}
                    name='logs'
                  />
                </div>
                <div className='btn-group-add text-right'>
                  <button className='btn-style-cancel'>Cancel</button>
                  <button className='btn-style-new'>Add</button>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}


export default Campaign